"use strict";

globalThis.hologram.pageReachableFunctionDefs = (deps) => {
	const {
		Bitstring,
		HologramBoxedError,
		HologramInterpreterError,
		Interpreter,
		MemoryStorage,
		Type,
		Utils,
	} = deps;

	Interpreter.defineNotImplementedErlangFunction("application", "get_env", 3);

	Interpreter.defineNotImplementedErlangFunction("elixir_config", "warn", 2);

	Interpreter.defineErlangFunction("maps", "remove", 2, (key, map) => {
		if (!Type.isMap(map)) {
			Interpreter.raiseBadMapError(map);
		}

		const newMap = Utils.shallowCloneObject(map);
		delete newMap.data[Type.encodeMapKey(key)];

		return newMap;
	});

	Interpreter.defineNotImplementedErlangFunction("persistent_term", "get", 1);

	Interpreter.defineElixirFunction("Access", "get_and_update", 3, "public", [
		{
			params: (context) => [
				Interpreter.matchOperator(
					Type.variablePattern("container_0"),
					Type.map([
						[Type.atom("__struct__"), Type.variablePattern("module_1")],
					]),
					context,
				),
				Type.variablePattern("key_2"),
				Type.variablePattern("fun_3"),
			],
			guards: [],
			body: (context) => {
				globalThis.hologram.return = Interpreter.try(
					(context) => {
						return Interpreter.callNamedFunction(
							context.vars.module_1,
							Type.atom("get_and_update"),
							Type.list([
								context.vars.container_0,
								context.vars.key_2,
								context.vars.fun_3,
							]),
							context,
						);
					},
					[
						{
							variable: Type.variablePattern("exception_4"),
							modules: [Type.atom("Elixir.UndefinedFunctionError")],
							body: (context) => {
								Interpreter.matchOperator(
									Interpreter.case(
										Type.matchPlaceholder(),
										[
											{
												match: Type.consPattern(
													Type.tuple([
														context.vars.module_1,
														Type.atom("get_and_update"),
														Type.list([
															context.vars.container_0,
															context.vars.key_2,
															context.vars.fun_3,
														]),
														Type.matchPlaceholder(),
													]),
													Type.matchPlaceholder(),
												),
												guards: [],
												body: (context) => {
													Interpreter.matchOperator(
														Type.bitstring([
															Type.bitstringSegment(
																Elixir_Kernel["inspect/1"](
																	context.vars.module_1,
																),
																{ type: "binary" },
															),
															Type.bitstringSegment(
																Type.string(
																	' does not implement the Access behaviour\n\nYou can use the "struct.field" syntax to access struct fields. You can also use Access.key!/1 to access struct fields dynamically inside get_in/put_in/update_in',
																),
																{ type: "binary" },
															),
														]),
														Type.variablePattern("reason_5"),
														context,
													);
													Interpreter.updateVarsToMatchedValues(context);
													return Elixir_Map["merge/2"](
														context.vars.exception_4,
														Type.map([
															[Type.atom("reason"), context.vars.reason_5],
														]),
													);
												},
											},
											{
												match: Type.matchPlaceholder(),
												guards: [],
												body: (context) => {
													return context.vars.exception_4;
												},
											},
										],
										context,
									),
									Type.variablePattern("exception_6"),
									context,
								);
								Interpreter.updateVarsToMatchedValues(context);
								return Erlang["error/1"](
									Erlang["raise/3"](
										Type.atom("error"),
										Elixir_Kernel_Utils["raise/1"](context.vars.exception_6),
										Type.matchPlaceholder(),
									),
								);
							},
						},
					],
					[],
					[],
					null,
					context,
				);
				Interpreter.updateVarsToMatchedValues(context);
				return globalThis.hologram.return;
			},
		},
		{
			params: (context) => [
				Type.variablePattern("map_0"),
				Type.variablePattern("key_1"),
				Type.variablePattern("fun_2"),
			],
			guards: [(context) => Erlang["is_map/1"](context.vars.map_0)],
			body: (context) => {
				return Elixir_Map["get_and_update/3"](
					context.vars.map_0,
					context.vars.key_1,
					context.vars.fun_2,
				);
			},
		},
		{
			params: (context) => [
				Type.variablePattern("list_0"),
				Type.variablePattern("key_1"),
				Type.variablePattern("fun_2"),
			],
			guards: [
				(context) =>
					Erlang["andalso/2"](
						(context) => Erlang["is_list/1"](context.vars.list_0),
						(context) => Erlang["is_atom/1"](context.vars.key_1),
						context,
					),
			],
			body: (context) => {
				return Elixir_Keyword["get_and_update/3"](
					context.vars.list_0,
					context.vars.key_1,
					context.vars.fun_2,
				);
			},
		},
		{
			params: (context) => [
				Type.variablePattern("list_0"),
				Type.variablePattern("key_1"),
				Type.matchPlaceholder(),
			],
			guards: [
				(context) =>
					Erlang["andalso/2"](
						(context) => Erlang["is_list/1"](context.vars.list_0),
						(context) => Erlang["is_integer/1"](context.vars.key_1),
						context,
					),
			],
			body: (context) => {
				return Erlang["error/1"](
					Elixir_ArgumentError["exception/1"](
						Type.bitstring([
							Type.bitstringSegment(
								Type.string(
									"the Access module does not support accessing lists by index, got: ",
								),
								{ type: "binary" },
							),
							Type.bitstringSegment(
								Elixir_Kernel["inspect/1"](context.vars.key_1),
								{ type: "binary" },
							),
							Type.bitstringSegment(
								Type.string(
									"\n\nAccessing a list by index is typically discouraged in Elixir, instead we prefer to use the Enum module to manipulate lists as a whole. If you really must mostify a list element by index, you can Access.at/1 or the functions in the List module",
								),
								{ type: "binary" },
							),
						]),
					),
				);
			},
		},
		{
			params: (context) => [
				Type.variablePattern("list_0"),
				Type.variablePattern("key_1"),
				Type.matchPlaceholder(),
			],
			guards: [(context) => Erlang["is_list/1"](context.vars.list_0)],
			body: (context) => {
				return Erlang["error/1"](
					Elixir_ArgumentError["exception/1"](
						Type.bitstring([
							Type.bitstringSegment(
								Type.string(
									"the Access module supports only keyword lists (with atom keys), got: ",
								),
								{ type: "binary" },
							),
							Type.bitstringSegment(
								Elixir_Kernel["inspect/1"](context.vars.key_1),
								{ type: "binary" },
							),
						]),
					),
				);
			},
		},
		{
			params: (context) => [
				Type.atom("nil"),
				Type.variablePattern("key_0"),
				Type.matchPlaceholder(),
			],
			guards: [],
			body: (context) => {
				return Erlang["error/1"](
					Elixir_ArgumentError["exception/1"](
						Type.bitstring([
							Type.bitstringSegment(Type.string("could not put/update key "), {
								type: "binary",
							}),
							Type.bitstringSegment(
								Elixir_Kernel["inspect/1"](context.vars.key_0),
								{ type: "binary" },
							),
							Type.bitstringSegment(Type.string(" on a nil value"), {
								type: "binary",
							}),
						]),
					),
				);
			},
		},
	]);

	Interpreter.defineElixirFunction("Application", "get_env", 3, "public", [
		{
			params: (context) => [
				Type.variablePattern("app_0"),
				Type.variablePattern("key_1"),
				Type.variablePattern("default_2"),
			],
			guards: [(context) => Erlang["is_atom/1"](context.vars.app_0)],
			body: (context) => {
				Elixir_Application["maybe_warn_on_app_env_key/2"](
					context.vars.app_0,
					context.vars.key_1,
				);
				return Erlang_Application["get_env/3"](
					context.vars.app_0,
					context.vars.key_1,
					context.vars.default_2,
				);
			},
		},
	]);

	Interpreter.defineElixirFunction(
		"Application",
		"maybe_warn_on_app_env_key",
		2,
		"private",
		[
			{
				params: (context) => [
					Type.matchPlaceholder(),
					Type.variablePattern("key_1"),
				],
				guards: [(context) => Erlang["is_atom/1"](context.vars.key_1)],
				body: (context) => {
					return Type.atom("ok");
				},
			},
			{
				params: (context) => [
					Type.variablePattern("app_0"),
					Type.variablePattern("key_1"),
				],
				guards: [],
				body: (context) => {
					Interpreter.matchOperator(
						Type.anonymousFunction(
							0,
							[
								{
									params: (context) => [],
									guards: [],
									body: (context) => {
										return Type.bitstring([
											Type.bitstringSegment(
												Type.string(
													"passing non-atom as application env key is deprecated, got: ",
												),
												{ type: "binary" },
											),
											Type.bitstringSegment(
												Elixir_Kernel["inspect/1"](context.vars.key_1),
												{ type: "binary" },
											),
										]);
									},
								},
							],
							context,
						),
						Type.variablePattern("message_2"),
						context,
					);
					Interpreter.updateVarsToMatchedValues(context);
					globalThis.hologram.return = Elixir_IO["warn_once/3"](
						Type.tuple([
							Type.atom("Elixir.Application"),
							Type.atom("key"),
							context.vars.app_0,
							context.vars.key_1,
						]),
						context.vars.message_2,
						Interpreter.matchOperator(
							Type.integer(2n),
							Type.matchPlaceholder(),
							context,
						),
					);
					Interpreter.updateVarsToMatchedValues(context);
					return globalThis.hologram.return;
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"Hologram.Assets.ManifestCache",
		"get_manifest_js",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Erlang_Persistent_Term["get/1"](
						Interpreter.callNamedFunction(
							Elixir_Hologram_Assets_ManifestCache["impl/0"](),
							Type.atom("persistent_term_key"),
							Type.list([]),
							context,
						),
					);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"Hologram.Assets.ManifestCache",
		"impl",
		0,
		"private",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Elixir_Application["get_env/3"](
						Type.atom("hologram"),
						Type.atom("asset_manifest_cache_impl"),
						Type.atom("Elixir.Hologram.Assets.ManifestCache"),
					);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"Hologram.Component",
		"put_state",
		3,
		"public",
		[
			{
				params: (context) => [
					Type.variablePattern("component_0"),
					Type.variablePattern("keys_1"),
					Type.variablePattern("value_2"),
				],
				guards: [(context) => Erlang["is_list/1"](context.vars.keys_1)],
				body: (context) => {
					return Elixir_Map["merge/2"](
						context.vars.component_0,
						Type.map([
							[
								Type.atom("state"),
								Elixir_Kernel["put_in/3"](
									Interpreter.dotOperator(
										context.vars.component_0,
										Type.atom("state"),
									),
									context.vars.keys_1,
									context.vars.value_2,
								),
							],
						]),
					);
				},
			},
			{
				params: (context) => [
					Interpreter.matchOperator(
						Type.variablePattern("component_0"),
						Type.map([[Type.atom("state"), Type.variablePattern("state_1")]]),
						context,
					),
					Type.variablePattern("key_2"),
					Type.variablePattern("value_3"),
				],
				guards: [],
				body: (context) => {
					return Elixir_Map["merge/2"](
						context.vars.component_0,
						Type.map([
							[
								Type.atom("state"),
								Erlang_Maps["put/3"](
									context.vars.key_2,
									context.vars.value_3,
									context.vars.state_1,
								),
							],
						]),
					);
				},
			},
		],
	);

	Interpreter.defineElixirFunction("Hologram.JS", "sigil_JS", 2, "public", [
		{
			params: (context) => [Type.variablePattern("code_0"), Type.list([])],
			guards: [],
			body: (context) => {
				return Elixir_Hologram_JS["exec/1"](context.vars.code_0);
			},
		},
	]);

	Interpreter.defineElixirFunction(
		"Hologram.Router.Helpers",
		"page_bundle_path",
		1,
		"public",
		[
			{
				params: (context) => [Type.variablePattern("page_digest_0")],
				guards: [],
				body: (context) => {
					return Type.bitstring([
						Type.bitstringSegment(Type.string("/hologram/page-"), {
							type: "binary",
						}),
						Type.bitstringSegment(
							Elixir_String_Chars["to_string/1"](context.vars.page_digest_0),
							{ type: "binary" },
						),
						Type.bitstringSegment(Type.string(".js"), { type: "binary" }),
					]);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"Hologram.UI.Link",
		"__props__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Elixir_Enum["reverse/1"](
						Type.list([
							Type.tuple([
								Type.atom("to"),
								Type.list([
									Type.atom("module"),
									Type.atom("string"),
									Type.atom("tuple"),
								]),
								Type.list([]),
							]),
							Type.tuple([
								Type.atom("style"),
								Type.atom("string"),
								Type.list([
									Type.tuple([Type.atom("default"), Type.atom("nil")]),
								]),
							]),
							Type.tuple([
								Type.atom("rel"),
								Type.atom("string"),
								Type.list([
									Type.tuple([Type.atom("default"), Type.atom("nil")]),
								]),
							]),
							Type.tuple([
								Type.atom("class"),
								Type.atom("string"),
								Type.list([
									Type.tuple([Type.atom("default"), Type.atom("nil")]),
								]),
							]),
						]),
					);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"Hologram.UI.Link",
		"template",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					globalThis.hologram.return = Type.anonymousFunction(
						1,
						[
							{
								params: (context) => [Type.variablePattern("vars_0")],
								guards: [],
								body: (context) => {
									Interpreter.matchOperator(
										context.vars.vars_0,
										Type.matchPlaceholder(),
										context,
									);
									Interpreter.updateVarsToMatchedValues(context);
									return Type.list([
										Type.tuple([
											Type.atom("element"),
											Type.bitstring("a"),
											Type.list([
												Type.tuple([
													Type.bitstring("href"),
													Type.list([
														Type.tuple([
															Type.atom("expression"),
															Type.tuple([
																Elixir_Hologram_Router_Helpers["page_path/1"](
																	Interpreter.dotOperator(
																		context.vars.vars_0,
																		Type.atom("to"),
																	),
																),
															]),
														]),
													]),
												]),
												Type.tuple([
													Type.bitstring("class"),
													Type.list([
														Type.tuple([
															Type.atom("expression"),
															Type.tuple([
																Interpreter.dotOperator(
																	context.vars.vars_0,
																	Type.atom("class"),
																),
															]),
														]),
													]),
												]),
												Type.tuple([
													Type.bitstring("rel"),
													Type.list([
														Type.tuple([
															Type.atom("expression"),
															Type.tuple([
																Interpreter.dotOperator(
																	context.vars.vars_0,
																	Type.atom("rel"),
																),
															]),
														]),
													]),
												]),
												Type.tuple([
													Type.bitstring("style"),
													Type.list([
														Type.tuple([
															Type.atom("expression"),
															Type.tuple([
																Interpreter.dotOperator(
																	context.vars.vars_0,
																	Type.atom("style"),
																),
															]),
														]),
													]),
												]),
												Type.tuple([
													Type.bitstring("$pointerdown"),
													Type.list([
														Type.tuple([
															Type.atom("expression"),
															Type.tuple([
																Type.atom("__prefetch_page__"),
																Type.list([
																	Type.tuple([
																		Type.atom("to"),
																		Interpreter.dotOperator(
																			context.vars.vars_0,
																			Type.atom("to"),
																		),
																	]),
																]),
															]),
														]),
													]),
												]),
												Type.tuple([
													Type.bitstring("$click"),
													Type.list([
														Type.tuple([
															Type.atom("expression"),
															Type.tuple([
																Type.atom("__load_prefetched_page__"),
																Type.list([
																	Type.tuple([
																		Type.atom("to"),
																		Interpreter.dotOperator(
																			context.vars.vars_0,
																			Type.atom("to"),
																		),
																	]),
																]),
															]),
														]),
													]),
												]),
											]),
											Type.list([
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("slot"),
													Type.list([]),
													Type.list([]),
												]),
											]),
										]),
									]);
								},
							},
						],
						context,
					);
					Interpreter.updateVarsToMatchedValues(context);
					return globalThis.hologram.return;
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"Hologram.UI.Runtime",
		"__props__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Elixir_Enum["reverse/1"](
						Type.list([
							Type.tuple([
								Type.atom("page_mounted?"),
								Type.atom("boolean"),
								Type.list([
									Type.tuple([
										Type.atom("from_context"),
										Type.tuple([
											Type.atom("Elixir.Hologram.Runtime"),
											Type.atom("page_mounted?"),
										]),
									]),
								]),
							]),
							Type.tuple([
								Type.atom("page_digest"),
								Type.atom("string"),
								Type.list([
									Type.tuple([
										Type.atom("from_context"),
										Type.tuple([
											Type.atom("Elixir.Hologram.Runtime"),
											Type.atom("page_digest"),
										]),
									]),
								]),
							]),
							Type.tuple([
								Type.atom("initial_page?"),
								Type.atom("boolean"),
								Type.list([
									Type.tuple([
										Type.atom("from_context"),
										Type.tuple([
											Type.atom("Elixir.Hologram.Runtime"),
											Type.atom("initial_page?"),
										]),
									]),
								]),
							]),
						]),
					);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"Hologram.UI.Runtime",
		"template",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					globalThis.hologram.return = Type.anonymousFunction(
						1,
						[
							{
								params: (context) => [Type.variablePattern("vars_0")],
								guards: [],
								body: (context) => {
									Interpreter.matchOperator(
										context.vars.vars_0,
										Type.matchPlaceholder(),
										context,
									);
									Interpreter.updateVarsToMatchedValues(context);
									return Type.list([
										Interpreter.case(
											Interpreter.case(
												Interpreter.dotOperator(
													context.vars.vars_0,
													Type.atom("initial_page?"),
												),
												[
													{
														match: Type.variablePattern("x_1"),
														guards: [
															(context) =>
																Erlang["orelse/2"](
																	(context) =>
																		Erlang["=:=/2"](
																			context.vars.x_1,
																			Type.atom("false"),
																		),
																	(context) =>
																		Erlang["=:=/2"](
																			context.vars.x_1,
																			Type.atom("nil"),
																		),
																	context,
																),
														],
														body: (context) => {
															return context.vars.x_1;
														},
													},
													{
														match: Type.matchPlaceholder(),
														guards: [],
														body: (context) => {
															return Interpreter.case(
																Interpreter.dotOperator(
																	context.vars.vars_0,
																	Type.atom("page_mounted?"),
																),
																[
																	{
																		match: Type.variablePattern("x_2"),
																		guards: [
																			(context) =>
																				Erlang["orelse/2"](
																					(context) =>
																						Erlang["=:=/2"](
																							context.vars.x_2,
																							Type.atom("false"),
																						),
																					(context) =>
																						Erlang["=:=/2"](
																							context.vars.x_2,
																							Type.atom("nil"),
																						),
																					context,
																				),
																		],
																		body: (context) => {
																			return Type.atom("true");
																		},
																	},
																	{
																		match: Type.matchPlaceholder(),
																		guards: [],
																		body: (context) => {
																			return Type.atom("false");
																		},
																	},
																],
																context,
															);
														},
													},
												],
												context,
											),
											[
												{
													match: Type.variablePattern("x_3"),
													guards: [
														(context) =>
															Erlang["orelse/2"](
																(context) =>
																	Erlang["=:=/2"](
																		context.vars.x_3,
																		Type.atom("false"),
																	),
																(context) =>
																	Erlang["=:=/2"](
																		context.vars.x_3,
																		Type.atom("nil"),
																	),
																context,
															),
													],
													body: (context) => {
														return Type.atom("nil");
													},
												},
												{
													match: Type.matchPlaceholder(),
													guards: [],
													body: (context) => {
														return Type.list([
															Type.tuple([
																Type.atom("text"),
																Type.bitstring("\n  "),
															]),
															Type.tuple([
																Type.atom("element"),
																Type.bitstring("script"),
																Type.list([]),
																Type.list([
																	Type.tuple([
																		Type.atom("text"),
																		Type.bitstring(
																			"\n    globalThis.hologram ??= {};\n    ",
																		),
																	]),
																	Type.tuple([
																		Type.atom("expression"),
																		Type.tuple([
																			Elixir_Hologram_Assets_ManifestCache[
																				"get_manifest_js/0"
																			](),
																		]),
																	]),
																	Type.tuple([
																		Type.atom("text"),
																		Type.bitstring("\n  "),
																	]),
																]),
															]),
															Type.tuple([
																Type.atom("text"),
																Type.bitstring("\n"),
															]),
														]);
													},
												},
											],
											context,
										),
										Type.tuple([Type.atom("text"), Type.bitstring("\n\n")]),
										Interpreter.case(
											Interpreter.case(
												Interpreter.dotOperator(
													context.vars.vars_0,
													Type.atom("page_mounted?"),
												),
												[
													{
														match: Type.variablePattern("x_4"),
														guards: [
															(context) =>
																Erlang["orelse/2"](
																	(context) =>
																		Erlang["=:=/2"](
																			context.vars.x_4,
																			Type.atom("false"),
																		),
																	(context) =>
																		Erlang["=:=/2"](
																			context.vars.x_4,
																			Type.atom("nil"),
																		),
																	context,
																),
														],
														body: (context) => {
															return Type.atom("true");
														},
													},
													{
														match: Type.matchPlaceholder(),
														guards: [],
														body: (context) => {
															return Type.atom("false");
														},
													},
												],
												context,
											),
											[
												{
													match: Type.atom("false"),
													guards: [],
													body: (context) => {
														return Type.atom("nil");
													},
												},
												{
													match: Type.atom("true"),
													guards: [],
													body: (context) => {
														return Type.list([
															Type.tuple([
																Type.atom("text"),
																Type.bitstring("\n  "),
															]),
															Type.tuple([
																Type.atom("element"),
																Type.bitstring("script"),
																Type.list([]),
																Type.list([
																	Type.tuple([
																		Type.atom("text"),
																		Type.bitstring(
																			"\n    \n      globalThis.hologram.pageMountData = (deps) => {\n        const Type = deps.Type;\n        \n        return {\n          componentRegistry: $COMPONENT_REGISTRY_JS_PLACEHOLDER,\n          pageModule: $PAGE_MODULE_JS_PLACEHOLDER,\n          pageParams: $PAGE_PARAMS_JS_PLACEHOLDER\n        };\n      };\n    \n  ",
																		),
																	]),
																]),
															]),
															Type.tuple([
																Type.atom("text"),
																Type.bitstring("\n"),
															]),
														]);
													},
												},
											],
											context,
										),
										Type.tuple([Type.atom("text"), Type.bitstring("\n\n")]),
										Interpreter.case(
											Interpreter.case(
												Interpreter.dotOperator(
													context.vars.vars_0,
													Type.atom("initial_page?"),
												),
												[
													{
														match: Type.variablePattern("x_5"),
														guards: [
															(context) =>
																Erlang["orelse/2"](
																	(context) =>
																		Erlang["=:=/2"](
																			context.vars.x_5,
																			Type.atom("false"),
																		),
																	(context) =>
																		Erlang["=:=/2"](
																			context.vars.x_5,
																			Type.atom("nil"),
																		),
																	context,
																),
														],
														body: (context) => {
															return context.vars.x_5;
														},
													},
													{
														match: Type.matchPlaceholder(),
														guards: [],
														body: (context) => {
															return Interpreter.case(
																Interpreter.dotOperator(
																	context.vars.vars_0,
																	Type.atom("page_mounted?"),
																),
																[
																	{
																		match: Type.variablePattern("x_6"),
																		guards: [
																			(context) =>
																				Erlang["orelse/2"](
																					(context) =>
																						Erlang["=:=/2"](
																							context.vars.x_6,
																							Type.atom("false"),
																						),
																					(context) =>
																						Erlang["=:=/2"](
																							context.vars.x_6,
																							Type.atom("nil"),
																						),
																					context,
																				),
																		],
																		body: (context) => {
																			return Type.atom("true");
																		},
																	},
																	{
																		match: Type.matchPlaceholder(),
																		guards: [],
																		body: (context) => {
																			return Type.atom("false");
																		},
																	},
																],
																context,
															);
														},
													},
												],
												context,
											),
											[
												{
													match: Type.variablePattern("x_7"),
													guards: [
														(context) =>
															Erlang["orelse/2"](
																(context) =>
																	Erlang["=:=/2"](
																		context.vars.x_7,
																		Type.atom("false"),
																	),
																(context) =>
																	Erlang["=:=/2"](
																		context.vars.x_7,
																		Type.atom("nil"),
																	),
																context,
															),
													],
													body: (context) => {
														return Type.atom("nil");
													},
												},
												{
													match: Type.matchPlaceholder(),
													guards: [],
													body: (context) => {
														return Type.list([
															Type.tuple([
																Type.atom("text"),
																Type.bitstring("\n  "),
															]),
															Type.tuple([
																Type.atom("element"),
																Type.bitstring("script"),
																Type.list([
																	Type.tuple([
																		Type.bitstring("async"),
																		Type.list([]),
																	]),
																	Type.tuple([
																		Type.bitstring("src"),
																		Type.list([
																			Type.tuple([
																				Type.atom("expression"),
																				Type.tuple([
																					Elixir_Hologram_Router_Helpers[
																						"asset_path/1"
																					](
																						Type.bitstring(
																							"hologram/runtime.js",
																						),
																					),
																				]),
																			]),
																		]),
																	]),
																]),
																Type.list([]),
															]),
															Type.tuple([
																Type.atom("text"),
																Type.bitstring("\n"),
															]),
														]);
													},
												},
											],
											context,
										),
										Type.tuple([Type.atom("text"), Type.bitstring("\n\n")]),
										Interpreter.case(
											Interpreter.case(
												Interpreter.dotOperator(
													context.vars.vars_0,
													Type.atom("page_mounted?"),
												),
												[
													{
														match: Type.variablePattern("x_8"),
														guards: [
															(context) =>
																Erlang["orelse/2"](
																	(context) =>
																		Erlang["=:=/2"](
																			context.vars.x_8,
																			Type.atom("false"),
																		),
																	(context) =>
																		Erlang["=:=/2"](
																			context.vars.x_8,
																			Type.atom("nil"),
																		),
																	context,
																),
														],
														body: (context) => {
															return Type.atom("true");
														},
													},
													{
														match: Type.matchPlaceholder(),
														guards: [],
														body: (context) => {
															return Type.atom("false");
														},
													},
												],
												context,
											),
											[
												{
													match: Type.atom("false"),
													guards: [],
													body: (context) => {
														return Type.atom("nil");
													},
												},
												{
													match: Type.atom("true"),
													guards: [],
													body: (context) => {
														return Type.list([
															Type.tuple([
																Type.atom("text"),
																Type.bitstring("\n  "),
															]),
															Type.tuple([
																Type.atom("element"),
																Type.bitstring("script"),
																Type.list([
																	Type.tuple([
																		Type.bitstring("async"),
																		Type.list([]),
																	]),
																	Type.tuple([
																		Type.bitstring("src"),
																		Type.list([
																			Type.tuple([
																				Type.atom("expression"),
																				Type.tuple([
																					Elixir_Hologram_Router_Helpers[
																						"page_bundle_path/1"
																					](
																						Interpreter.dotOperator(
																							context.vars.vars_0,
																							Type.atom("page_digest"),
																						),
																					),
																				]),
																			]),
																		]),
																	]),
																]),
																Type.list([]),
															]),
															Type.tuple([
																Type.atom("text"),
																Type.bitstring("\n"),
															]),
														]);
													},
												},
											],
											context,
										),
									]);
								},
							},
						],
						context,
					);
					Interpreter.updateVarsToMatchedValues(context);
					return globalThis.hologram.return;
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"HologramWebsite.ActionsPage",
		"__params__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Elixir_Enum["reverse/1"](Type.list([]));
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"HologramWebsite.ActionsPage",
		"__route__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Type.bitstring("/docs/actions");
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"HologramWebsite.ArchitecturePage",
		"__params__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Elixir_Enum["reverse/1"](Type.list([]));
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"HologramWebsite.ArchitecturePage",
		"__route__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Type.bitstring("/docs/architecture");
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"HologramWebsite.CommandsPage",
		"__params__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Elixir_Enum["reverse/1"](Type.list([]));
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"HologramWebsite.CommandsPage",
		"__route__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Type.bitstring("/docs/commands");
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"HologramWebsite.Components.Code",
		"__props__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Elixir_Enum["reverse/1"](Type.list([]));
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"HologramWebsite.Components.Code",
		"template",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					globalThis.hologram.return = Type.anonymousFunction(
						1,
						[
							{
								params: (context) => [Type.variablePattern("vars_0")],
								guards: [],
								body: (context) => {
									Interpreter.matchOperator(
										context.vars.vars_0,
										Type.matchPlaceholder(),
										context,
									);
									Interpreter.updateVarsToMatchedValues(context);
									return Type.list([
										Type.tuple([
											Type.atom("element"),
											Type.bitstring("code"),
											Type.list([
												Type.tuple([
													Type.bitstring("data-component"),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("code"),
														]),
													]),
												]),
												Type.tuple([
													Type.bitstring("class"),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring(
																"text-base px-1 rounded text-neutral-300 bg-neutral-800 border border-[#363636]",
															),
														]),
													]),
												]),
											]),
											Type.list([
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("slot"),
													Type.list([]),
													Type.list([]),
												]),
											]),
										]),
									]);
								},
							},
						],
						context,
					);
					Interpreter.updateVarsToMatchedValues(context);
					return globalThis.hologram.return;
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"HologramWebsite.Components.CodeBlock",
		"__props__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Elixir_Enum["reverse/1"](Type.list([]));
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"HologramWebsite.Components.CodeBlock",
		"template",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					globalThis.hologram.return = Type.anonymousFunction(
						1,
						[
							{
								params: (context) => [Type.variablePattern("vars_0")],
								guards: [],
								body: (context) => {
									Interpreter.matchOperator(
										context.vars.vars_0,
										Type.matchPlaceholder(),
										context,
									);
									Interpreter.updateVarsToMatchedValues(context);
									return Type.list([
										Type.tuple([
											Type.atom("element"),
											Type.bitstring("pre"),
											Type.list([
												Type.tuple([
													Type.bitstring("data-component"),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("code_block"),
														]),
													]),
												]),
											]),
											Type.list([
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("code"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring(
																		"text-base mt-5 p-5 block rounded text-neutral-300 bg-neutral-800 border border-[#363636]",
																	),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("slot"),
															Type.list([]),
															Type.list([]),
														]),
													]),
												]),
											]),
										]),
									]);
								},
							},
						],
						context,
					);
					Interpreter.updateVarsToMatchedValues(context);
					return globalThis.hologram.return;
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"HologramWebsite.Components.DocsLayout",
		"__props__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Elixir_Enum["reverse/1"](
						Type.list([
							Type.tuple([
								Type.atom("page_title"),
								Type.atom("string"),
								Type.list([]),
							]),
						]),
					);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"HologramWebsite.Components.DocsLayout",
		"action",
		3,
		"public",
		[
			{
				params: (context) => [
					Type.atom("close_drawer_nav"),
					Type.matchPlaceholder(),
					Type.variablePattern("component_1"),
				],
				guards: [],
				body: (context) => {
					Elixir_Hologram_JS["sigil_JS/2"](
						Type.bitstring([
							Type.bitstringSegment(
								Type.string(
									'requestAnimationFrame(() => {\n  document.querySelector(".nav-drawer").classList.remove("translate-x-[-1px]");\n  document.querySelector(".nav-drawer").classList.add("translate-x-[-100%]");\n  document.querySelector("html").classList.remove("overflow-hidden");\n});\n',
								),
								{ type: "binary" },
							),
						]),
						Type.list([]),
					);
					return Elixir_Hologram_Component["put_state/3"](
						context.vars.component_1,
						Type.atom("drawer_nav_open?"),
						Type.atom("false"),
					);
				},
			},
			{
				params: (context) => [
					Type.atom("open_drawer_nav"),
					Type.matchPlaceholder(),
					Type.variablePattern("component_1"),
				],
				guards: [],
				body: (context) => {
					Elixir_Hologram_JS["sigil_JS/2"](
						Type.bitstring([
							Type.bitstringSegment(
								Type.string(
									'requestAnimationFrame(() => {\n  document.querySelector(".nav-drawer").classList.remove("translate-x-[-100%]");\n  document.querySelector(".nav-drawer").classList.add("translate-x-[-1px]");\n  document.querySelector("html").classList.add("overflow-hidden");\n});\n',
								),
								{ type: "binary" },
							),
						]),
						Type.list([]),
					);
					return Elixir_Hologram_Component["put_state/3"](
						context.vars.component_1,
						Type.atom("drawer_nav_open?"),
						Type.atom("true"),
					);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"HologramWebsite.Components.DocsLayout",
		"google_measurement_id",
		1,
		"private",
		[
			{
				params: (context) => [Type.atom("prod")],
				guards: [],
				body: (context) => {
					return Type.bitstring("G-TSE4T70T0J");
				},
			},
			{
				params: (context) => [Type.matchPlaceholder()],
				guards: [],
				body: (context) => {
					return Type.bitstring("G-MG81XEL12Y");
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"HologramWebsite.Components.DocsLayout",
		"header_bg_class",
		1,
		"private",
		[
			{
				params: (context) => [Type.atom("false")],
				guards: [],
				body: (context) => {
					return Type.bitstring("bg-neutral-900/80 lg:bg-neutral-900");
				},
			},
			{
				params: (context) => [Type.atom("true")],
				guards: [],
				body: (context) => {
					return Type.bitstring("bg-neutral-900");
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"HologramWebsite.Components.DocsLayout",
		"heap_environment_id",
		1,
		"private",
		[
			{
				params: (context) => [Type.atom("prod")],
				guards: [],
				body: (context) => {
					return Type.bitstring("3829164670");
				},
			},
			{
				params: (context) => [Type.matchPlaceholder()],
				guards: [],
				body: (context) => {
					return Type.bitstring("2553200084");
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"HologramWebsite.Components.DocsLayout",
		"html_elem_class",
		1,
		"private",
		[
			{
				params: (context) => [Type.atom("false")],
				guards: [],
				body: (context) => {
					return Type.atom("nil");
				},
			},
			{
				params: (context) => [Type.atom("true")],
				guards: [],
				body: (context) => {
					return Type.bitstring("overflow-hidden");
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"HologramWebsite.Components.DocsLayout",
		"nav_drawer_position_class",
		1,
		"private",
		[
			{
				params: (context) => [Type.atom("false")],
				guards: [],
				body: (context) => {
					return Type.bitstring("translate-x-[-100%]");
				},
			},
			{
				params: (context) => [Type.atom("true")],
				guards: [],
				body: (context) => {
					return Type.bitstring("translate-x-[-1px]");
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"HologramWebsite.Components.DocsLayout",
		"plausible_domain",
		1,
		"private",
		[
			{
				params: (context) => [Type.atom("prod")],
				guards: [],
				body: (context) => {
					return Type.bitstring("hologram.page");
				},
			},
			{
				params: (context) => [Type.matchPlaceholder()],
				guards: [],
				body: (context) => {
					return Type.bitstring("hologram.dev");
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"HologramWebsite.Components.DocsLayout",
		"template",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					globalThis.hologram.return = Type.anonymousFunction(
						1,
						[
							{
								params: (context) => [Type.variablePattern("vars_0")],
								guards: [],
								body: (context) => {
									Interpreter.matchOperator(
										context.vars.vars_0,
										Type.matchPlaceholder(),
										context,
									);
									Interpreter.updateVarsToMatchedValues(context);
									return Type.list([
										Type.tuple([Type.atom("doctype"), Type.bitstring("html")]),
										Type.tuple([Type.atom("text"), Type.bitstring("\n")]),
										Type.tuple([
											Type.atom("element"),
											Type.bitstring("html"),
											Type.list([
												Type.tuple([
													Type.bitstring("lang"),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("en"),
														]),
													]),
												]),
												Type.tuple([
													Type.bitstring("class"),
													Type.list([
														Type.tuple([
															Type.atom("expression"),
															Type.tuple([
																Elixir_HologramWebsite_Components_DocsLayout[
																	"html_elem_class/1"
																](
																	Interpreter.dotOperator(
																		context.vars.vars_0,
																		Type.atom("drawer_nav_open?"),
																	),
																),
															]),
														]),
													]),
												]),
											]),
											Type.list([
												Type.tuple([Type.atom("text"), Type.bitstring("\n  ")]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("head"),
													Type.list([]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n    "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("meta"),
															Type.list([
																Type.tuple([
																	Type.bitstring("charset"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("utf-8"),
																		]),
																	]),
																]),
															]),
															Type.list([]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n    "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("meta"),
															Type.list([
																Type.tuple([
																	Type.bitstring("name"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("viewport"),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.bitstring("content"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring(
																				"width=device-width, initial-scale=1",
																			),
																		]),
																	]),
																]),
															]),
															Type.list([]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n    "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("title"),
															Type.list([]),
															Type.list([
																Type.tuple([
																	Type.atom("expression"),
																	Type.tuple([
																		Interpreter.dotOperator(
																			context.vars.vars_0,
																			Type.atom("page_title"),
																		),
																	]),
																]),
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring(" - Hologram"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("        \n    "),
														]),
														Type.tuple([
															Type.atom("component"),
															Type.atom("Elixir.Hologram.UI.Runtime"),
															Type.list([]),
															Type.list([]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring(" \n    "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("link"),
															Type.list([
																Type.tuple([
																	Type.bitstring("rel"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("stylesheet"),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.bitstring("href"),
																	Type.list([
																		Type.tuple([
																			Type.atom("expression"),
																			Type.tuple([
																				Elixir_Hologram_Router_Helpers[
																					"asset_path/1"
																				](Type.bitstring("assets/app.css")),
																			]),
																		]),
																	]),
																]),
															]),
															Type.list([]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n    "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("link"),
															Type.list([
																Type.tuple([
																	Type.bitstring("rel"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("icon"),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.bitstring("type"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("image/x-icon"),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.bitstring("href"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("/favicon.ico"),
																		]),
																	]),
																]),
															]),
															Type.list([]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n    "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("script"),
															Type.list([
																Type.tuple([
																	Type.bitstring("defer"),
																	Type.list([]),
																]),
																Type.tuple([
																	Type.bitstring("data-domain"),
																	Type.list([
																		Type.tuple([
																			Type.atom("expression"),
																			Type.tuple([
																				Elixir_HologramWebsite_Components_DocsLayout[
																					"plausible_domain/1"
																				](
																					Interpreter.dotOperator(
																						context.vars.vars_0,
																						Type.atom("env"),
																					),
																				),
																			]),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.bitstring("src"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("/assets/analytics.js"),
																		]),
																	]),
																]),
															]),
															Type.list([]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n    "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("script"),
															Type.list([]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring(
																		"\n      \n        window.plausible = window.plausible || function() { (window.plausible.q = window.plausible.q || []).push(arguments) }\n      \n    ",
																	),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("        \n    "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("script"),
															Type.list([
																Type.tuple([
																	Type.bitstring("type"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("text/javascript"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring(
																		'\n      \n        window.heapReadyCb=window.heapReadyCb||[],window.heap=window.heap||[],heap.load=function(e,t){window.heap.envId=e,window.heap.clientConfig=t=t||{},window.heap.clientConfig.shouldFetchServerConfig=!1;var a=document.createElement("script");a.type="text/javascript",a.async=!0,a.src="https://cdn.us.heap-api.com/config/"+e+"/heap_config.js";var r=document.getElementsByTagName("script")[0];r.parentNode.insertBefore(a,r);var n=["init","startTracking","stopTracking","track","resetIdentity","identify","getSessionId","getUserId","getIdentity","addUserProperties","addEventProperties","removeEventProperty","clearEventProperties","addAccountProperties","addAdapter","addTransformer","addTransformerFn","onReady","addPageviewProperties","removePageviewProperty","clearPageviewProperties","trackPageview"],i=function(e){return function(){var t=Array.prototype.slice.call(arguments,0);window.heapReadyCb.push({name:e,fn:function(){heap[e]&&heap[e].apply(heap,t)}})}};for(var p=0;p<n.length;p++)heap[n[p]]=i(n[p])};\n      \n      heap.load("',
																	),
																]),
																Type.tuple([
																	Type.atom("expression"),
																	Type.tuple([
																		Elixir_HologramWebsite_Components_DocsLayout[
																			"heap_environment_id/1"
																		](
																			Interpreter.dotOperator(
																				context.vars.vars_0,
																				Type.atom("env"),
																			),
																		),
																	]),
																]),
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring('");\n    '),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n    "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("script"),
															Type.list([
																Type.tuple([
																	Type.bitstring("async"),
																	Type.list([]),
																]),
																Type.tuple([
																	Type.bitstring("src"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring(
																				"https://www.googletagmanager.com/gtag/js?id=",
																			),
																		]),
																		Type.tuple([
																			Type.atom("expression"),
																			Type.tuple([
																				Elixir_HologramWebsite_Components_DocsLayout[
																					"google_measurement_id/1"
																				](
																					Interpreter.dotOperator(
																						context.vars.vars_0,
																						Type.atom("env"),
																					),
																				),
																			]),
																		]),
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring(""),
																		]),
																	]),
																]),
															]),
															Type.list([]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n    "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("script"),
															Type.list([]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring(
																		"\n      \n        window.dataLayer = window.dataLayer || [];\n        function gtag(){dataLayer.push(arguments);}\n        gtag('js', new Date());\n      \n\n      gtag('config', '",
																	),
																]),
																Type.tuple([
																	Type.atom("expression"),
																	Type.tuple([
																		Elixir_HologramWebsite_Components_DocsLayout[
																			"google_measurement_id/1"
																		](
																			Interpreter.dotOperator(
																				context.vars.vars_0,
																				Type.atom("env"),
																			),
																		),
																	]),
																]),
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("');\n    "),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n    "),
														]),
														Interpreter.case(
															Erlang["==/2"](
																Interpreter.dotOperator(
																	context.vars.vars_0,
																	Type.atom("env"),
																),
																Type.atom("prod"),
															),
															[
																{
																	match: Type.atom("false"),
																	guards: [],
																	body: (context) => {
																		return Type.atom("nil");
																	},
																},
																{
																	match: Type.atom("true"),
																	guards: [],
																	body: (context) => {
																		return Type.list([
																			Type.tuple([
																				Type.atom("text"),
																				Type.bitstring("\n      "),
																			]),
																			Type.tuple([
																				Type.atom("element"),
																				Type.bitstring("script"),
																				Type.list([
																					Type.tuple([
																						Type.bitstring("src"),
																						Type.list([
																							Type.tuple([
																								Type.atom("text"),
																								Type.bitstring(
																									"https://js.sentry-cdn.com/6389b182d4f8d844c90bfa3e63064a03.min.js",
																								),
																							]),
																						]),
																					]),
																					Type.tuple([
																						Type.bitstring("crossorigin"),
																						Type.list([
																							Type.tuple([
																								Type.atom("text"),
																								Type.bitstring("anonymous"),
																							]),
																						]),
																					]),
																				]),
																				Type.list([]),
																			]),
																			Type.tuple([
																				Type.atom("text"),
																				Type.bitstring("\n    "),
																			]),
																		]);
																	},
																},
															],
															context,
														),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n  "),
														]),
													]),
												]),
												Type.tuple([Type.atom("text"), Type.bitstring("\n  ")]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("body"),
													Type.list([]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n    "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("header"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring(
																				"fixed flex w-full lg:w-72 xl:w-80 h-14 lg:h-20 z-20 items-center justify-between px-4 sm:px-6 ",
																			),
																		]),
																		Type.tuple([
																			Type.atom("expression"),
																			Type.tuple([
																				Elixir_HologramWebsite_Components_DocsLayout[
																					"header_bg_class/1"
																				](
																					Interpreter.dotOperator(
																						context.vars.vars_0,
																						Type.atom("drawer_nav_open?"),
																					),
																				),
																			]),
																		]),
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring(
																				" border-b border-[#363636] lg:border-b-0 lg:border-r backdrop-blur lg:backdrop-blur-none transition",
																			),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("\n      "),
																]),
																Type.tuple([
																	Type.atom("component"),
																	Type.atom(
																		"Elixir.HologramWebsite.Components.Logo",
																	),
																	Type.list([
																		Type.tuple([
																			Type.bitstring("height"),
																			Type.list([
																				Type.tuple([
																					Type.atom("expression"),
																					Type.tuple([Type.integer(24n)]),
																				]),
																			]),
																		]),
																	]),
																	Type.list([]),
																]),
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("\n      "),
																]),
																Type.tuple([
																	Type.atom("component"),
																	Type.atom(
																		"Elixir.HologramWebsite.Components.Header.DrawerNavButtons",
																	),
																	Type.list([
																		Type.tuple([
																			Type.bitstring("drawer_nav_open?"),
																			Type.list([
																				Type.tuple([
																					Type.atom("expression"),
																					Type.tuple([
																						Interpreter.dotOperator(
																							context.vars.vars_0,
																							Type.atom("drawer_nav_open?"),
																						),
																					]),
																				]),
																			]),
																		]),
																	]),
																	Type.list([]),
																]),
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("\n    "),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n    "),
														]),
														Type.tuple([
															Type.atom("component"),
															Type.atom(
																"Elixir.HologramWebsite.Components.Nav",
															),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring(
																				"hidden lg:block fixed lg:w-72 xl:w-80 h-full z-10 border-r border-[#363636]",
																			),
																		]),
																	]),
																]),
															]),
															Type.list([]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n    "),
														]),
														Type.tuple([
															Type.atom("component"),
															Type.atom(
																"Elixir.HologramWebsite.Components.Nav",
															),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring(
																				"nav-drawer fixed lg:hidden box-content w-full h-full z-10 overflow-y-auto bg-neutral-900 border-x border-[#363636] transform ",
																			),
																		]),
																		Type.tuple([
																			Type.atom("expression"),
																			Type.tuple([
																				Elixir_HologramWebsite_Components_DocsLayout[
																					"nav_drawer_position_class/1"
																				](
																					Interpreter.dotOperator(
																						context.vars.vars_0,
																						Type.atom("drawer_nav_open?"),
																					),
																				),
																			]),
																		]),
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring(
																				" transition-transform duration-300 ease-in-out",
																			),
																		]),
																	]),
																]),
															]),
															Type.list([]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n    "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("main"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring(
																				"lg:ml-72 xl:ml-80 px-4 sm:px-6 lg:px-12 py-14",
																			),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("\n      "),
																]),
																Type.tuple([
																	Type.atom("element"),
																	Type.bitstring("div"),
																	Type.list([
																		Type.tuple([
																			Type.bitstring("class"),
																			Type.list([
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring(
																						"mx-auto md:max-w-2xl lg:max-w-6xl mt-8 sm:mt-10 md:mt-12 lg:mt-0",
																					),
																				]),
																			]),
																		]),
																	]),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("\n        "),
																		]),
																		Type.tuple([
																			Type.atom("element"),
																			Type.bitstring("slot"),
																			Type.list([]),
																			Type.list([]),
																		]),
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("\n      "),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("\n    "),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n    "),
														]),
														Type.tuple([
															Type.atom("public_comment"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring(" env: "),
																]),
																Type.tuple([
																	Type.atom("expression"),
																	Type.tuple([
																		Interpreter.dotOperator(
																			context.vars.vars_0,
																			Type.atom("env"),
																		),
																	]),
																]),
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring(", region: "),
																]),
																Type.tuple([
																	Type.atom("expression"),
																	Type.tuple([
																		Interpreter.dotOperator(
																			context.vars.vars_0,
																			Type.atom("region"),
																		),
																	]),
																]),
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring(", machine_id: "),
																]),
																Type.tuple([
																	Type.atom("expression"),
																	Type.tuple([
																		Interpreter.dotOperator(
																			context.vars.vars_0,
																			Type.atom("machine_id"),
																		),
																	]),
																]),
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring(" "),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("        \n  "),
														]),
													]),
												]),
												Type.tuple([Type.atom("text"), Type.bitstring("\n")]),
											]),
										]),
									]);
								},
							},
						],
						context,
					);
					Interpreter.updateVarsToMatchedValues(context);
					return globalThis.hologram.return;
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"HologramWebsite.Components.GitHubSponsorsButton",
		"__props__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Elixir_Enum["reverse/1"](
						Type.list([
							Type.tuple([
								Type.atom("size"),
								Type.atom("atom"),
								Type.list([
									Type.tuple([Type.atom("default"), Type.atom("big")]),
								]),
							]),
						]),
					);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"HologramWebsite.Components.GitHubSponsorsButton",
		"link_class",
		1,
		"public",
		[
			{
				params: (context) => [Type.atom("big")],
				guards: [],
				body: (context) => {
					return Type.bitstring("h-10 px-3 text-base");
				},
			},
			{
				params: (context) => [Type.atom("small")],
				guards: [],
				body: (context) => {
					return Type.bitstring("h-8 px-2 text-sm");
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"HologramWebsite.Components.GitHubSponsorsButton",
		"svg_class",
		1,
		"public",
		[
			{
				params: (context) => [Type.atom("big")],
				guards: [],
				body: (context) => {
					return Type.bitstring("w-6 h-6");
				},
			},
			{
				params: (context) => [Type.atom("small")],
				guards: [],
				body: (context) => {
					return Type.bitstring("w-4 h-4");
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"HologramWebsite.Components.GitHubSponsorsButton",
		"template",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					globalThis.hologram.return = Type.anonymousFunction(
						1,
						[
							{
								params: (context) => [Type.variablePattern("vars_0")],
								guards: [],
								body: (context) => {
									Interpreter.matchOperator(
										context.vars.vars_0,
										Type.matchPlaceholder(),
										context,
									);
									Interpreter.updateVarsToMatchedValues(context);
									return Type.list([
										Type.tuple([
											Type.atom("element"),
											Type.bitstring("a"),
											Type.list([
												Type.tuple([
													Type.bitstring("href"),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring(
																"https://github.com/sponsors/bartblast",
															),
														]),
													]),
												]),
												Type.tuple([
													Type.bitstring("rel"),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("nofollow"),
														]),
													]),
												]),
												Type.tuple([
													Type.bitstring("target"),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("_blank"),
														]),
													]),
												]),
												Type.tuple([
													Type.bitstring("class"),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring(
																"github-button inline-flex items-center gap-2 ",
															),
														]),
														Type.tuple([
															Type.atom("expression"),
															Type.tuple([
																Elixir_HologramWebsite_Components_GitHubSponsorsButton[
																	"link_class/1"
																](
																	Interpreter.dotOperator(
																		context.vars.vars_0,
																		Type.atom("size"),
																	),
																),
															]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring(
																" font-semibold border rounded-md",
															),
														]),
													]),
												]),
											]),
											Type.list([
												Type.tuple([Type.atom("text"), Type.bitstring("\n  ")]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("svg"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("expression"),
																	Type.tuple([
																		Elixir_HologramWebsite_Components_GitHubSponsorsButton[
																			"svg_class/1"
																		](
																			Interpreter.dotOperator(
																				context.vars.vars_0,
																				Type.atom("size"),
																			),
																		),
																	]),
																]),
															]),
														]),
														Type.tuple([
															Type.bitstring("viewBox"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("0 0 16 16"),
																]),
															]),
														]),
														Type.tuple([
															Type.bitstring("fill"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("#bf3989"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n    "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("path"),
															Type.list([
																Type.tuple([
																	Type.bitstring("transform"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("translate(0, 0.5)"),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.bitstring("d"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring(
																				"m8 14.25.345.666a.75.75 0 0 1-.69 0l-.008-.004-.018-.01a7.152 7.152 0 0 1-.31-.17 22.055 22.055 0 0 1-3.434-2.414C2.045 10.731 0 8.35 0 5.5 0 2.836 2.086 1 4.25 1 5.797 1 7.153 1.802 8 3.02 8.847 1.802 10.203 1 11.75 1 13.914 1 16 2.836 16 5.5c0 2.85-2.045 5.231-3.885 6.818a22.066 22.066 0 0 1-3.744 2.584l-.018.01-.006.003h-.002ZM4.25 2.5c-1.336 0-2.75 1.164-2.75 3 0 2.15 1.58 4.144 3.365 5.682A20.58 20.58 0 0 0 8 13.393a20.58 20.58 0 0 0 3.135-2.211C12.92 9.644 14.5 7.65 14.5 5.5c0-1.836-1.414-3-2.75-3-1.373 0-2.609.986-3.029 2.456a.749.749 0 0 1-1.442 0C6.859 3.486 5.623 2.5 4.25 2.5Z",
																			),
																		]),
																	]),
																]),
															]),
															Type.list([]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n  "),
														]),
													]),
												]),
												Type.tuple([
													Type.atom("text"),
													Type.bitstring("\n  Sponsor\n"),
												]),
											]),
										]),
									]);
								},
							},
						],
						context,
					);
					Interpreter.updateVarsToMatchedValues(context);
					return globalThis.hologram.return;
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"HologramWebsite.Components.GitHubStarButton",
		"__props__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Elixir_Enum["reverse/1"](
						Type.list([
							Type.tuple([
								Type.atom("size"),
								Type.atom("atom"),
								Type.list([
									Type.tuple([Type.atom("default"), Type.atom("big")]),
								]),
							]),
							Type.tuple([
								Type.atom("class"),
								Type.atom("string"),
								Type.list([
									Type.tuple([Type.atom("default"), Type.bitstring("")]),
								]),
							]),
						]),
					);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"HologramWebsite.Components.GitHubStarButton",
		"link_class",
		1,
		"public",
		[
			{
				params: (context) => [Type.atom("big")],
				guards: [],
				body: (context) => {
					return Type.bitstring("h-10 px-3 text-base");
				},
			},
			{
				params: (context) => [Type.atom("small")],
				guards: [],
				body: (context) => {
					return Type.bitstring("h-8 px-2 text-sm");
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"HologramWebsite.Components.GitHubStarButton",
		"svg_class",
		1,
		"public",
		[
			{
				params: (context) => [Type.atom("big")],
				guards: [],
				body: (context) => {
					return Type.bitstring("w-6 h-6");
				},
			},
			{
				params: (context) => [Type.atom("small")],
				guards: [],
				body: (context) => {
					return Type.bitstring("w-4 h-4");
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"HologramWebsite.Components.GitHubStarButton",
		"template",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					globalThis.hologram.return = Type.anonymousFunction(
						1,
						[
							{
								params: (context) => [Type.variablePattern("vars_0")],
								guards: [],
								body: (context) => {
									Interpreter.matchOperator(
										context.vars.vars_0,
										Type.matchPlaceholder(),
										context,
									);
									Interpreter.updateVarsToMatchedValues(context);
									return Type.list([
										Type.tuple([
											Type.atom("element"),
											Type.bitstring("a"),
											Type.list([
												Type.tuple([
													Type.bitstring("href"),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring(
																"https://github.com/bartblast/hologram",
															),
														]),
													]),
												]),
												Type.tuple([
													Type.bitstring("rel"),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("nofollow"),
														]),
													]),
												]),
												Type.tuple([
													Type.bitstring("target"),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("_blank"),
														]),
													]),
												]),
												Type.tuple([
													Type.bitstring("class"),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring(
																"github-button inline-flex items-center gap-2 ",
															),
														]),
														Type.tuple([
															Type.atom("expression"),
															Type.tuple([
																Elixir_HologramWebsite_Components_GitHubStarButton[
																	"link_class/1"
																](
																	Interpreter.dotOperator(
																		context.vars.vars_0,
																		Type.atom("size"),
																	),
																),
															]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring(
																" font-semibold border rounded-md ",
															),
														]),
														Type.tuple([
															Type.atom("expression"),
															Type.tuple([
																Interpreter.dotOperator(
																	context.vars.vars_0,
																	Type.atom("class"),
																),
															]),
														]),
														Type.tuple([Type.atom("text"), Type.bitstring("")]),
													]),
												]),
											]),
											Type.list([
												Type.tuple([Type.atom("text"), Type.bitstring("\n  ")]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("svg"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("expression"),
																	Type.tuple([
																		Elixir_HologramWebsite_Components_GitHubStarButton[
																			"svg_class/1"
																		](
																			Interpreter.dotOperator(
																				context.vars.vars_0,
																				Type.atom("size"),
																			),
																		),
																	]),
																]),
															]),
														]),
														Type.tuple([
															Type.bitstring("viewBox"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("0 0 16 16"),
																]),
															]),
														]),
														Type.tuple([
															Type.bitstring("fill"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("currentColor"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n    "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("path"),
															Type.list([
																Type.tuple([
																	Type.bitstring("d"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring(
																				"M8 0C3.58 0 0 3.58 0 8c0 3.54 2.29 6.53 5.47 7.59.4.07.55-.17.55-.38 0-.19-.01-.82-.01-1.49-2.01.37-2.53-.49-2.69-.94-.09-.23-.48-.94-.82-1.13-.28-.15-.68-.52-.01-.53.63-.01 1.08.58 1.23.82.72 1.21 1.87.87 2.33.66.07-.52.28-.87.51-1.07-1.78-.2-3.64-.89-3.64-3.95 0-.87.31-1.59.82-2.15-.08-.2-.36-1.02.08-2.12 0 0 .67-.21 2.2.82.64-.18 1.32-.27 2-.27.68 0 1.36.09 2 .27 1.53-1.04 2.2-.82 2.2-.82.44 1.1.16 1.92.08 2.12.51.56.82 1.27.82 2.15 0 3.07-1.87 3.75-3.65 3.95.29.25.54.73.54 1.48 0 1.07-.01 1.93-.01 2.2 0 .21.15.46.55.38A8.013 8.013 0 0016 8c0-4.42-3.58-8-8-8z",
																			),
																		]),
																	]),
																]),
															]),
															Type.list([]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n  "),
														]),
													]),
												]),
												Type.tuple([
													Type.atom("text"),
													Type.bitstring("\n  Star\n"),
												]),
											]),
										]),
									]);
								},
							},
						],
						context,
					);
					Interpreter.updateVarsToMatchedValues(context);
					return globalThis.hologram.return;
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"HologramWebsite.Components.Header.DrawerNavButtons",
		"__props__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Elixir_Enum["reverse/1"](
						Type.list([
							Type.tuple([
								Type.atom("drawer_nav_open?"),
								Type.atom("boolean"),
								Type.list([]),
							]),
						]),
					);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"HologramWebsite.Components.Header.DrawerNavButtons",
		"template",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					globalThis.hologram.return = Type.anonymousFunction(
						1,
						[
							{
								params: (context) => [Type.variablePattern("vars_0")],
								guards: [],
								body: (context) => {
									Interpreter.matchOperator(
										context.vars.vars_0,
										Type.matchPlaceholder(),
										context,
									);
									Interpreter.updateVarsToMatchedValues(context);
									return Type.list([
										Type.tuple([
											Type.atom("element"),
											Type.bitstring("div"),
											Type.list([
												Type.tuple([
													Type.bitstring("class"),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("lg:hidden"),
														]),
													]),
												]),
											]),
											Type.list([
												Type.tuple([Type.atom("text"), Type.bitstring("\n  ")]),
												Interpreter.case(
													Interpreter.dotOperator(
														context.vars.vars_0,
														Type.atom("drawer_nav_open?"),
													),
													[
														{
															match: Type.variablePattern("x_1"),
															guards: [
																(context) =>
																	Erlang["orelse/2"](
																		(context) =>
																			Erlang["=:=/2"](
																				context.vars.x_1,
																				Type.atom("false"),
																			),
																		(context) =>
																			Erlang["=:=/2"](
																				context.vars.x_1,
																				Type.atom("nil"),
																			),
																		context,
																	),
															],
															body: (context) => {
																return Type.list([
																	Type.tuple([
																		Type.atom("text"),
																		Type.bitstring("\n    "),
																	]),
																	Type.tuple([
																		Type.atom("element"),
																		Type.bitstring("button"),
																		Type.list([
																			Type.tuple([
																				Type.bitstring("$click"),
																				Type.list([
																					Type.tuple([
																						Type.atom("expression"),
																						Type.tuple([
																							Type.list([
																								Type.tuple([
																									Type.atom("action"),
																									Type.atom("open_drawer_nav"),
																								]),
																								Type.tuple([
																									Type.atom("target"),
																									Type.bitstring("layout"),
																								]),
																							]),
																						]),
																					]),
																				]),
																			]),
																			Type.tuple([
																				Type.bitstring("type"),
																				Type.list([
																					Type.tuple([
																						Type.atom("text"),
																						Type.bitstring("button"),
																					]),
																				]),
																			]),
																			Type.tuple([
																				Type.bitstring("class"),
																				Type.list([
																					Type.tuple([
																						Type.atom("text"),
																						Type.bitstring(
																							"flex h-6 w-6 items-center justify-center rounded-md transition",
																						),
																					]),
																				]),
																			]),
																			Type.tuple([
																				Type.bitstring("aria-label"),
																				Type.list([
																					Type.tuple([
																						Type.atom("text"),
																						Type.bitstring("Toggle navigation"),
																					]),
																				]),
																			]),
																		]),
																		Type.list([
																			Type.tuple([
																				Type.atom("text"),
																				Type.bitstring("\n      "),
																			]),
																			Type.tuple([
																				Type.atom("element"),
																				Type.bitstring("svg"),
																				Type.list([
																					Type.tuple([
																						Type.bitstring("viewBox"),
																						Type.list([
																							Type.tuple([
																								Type.atom("text"),
																								Type.bitstring("0 0 10 9"),
																							]),
																						]),
																					]),
																					Type.tuple([
																						Type.bitstring("fill"),
																						Type.list([
																							Type.tuple([
																								Type.atom("text"),
																								Type.bitstring("none"),
																							]),
																						]),
																					]),
																					Type.tuple([
																						Type.bitstring("stroke-linecap"),
																						Type.list([
																							Type.tuple([
																								Type.atom("text"),
																								Type.bitstring("round"),
																							]),
																						]),
																					]),
																					Type.tuple([
																						Type.bitstring("aria-hidden"),
																						Type.list([
																							Type.tuple([
																								Type.atom("text"),
																								Type.bitstring("true"),
																							]),
																						]),
																					]),
																					Type.tuple([
																						Type.bitstring("class"),
																						Type.list([
																							Type.tuple([
																								Type.atom("text"),
																								Type.bitstring(
																									"w-2.5 stroke-white",
																								),
																							]),
																						]),
																					]),
																				]),
																				Type.list([
																					Type.tuple([
																						Type.atom("text"),
																						Type.bitstring("\n        "),
																					]),
																					Type.tuple([
																						Type.atom("element"),
																						Type.bitstring("path"),
																						Type.list([
																							Type.tuple([
																								Type.bitstring("d"),
																								Type.list([
																									Type.tuple([
																										Type.atom("text"),
																										Type.bitstring(
																											"M.5 1h9M.5 8h9M.5 4.5h9",
																										),
																									]),
																								]),
																							]),
																						]),
																						Type.list([]),
																					]),
																					Type.tuple([
																						Type.atom("text"),
																						Type.bitstring("\n      "),
																					]),
																				]),
																			]),
																			Type.tuple([
																				Type.atom("text"),
																				Type.bitstring("\n    "),
																			]),
																		]),
																	]),
																	Type.tuple([
																		Type.atom("text"),
																		Type.bitstring("\n  "),
																	]),
																]);
															},
														},
														{
															match: Type.matchPlaceholder(),
															guards: [],
															body: (context) => {
																return Type.list([
																	Type.tuple([
																		Type.atom("text"),
																		Type.bitstring("\n    "),
																	]),
																	Type.tuple([
																		Type.atom("element"),
																		Type.bitstring("button"),
																		Type.list([
																			Type.tuple([
																				Type.bitstring("$click"),
																				Type.list([
																					Type.tuple([
																						Type.atom("expression"),
																						Type.tuple([
																							Type.list([
																								Type.tuple([
																									Type.atom("action"),
																									Type.atom("close_drawer_nav"),
																								]),
																								Type.tuple([
																									Type.atom("target"),
																									Type.bitstring("layout"),
																								]),
																							]),
																						]),
																					]),
																				]),
																			]),
																			Type.tuple([
																				Type.bitstring("type"),
																				Type.list([
																					Type.tuple([
																						Type.atom("text"),
																						Type.bitstring("button"),
																					]),
																				]),
																			]),
																			Type.tuple([
																				Type.bitstring("class"),
																				Type.list([
																					Type.tuple([
																						Type.atom("text"),
																						Type.bitstring(
																							"flex h-6 w-6 items-center justify-center rounded-md transition",
																						),
																					]),
																				]),
																			]),
																			Type.tuple([
																				Type.bitstring("aria-label"),
																				Type.list([
																					Type.tuple([
																						Type.atom("text"),
																						Type.bitstring("Toggle navigation"),
																					]),
																				]),
																			]),
																		]),
																		Type.list([
																			Type.tuple([
																				Type.atom("text"),
																				Type.bitstring("\n      "),
																			]),
																			Type.tuple([
																				Type.atom("element"),
																				Type.bitstring("svg"),
																				Type.list([
																					Type.tuple([
																						Type.bitstring("viewBox"),
																						Type.list([
																							Type.tuple([
																								Type.atom("text"),
																								Type.bitstring("0 0 10 9"),
																							]),
																						]),
																					]),
																					Type.tuple([
																						Type.bitstring("fill"),
																						Type.list([
																							Type.tuple([
																								Type.atom("text"),
																								Type.bitstring("none"),
																							]),
																						]),
																					]),
																					Type.tuple([
																						Type.bitstring("stroke-linecap"),
																						Type.list([
																							Type.tuple([
																								Type.atom("text"),
																								Type.bitstring("round"),
																							]),
																						]),
																					]),
																					Type.tuple([
																						Type.bitstring("aria-hidden"),
																						Type.list([
																							Type.tuple([
																								Type.atom("text"),
																								Type.bitstring("true"),
																							]),
																						]),
																					]),
																					Type.tuple([
																						Type.bitstring("class"),
																						Type.list([
																							Type.tuple([
																								Type.atom("text"),
																								Type.bitstring(
																									"w-2.5 stroke-white",
																								),
																							]),
																						]),
																					]),
																				]),
																				Type.list([
																					Type.tuple([
																						Type.atom("text"),
																						Type.bitstring("\n        "),
																					]),
																					Type.tuple([
																						Type.atom("element"),
																						Type.bitstring("path"),
																						Type.list([
																							Type.tuple([
																								Type.bitstring("d"),
																								Type.list([
																									Type.tuple([
																										Type.atom("text"),
																										Type.bitstring(
																											"m1.5 1 7 7M8.5 1l-7 7",
																										),
																									]),
																								]),
																							]),
																						]),
																						Type.list([]),
																					]),
																					Type.tuple([
																						Type.atom("text"),
																						Type.bitstring("\n      "),
																					]),
																				]),
																			]),
																			Type.tuple([
																				Type.atom("text"),
																				Type.bitstring("\n    "),
																			]),
																		]),
																	]),
																	Type.tuple([
																		Type.atom("text"),
																		Type.bitstring("\n  "),
																	]),
																]);
															},
														},
													],
													context,
												),
												Type.tuple([Type.atom("text"), Type.bitstring("\n")]),
											]),
										]),
									]);
								},
							},
						],
						context,
					);
					Interpreter.updateVarsToMatchedValues(context);
					return globalThis.hologram.return;
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"HologramWebsite.Components.Heading1",
		"__props__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Elixir_Enum["reverse/1"](Type.list([]));
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"HologramWebsite.Components.Heading1",
		"template",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					globalThis.hologram.return = Type.anonymousFunction(
						1,
						[
							{
								params: (context) => [Type.variablePattern("vars_0")],
								guards: [],
								body: (context) => {
									Interpreter.matchOperator(
										context.vars.vars_0,
										Type.matchPlaceholder(),
										context,
									);
									Interpreter.updateVarsToMatchedValues(context);
									return Type.list([
										Type.tuple([
											Type.atom("element"),
											Type.bitstring("h1"),
											Type.list([
												Type.tuple([
													Type.bitstring("class"),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring(
																"text-4xl text-[#eeeeee] font-semibold",
															),
														]),
													]),
												]),
											]),
											Type.list([
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("slot"),
													Type.list([]),
													Type.list([]),
												]),
											]),
										]),
									]);
								},
							},
						],
						context,
					);
					Interpreter.updateVarsToMatchedValues(context);
					return globalThis.hologram.return;
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"HologramWebsite.Components.Heading2",
		"__props__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Elixir_Enum["reverse/1"](Type.list([]));
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"HologramWebsite.Components.Heading2",
		"template",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					globalThis.hologram.return = Type.anonymousFunction(
						1,
						[
							{
								params: (context) => [Type.variablePattern("vars_0")],
								guards: [],
								body: (context) => {
									Interpreter.matchOperator(
										context.vars.vars_0,
										Type.matchPlaceholder(),
										context,
									);
									Interpreter.updateVarsToMatchedValues(context);
									return Type.list([
										Type.tuple([
											Type.atom("element"),
											Type.bitstring("h2"),
											Type.list([
												Type.tuple([
													Type.bitstring("class"),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring(
																"text-3xl mt-12 text-[#eeeeee] font-semibold",
															),
														]),
													]),
												]),
											]),
											Type.list([
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("slot"),
													Type.list([]),
													Type.list([]),
												]),
											]),
										]),
									]);
								},
							},
						],
						context,
					);
					Interpreter.updateVarsToMatchedValues(context);
					return globalThis.hologram.return;
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"HologramWebsite.Components.List",
		"__props__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Elixir_Enum["reverse/1"](
						Type.list([
							Type.tuple([
								Type.atom("type"),
								Type.atom("atom"),
								Type.list([
									Type.tuple([Type.atom("default"), Type.atom("unordered")]),
								]),
							]),
							Type.tuple([
								Type.atom("leading_zero"),
								Type.atom("boolean"),
								Type.list([
									Type.tuple([Type.atom("default"), Type.atom("false")]),
								]),
							]),
						]),
					);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"HologramWebsite.Components.List",
		"leading_zero_class",
		1,
		"public",
		[
			{
				params: (context) => [Type.atom("false")],
				guards: [],
				body: (context) => {
					return Type.bitstring("");
				},
			},
			{
				params: (context) => [Type.atom("true")],
				guards: [],
				body: (context) => {
					return Type.bitstring("leading-zero");
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"HologramWebsite.Components.List",
		"list_type_class",
		1,
		"public",
		[
			{
				params: (context) => [Type.atom("ordered")],
				guards: [],
				body: (context) => {
					return Type.bitstring("list-decimal");
				},
			},
			{
				params: (context) => [Type.atom("unordered")],
				guards: [],
				body: (context) => {
					return Type.bitstring("list-disc");
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"HologramWebsite.Components.List",
		"padding_left_class",
		2,
		"public",
		[
			{
				params: (context) => [Type.atom("unordered"), Type.matchPlaceholder()],
				guards: [],
				body: (context) => {
					return Type.bitstring("pl-[16px]");
				},
			},
			{
				params: (context) => [Type.atom("ordered"), Type.atom("false")],
				guards: [],
				body: (context) => {
					return Type.bitstring("pl-[18px]");
				},
			},
			{
				params: (context) => [Type.atom("ordered"), Type.atom("true")],
				guards: [],
				body: (context) => {
					return Type.bitstring("pl-[29px]");
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"HologramWebsite.Components.List",
		"template",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					globalThis.hologram.return = Type.anonymousFunction(
						1,
						[
							{
								params: (context) => [Type.variablePattern("vars_0")],
								guards: [],
								body: (context) => {
									Interpreter.matchOperator(
										context.vars.vars_0,
										Type.matchPlaceholder(),
										context,
									);
									Interpreter.updateVarsToMatchedValues(context);
									return Type.list([
										Type.tuple([
											Type.atom("element"),
											Type.bitstring("ul"),
											Type.list([
												Type.tuple([
													Type.bitstring("class"),
													Type.list([
														Type.tuple([Type.atom("text"), Type.bitstring("")]),
														Type.tuple([
															Type.atom("expression"),
															Type.tuple([
																Elixir_HologramWebsite_Components_List[
																	"list_type_class/1"
																](
																	Interpreter.dotOperator(
																		context.vars.vars_0,
																		Type.atom("type"),
																	),
																),
															]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring(" list-outside "),
														]),
														Type.tuple([
															Type.atom("expression"),
															Type.tuple([
																Elixir_HologramWebsite_Components_List[
																	"leading_zero_class/1"
																](
																	Interpreter.dotOperator(
																		context.vars.vars_0,
																		Type.atom("leading_zero"),
																	),
																),
															]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring(" "),
														]),
														Type.tuple([
															Type.atom("expression"),
															Type.tuple([
																Elixir_HologramWebsite_Components_List[
																	"padding_left_class/2"
																](
																	Interpreter.dotOperator(
																		context.vars.vars_0,
																		Type.atom("type"),
																	),
																	Interpreter.dotOperator(
																		context.vars.vars_0,
																		Type.atom("leading_zero"),
																	),
																),
															]),
														]),
														Type.tuple([Type.atom("text"), Type.bitstring("")]),
													]),
												]),
											]),
											Type.list([
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("slot"),
													Type.list([]),
													Type.list([]),
												]),
											]),
										]),
									]);
								},
							},
						],
						context,
					);
					Interpreter.updateVarsToMatchedValues(context);
					return globalThis.hologram.return;
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"HologramWebsite.Components.List.Item",
		"__props__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Elixir_Enum["reverse/1"](Type.list([]));
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"HologramWebsite.Components.List.Item",
		"template",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					globalThis.hologram.return = Type.anonymousFunction(
						1,
						[
							{
								params: (context) => [Type.variablePattern("vars_0")],
								guards: [],
								body: (context) => {
									Interpreter.matchOperator(
										context.vars.vars_0,
										Type.matchPlaceholder(),
										context,
									);
									Interpreter.updateVarsToMatchedValues(context);
									return Type.list([
										Type.tuple([
											Type.atom("element"),
											Type.bitstring("li"),
											Type.list([
												Type.tuple([
													Type.bitstring("class"),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring(
																"text-base mt-2 pl-1 text-neutral-300",
															),
														]),
													]),
												]),
											]),
											Type.list([
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("slot"),
													Type.list([]),
													Type.list([]),
												]),
											]),
										]),
									]);
								},
							},
						],
						context,
					);
					Interpreter.updateVarsToMatchedValues(context);
					return globalThis.hologram.return;
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"HologramWebsite.Components.Logo",
		"__props__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Elixir_Enum["reverse/1"](
						Type.list([
							Type.tuple([
								Type.atom("height"),
								Type.atom("integer"),
								Type.list([]),
							]),
						]),
					);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"HologramWebsite.Components.Logo",
		"template",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					globalThis.hologram.return = Type.anonymousFunction(
						1,
						[
							{
								params: (context) => [Type.variablePattern("vars_0")],
								guards: [],
								body: (context) => {
									Interpreter.matchOperator(
										context.vars.vars_0,
										Type.matchPlaceholder(),
										context,
									);
									Interpreter.updateVarsToMatchedValues(context);
									return Type.list([
										Type.tuple([
											Type.atom("component"),
											Type.atom("Elixir.Hologram.UI.Link"),
											Type.list([
												Type.tuple([
													Type.bitstring("to"),
													Type.list([
														Type.tuple([
															Type.atom("expression"),
															Type.tuple([
																Type.atom("Elixir.HologramWebsite.HomePage"),
															]),
														]),
													]),
												]),
												Type.tuple([
													Type.bitstring("class"),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("logo"),
														]),
													]),
												]),
											]),
											Type.list([
												Type.tuple([Type.atom("text"), Type.bitstring("\n  ")]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("svg"),
													Type.list([
														Type.tuple([
															Type.bitstring("height"),
															Type.list([
																Type.tuple([
																	Type.atom("expression"),
																	Type.tuple([
																		Interpreter.dotOperator(
																			context.vars.vars_0,
																			Type.atom("height"),
																		),
																	]),
																]),
															]),
														]),
														Type.tuple([
															Type.bitstring("viewBox"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("0 0 2249.3333 437.33334"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n    "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("path"),
															Type.list([
																Type.tuple([
																	Type.bitstring("fill"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("#a88bfa"),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.bitstring("stroke-width"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("0.666667"),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.bitstring("d"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring(
																				"m 1407.875,394.87793 c 0.4812,-0.19258 1.0562,-0.1689 1.2778,0.0526 0.2215,0.22153 -0.1723,0.3791 -0.875,0.35015 -0.7767,-0.032 -0.9346,-0.18996 -0.4028,-0.40277 z M 1455,379.33334 c 0.6636,-0.73333 1.3566,-1.33333 1.54,-1.33333 0.1833,0 -0.2097,0.6 -0.8734,1.33333 -0.6636,0.73333 -1.3566,1.33333 -1.54,1.33333 -0.1833,0 0.2097,-0.6 0.8734,-1.33333 z m 539.3188,-83.66667 c 0,-31.9 0.081,-45.04755 0.181,-29.21677 0.1,15.83077 0.1,41.93077 0,58 -0.1,16.06923 -0.1809,3.11677 -0.181,-28.78323 z M 2077.6521,296 c 0,-31.71666 0.082,-44.69166 0.181,-28.83333 0.1,15.85833 0.1,41.80833 0,57.66667 -0.099,15.85833 -0.181,2.88333 -0.181,-28.83334 z M 1512.324,253.66667 c 10e-5,-50.96667 0.079,-71.71823 0.1759,-46.11459 0.097,25.60364 0.097,67.30364 0,92.66667 -0.097,25.36302 -0.1759,4.41459 -0.1759,-46.55208 z m 341.0093,82.7483 c 0,-0.13844 0.525,-0.66344 1.1667,-1.16667 1.0574,-0.82925 1.0809,-0.80567 0.2517,0.25171 -0.8709,1.1105 -1.4184,1.46365 -1.4184,0.91496 z m -54.125,-21.53704 c 0.4813,-0.19258 1.0563,-0.1689 1.2778,0.0526 0.2215,0.22153 -0.1723,0.37909 -0.875,0.35015 -0.7767,-0.032 -0.9346,-0.18996 -0.4028,-0.40278 z m -93.1557,-48.60015 c 0.032,-0.77663 0.19,-0.9346 0.4028,-0.40278 0.1926,0.48125 0.1689,1.05626 -0.053,1.27778 -0.2215,0.22153 -0.3791,-0.17222 -0.3502,-0.875 z m -930.66668,-1.33333 c 0.032,-0.77663 0.19,-0.9346 0.4028,-0.40278 0.1926,0.48125 0.16894,1.05625 -0.0527,1.27778 -0.22154,0.22153 -0.37914,-0.17223 -0.3502,-0.875 z m 317.99998,0 c 0.032,-0.77663 0.19,-0.9346 0.4028,-0.40278 0.1926,0.48125 0.169,1.05625 -0.053,1.27778 -0.2216,0.22153 -0.3792,-0.17223 -0.3502,-0.875 z m -162.51945,-8.27778 c 0,-2.01667 0.12494,-2.84167 0.27774,-1.83333 0.15273,1.00833 0.15273,2.65833 0,3.66666 -0.1528,1.00834 -0.27774,0.18334 -0.27774,-1.83333 z m 317.99995,0 c 0,-2.01667 0.125,-2.84167 0.2778,-1.83333 0.1527,1.00833 0.1527,2.65833 0,3.66666 -0.1528,1.00834 -0.2778,0.18334 -0.2778,-1.83333 z m 502.5722,0.66667 c 0,-0.91667 0.1513,-1.29167 0.3362,-0.83334 0.185,0.45834 0.185,1.20834 0,1.66667 -0.1849,0.45833 -0.3362,0.0833 -0.3362,-0.83333 z m -976.00001,-8 c 0,-0.91667 0.15133,-1.29167 0.33627,-0.83334 0.18493,0.45834 0.18493,1.20834 0,1.66667 -0.18494,0.45833 -0.33627,0.0833 -0.33627,-0.83333 z m 318.00001,0 c 0,-0.91667 0.1513,-1.29167 0.3363,-0.83334 0.1849,0.45834 0.1849,1.20834 0,1.66667 -0.185,0.45833 -0.3363,0.0833 -0.3363,-0.83333 z m 612.614,-0.38889 c 0.032,-0.77663 0.19,-0.9346 0.4028,-0.40278 0.1926,0.48125 0.1689,1.05625 -0.053,1.27778 -0.2215,0.22153 -0.3791,-0.17223 -0.3502,-0.875 z m -100.6667,-12 c 0.032,-0.77663 0.19,-0.9346 0.4028,-0.40278 0.1926,0.48125 0.1689,1.05625 -0.053,1.27778 -0.2215,0.22153 -0.3791,-0.17223 -0.3502,-0.875 z m 588.529,-26.77778 c -0.8292,-1.05737 -0.8057,-1.08095 0.2517,-0.25171 1.1105,0.87092 1.4637,1.41838 0.915,1.41838 -0.1384,0 -0.6634,-0.525 -1.1667,-1.16667 z M 1683,199.33334 C 1684.8057,197.5 1686.4332,196 1686.6165,196 c 0.1833,0 -1.1441,1.5 -2.9499,3.33334 -1.8057,1.83333 -3.4332,3.33333 -3.6165,3.33333 -0.1833,0 1.1441,-1.5 2.9499,-3.33333 z m -30.4584,-0.45541 c 0.4813,-0.19258 1.0563,-0.1689 1.2778,0.0526 0.2216,0.22153 -0.1722,0.37909 -0.875,0.35015 -0.7766,-0.032 -0.9346,-0.18996 -0.4028,-0.40278 z M 2105.2482,181.5 c -0.8292,-1.05737 -0.8056,-1.08095 0.2518,-0.2517 1.1104,0.87091 1.4636,1.41837 0.9149,1.41837 -0.1384,0 -0.6634,-0.525 -1.1667,-1.16667 z M 1994.2666,171 c 0,-5.5 0.1042,-7.66128 0.2294,-4.80286 0.1253,2.85842 0.1246,7.35842 0,10 -0.1262,2.64158 -0.2287,0.30286 -0.2278,-5.19714 z m -383.9333,3 c 0.6637,-0.73333 1.3567,-1.33333 1.54,-1.33333 0.1833,0 -0.2097,0.6 -0.8733,1.33333 -0.6637,0.73334 -1.3567,1.33334 -1.54,1.33334 -0.1834,0 0.2096,-0.6 0.8733,-1.33334 z m 83.5816,-3.16666 c -0.8292,-1.05738 -0.8057,-1.08096 0.2517,-0.25171 0.6417,0.50323 1.1667,1.02823 1.1667,1.16667 0,0.54869 -0.5475,0.19554 -1.4184,-0.91496 z m 175.9596,-9.99888 c 5.6143,-0.11163 14.6143,-0.11138 20,5.4e-4 5.3857,0.11193 0.7921,0.20326 -10.2079,0.20296 -11,-3e-4 -15.4064,-0.0919 -9.7921,-0.2035 z m -202.6662,-2.6232 c 0.4813,-0.19258 1.0563,-0.1689 1.2778,0.0526 0.2215,0.22153 -0.1723,0.3791 -0.875,0.35015 -0.7767,-0.032 -0.9346,-0.18996 -0.4028,-0.40277 z",
																			),
																		]),
																	]),
																]),
															]),
															Type.list([]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n    "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("path"),
															Type.list([
																Type.tuple([
																	Type.bitstring("fill"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("#a88bfa"),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.bitstring("stroke-width"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("0.666667"),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.bitstring("d"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring(
																				"m 1417.2083,394.87793 c 0.4813,-0.19258 1.0563,-0.1689 1.2778,0.0526 0.2215,0.22153 -0.1723,0.3791 -0.875,0.35015 -0.7767,-0.032 -0.9346,-0.18996 -0.4028,-0.40277 z M 930.71925,260.94445 c 0.032,-0.77663 0.19,-0.9346 0.4028,-0.40278 0.1926,0.48125 0.16894,1.05625 -0.0527,1.27778 -0.22154,0.22153 -0.37914,-0.17223 -0.3502,-0.875 z m 317.99995,0 c 0.032,-0.77663 0.19,-0.9346 0.4028,-0.40278 0.1926,0.48125 0.169,1.05625 -0.053,1.27778 -0.2216,0.22153 -0.3792,-0.17223 -0.3502,-0.875 z m 502.6667,-1.33333 c 0.032,-0.77664 0.19,-0.9346 0.4028,-0.40278 0.1926,0.48124 0.1689,1.05625 -0.053,1.27778 -0.2215,0.22152 -0.3791,-0.17223 -0.3502,-0.875 z m -820.66665,-7.33334 c 0.032,-0.77663 0.19,-0.9346 0.4028,-0.40278 0.1926,0.48125 0.16894,1.05626 -0.0527,1.27778 -0.22154,0.22153 -0.37914,-0.17222 -0.3502,-0.875 z m 317.99995,0 c 0.032,-0.77663 0.19,-0.9346 0.4028,-0.40278 0.1926,0.48125 0.169,1.05626 -0.053,1.27778 -0.2216,0.22153 -0.3792,-0.17222 -0.3502,-0.875 z m 457.3334,-1.33333 c 0.032,-0.77663 0.19,-0.9346 0.4028,-0.40278 0.1926,0.48125 0.1689,1.05625 -0.053,1.27778 -0.2215,0.22153 -0.3791,-0.17223 -0.3502,-0.875 z M 874.84599,199.53801 c 0.64866,-0.16903 1.54866,-0.15791 2,0.0247 0.4514,0.18262 -0.0793,0.32092 -1.17934,0.30733 -1.1,-0.0136 -1.46926,-0.163 -0.82066,-0.33203 z m 318.00001,0 c 0.6486,-0.16903 1.5486,-0.15791 2,0.0247 0.4514,0.18262 -0.079,0.32092 -1.1794,0.30733 -1.1,-0.0136 -1.4692,-0.163 -0.8206,-0.33203 z M 1342,187 c 0.8611,-0.91666 1.7157,-1.66666 1.899,-1.66666 0.1834,0 -0.3712,0.75 -1.2324,1.66666 -0.8611,0.91667 -1.7157,1.66667 -1.899,1.66667 -0.1834,0 0.3712,-0.75 1.2324,-1.66667 z m 761.2482,-7.5 c -0.8292,-1.05737 -0.8056,-1.08095 0.2518,-0.2517 1.1104,0.87091 1.4636,1.41837 0.9149,1.41837 -0.1384,0 -0.6634,-0.525 -1.1667,-1.16667 z",
																			),
																		]),
																	]),
																]),
															]),
															Type.list([]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n    "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("path"),
															Type.list([
																Type.tuple([
																	Type.bitstring("fill"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("#a88bfa"),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.bitstring("stroke-width"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("0.666667"),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.bitstring("d"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring(
																				"m 1419.2083,436.87793 c 0.4813,-0.19258 1.0563,-0.1689 1.2778,0.0526 0.2215,0.22153 -0.1723,0.3791 -0.875,0.35015 -0.7767,-0.032 -0.9346,-0.18996 -0.4028,-0.40277 z M 1056.994,209.33334 c 0,-79.38334 0.078,-111.858339 0.1727,-72.16667 0.095,39.69167 0.095,104.64167 0,144.33333 -0.095,39.69167 -0.1727,7.21667 -0.1727,-72.16666 z m -281.60808,52.94444 c 0.032,-0.77663 0.19,-0.9346 0.4028,-0.40278 0.1926,0.48125 0.16894,1.05626 -0.0527,1.27778 -0.22154,0.22153 -0.37914,-0.17222 -0.3502,-0.875 z m 317.99998,0 c 0.032,-0.77663 0.19,-0.9346 0.4028,-0.40278 0.1926,0.48125 0.169,1.05626 -0.053,1.27778 -0.2216,0.22153 -0.3792,-0.17222 -0.3502,-0.875 z m 658,-0.66666 c 0.032,-0.77664 0.19,-0.9346 0.4028,-0.40278 0.1926,0.48124 0.1689,1.05625 -0.053,1.27778 -0.2215,0.22152 -0.3791,-0.17223 -0.3502,-0.875 z m 0.053,-8.27778 c 0,-0.91667 0.1513,-1.29167 0.3362,-0.83334 0.185,0.45834 0.185,1.20834 0,1.66667 -0.1849,0.45833 -0.3362,0.0833 -0.3362,-0.83333 z",
																			),
																		]),
																	]),
																]),
															]),
															Type.list([]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n    "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("path"),
															Type.list([
																Type.tuple([
																	Type.bitstring("fill"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("#a88bfa"),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.bitstring("stroke-width"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("0.666667"),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.bitstring("d"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring(
																				"m 1403.2083,436.87793 c 0.4813,-0.19258 1.0563,-0.1689 1.2778,0.0526 0.2215,0.22153 -0.1723,0.3791 -0.875,0.35015 -0.7767,-0.032 -0.9346,-0.18996 -0.4028,-0.40277 z m -517.33331,-80 c 0.48126,-0.19258 1.05626,-0.1689 1.2778,0.0526 0.22153,0.22153 -0.17227,0.3791 -0.875,0.35015 -0.77667,-0.032 -0.9346,-0.18996 -0.4028,-0.40277 z m 318.00001,0 c 0.4812,-0.19258 1.0562,-0.1689 1.2778,0.0526 0.2215,0.22153 -0.1723,0.3791 -0.875,0.35015 -0.7767,-0.032 -0.9346,-0.18996 -0.4028,-0.40277 z M 508.99381,213.33334 c 0,-77.18334 0.0778,-108.75834 0.17282,-70.16667 0.095,38.59167 0.095,101.74167 0,140.33333 -0.0951,38.59167 -0.17282,7.01667 -0.17282,-70.16666 z m 45.99268,78 c 0,-34.28334 0.081,-48.30834 0.18001,-31.16667 0.099,17.14167 0.099,45.19167 0,62.33333 -0.099,17.14167 -0.18001,3.11667 -0.18001,-31.16666 z m 131.99997,0 c 0,-34.28334 0.081,-48.30834 0.18006,-31.16667 0.099,17.14167 0.099,45.19167 0,62.33333 -0.0991,17.14167 -0.18006,3.11667 -0.18006,-31.16666 z m 46.00733,-78 c 0,-77.18334 0.0778,-108.75834 0.17287,-70.16667 0.095,38.59167 0.095,101.74167 0,140.33333 -0.0951,38.59167 -0.17287,7.01667 -0.17287,-70.16666 z m 280.00021,-4 c 0,-79.38334 0.078,-111.858339 0.1727,-72.16667 0.095,39.69167 0.095,104.64167 0,144.33333 -0.095,39.69167 -0.1727,7.21667 -0.1727,-72.16666 z m 547.997,48 c 0,-52.98334 0.079,-74.65834 0.1756,-48.16667 0.096,26.49167 0.096,69.84167 0,96.33333 -0.097,26.49167 -0.1756,4.81667 -0.1756,-48.16666 z M 1604.985,298 c 0,-30.61666 0.082,-43.14166 0.1814,-27.83333 0.1,15.30833 0.1,40.35833 0,55.66667 -0.1,15.30833 -0.1814,2.78333 -0.1814,-27.83334 z m 200.2233,17.5446 c 0.4813,-0.19258 1.0563,-0.1689 1.2778,0.0526 0.2215,0.22152 -0.1723,0.37909 -0.875,0.35014 -0.7767,-0.032 -0.9346,-0.18996 -0.4028,-0.40277 z m -388.0417,-7.98612 c 0.4584,-0.18494 1.2084,-0.18494 1.6667,0 0.4583,0.18494 0.083,0.33626 -0.8333,0.33626 -0.9167,0 -1.2917,-0.15132 -0.8334,-0.33626 z m -581.25168,-8.72514 c -0.8292,-1.05738 -0.80567,-1.08096 0.25173,-0.25171 1.11047,0.87091 1.46367,1.41837 0.91494,1.41837 -0.1384,0 -0.6634,-0.525 -1.16667,-1.16666 z m 317.99998,0 c -0.8292,-1.05738 -0.8057,-1.08096 0.2517,-0.25171 1.1105,0.87091 1.4637,1.41837 0.915,1.41837 -0.1384,0 -0.6634,-0.525 -1.1667,-1.16666 z M 1614,213.08163 c 0,-0.13843 0.525,-0.66343 1.1666,-1.16667 1.0574,-0.82924 1.081,-0.80566 0.2518,0.25171 -0.871,1.1105 -1.4184,1.46365 -1.4184,0.91496 z m 4.3333,-4.41496 c 0.6637,-0.73333 1.3567,-1.33333 1.54,-1.33333 0.1833,0 -0.2097,0.6 -0.8733,1.33333 -0.6637,0.73333 -1.3567,1.33333 -1.54,1.33333 -0.1834,0 0.2096,-0.6 0.8733,-1.33333 z m 52.9495,-1.83333 -1.6162,-1.83334 1.8334,1.61621 c 1.0083,0.88892 1.8333,1.71392 1.8333,1.83333 0,0.52286 -0.5399,0.0973 -2.0505,-1.6162 z m 5.356,-1 c 1.6346,-1.74167 3.0596,-3.16667 3.1666,-3.16667 0.5006,0 -0.029,0.59855 -2.9721,3.36119 L 1673.6666,209 Z M 871.87499,199.5446 c 0.48126,-0.19258 1.05626,-0.1689 1.2778,0.0526 0.22153,0.22152 -0.17227,0.37909 -0.875,0.35014 -0.77667,-0.032 -0.9346,-0.18996 -0.4028,-0.40277 z m 6.66666,0 c 0.48127,-0.19258 1.05627,-0.1689 1.2778,0.0526 0.22154,0.22152 -0.17226,0.37909 -0.875,0.35014 -0.77666,-0.032 -0.9346,-0.18996 -0.4028,-0.40277 z m 311.33335,0 c 0.4812,-0.19258 1.0562,-0.1689 1.2778,0.0526 0.2215,0.22152 -0.1723,0.37909 -0.875,0.35014 -0.7767,-0.032 -0.9346,-0.18996 -0.4028,-0.40277 z m 6.6666,0 c 0.4813,-0.19258 1.0563,-0.1689 1.2778,0.0526 0.2216,0.22152 -0.1722,0.37909 -0.875,0.35014 -0.7766,-0.032 -0.9346,-0.18996 -0.4028,-0.40277 z m 220.625,-0.65278 c 0.4584,-0.18494 1.2084,-0.18494 1.6667,0 0.4583,0.18494 0.083,0.33626 -0.8333,0.33626 -0.9167,0 -1.2917,-0.15132 -0.8334,-0.33626 z m 388.346,-0.0205 c 0.6487,-0.16903 1.5487,-0.15791 2,0.0247 0.4514,0.18262 -0.079,0.32092 -1.1793,0.30733 -1.1,-0.0136 -1.4693,-0.163 -0.8207,-0.33203 z m -108.1934,-14.36827 4.9746,-5.16359 -3.639,-3.83641 -3.6391,-3.8364 3.9858,3.83426 3.9859,3.83428 -5.3214,5.16572 -5.3213,5.16574 z M 554.98537,130.33334 c 5e-5,-31.533338 0.0816,-44.335819 0.18114,-28.44996 0.0996,15.88586 0.0995,41.68586 -8e-5,57.33334 -0.0996,15.64747 -0.1811,2.64995 -0.18106,-28.88338 z m 132.00002,0 c 0,-31.533338 0.0815,-44.335819 0.18113,-28.44996 0.0995,15.88586 0.0995,41.68586 -6e-5,57.33334 -0.0997,15.64747 -0.18114,2.64995 -0.18107,-28.88338 z m 1429.68121,52 c 0.8612,-0.91667 1.7158,-1.66667 1.8991,-1.66667 0.1833,0 -0.3713,0.75 -1.2324,1.66667 -0.8611,0.91666 -1.7157,1.66666 -1.8991,1.66666 -0.1833,0 0.3713,-0.75 1.2324,-1.66666 z m 115.6034,-0.5 -1.27,-1.5 1.5,1.26999 c 1.4096,1.19348 1.8034,1.73001 1.27,1.73001 -0.1266,0 -0.8016,-0.675 -1.5,-1.5 z m -627.48,-11 c 0.124,-9.89141 0.3718,-8.71057 0.6996,3.33482 0.097,3.57583 -0.048,6.50083 -0.323,6.5 -0.275,-6.6e-4 -0.4445,-4.42649 -0.3766,-9.83482 z m 515.21,8.24829 c 0,-0.13843 0.525,-0.66343 1.1666,-1.16667 1.0574,-0.82924 1.081,-0.80566 0.2518,0.25171 -0.871,1.1105 -1.4184,1.46365 -1.4184,0.91496 z m -500,-12.70138 c 0,-0.18333 0.6,-0.65445 1.3333,-1.04691 0.7333,-0.39247 1.3333,-0.56358 1.3333,-0.38025 0,0.18333 -0.6,0.65445 -1.3333,1.04691 -0.7333,0.39247 -1.3333,0.56358 -1.3333,0.38025 z m 21.875,-8.16899 c 0.4812,-0.19258 1.0562,-0.1689 1.2778,0.0526 0.2215,0.22153 -0.1723,0.3791 -0.875,0.35015 -0.7767,-0.032 -0.9346,-0.18996 -0.4028,-0.40277 z m 4.971,-0.67325 c 0.6486,-0.16903 1.5486,-0.15791 2,0.0247 0.4514,0.18262 -0.079,0.32092 -1.1794,0.30733 -1.1,-0.0136 -1.4692,-0.163 -0.8206,-0.33203 z m 14.3623,0.007 c 0.4813,-0.19258 1.0563,-0.1689 1.2778,0.0526 0.2215,0.22152 -0.1723,0.37909 -0.875,0.35014 -0.7767,-0.032 -0.9346,-0.18996 -0.4028,-0.40277 z",
																			),
																		]),
																	]),
																]),
															]),
															Type.list([]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n    "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("path"),
															Type.list([
																Type.tuple([
																	Type.bitstring("fill"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("#a88bfa"),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.bitstring("stroke-width"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("0.666667"),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.bitstring("d"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring(
																				"m 73.644699,390.00001 c 0,-20.35 0.08469,-28.675 0.188193,-18.5 0.103507,10.175 0.103507,26.825 0,37 -0.103506,10.175 -0.188193,1.85 -0.188193,-18.5 z m 260.666661,0 c 0,-20.35 0.0847,-28.675 0.1882,-18.5 0.1035,10.175 0.1035,26.825 0,37 -0.10351,10.175 -0.1882,1.85 -0.1882,-18.5 z m 531.56363,-33.12208 c 0.48126,-0.19258 1.05626,-0.1689 1.2778,0.0526 0.22153,0.22153 -0.17227,0.3791 -0.875,0.35015 -0.77667,-0.032 -0.9346,-0.18996 -0.4028,-0.40277 z m 318.00001,0 c 0.4812,-0.19258 1.0562,-0.1689 1.2778,0.0526 0.2215,0.22153 -0.1723,0.3791 -0.875,0.35015 -0.7767,-0.032 -0.9346,-0.18996 -0.4028,-0.40277 z m 607.3333,0 c 0.4813,-0.19258 1.0563,-0.1689 1.2778,0.0526 0.2215,0.22153 -0.1723,0.3791 -0.875,0.35015 -0.7767,-0.032 -0.9346,-0.18996 -0.4028,-0.40277 z m 14.3043,-0.007 c 0.6487,-0.16903 1.5487,-0.15792 2,0.0247 0.4514,0.18262 -0.079,0.32091 -1.1793,0.30733 -1.1,-0.0136 -1.4693,-0.163 -0.8207,-0.33203 z m -38.2644,-56.7046 c -0.8292,-1.05737 -0.8056,-1.08095 0.2518,-0.25171 1.1104,0.87092 1.4636,1.41838 0.9149,1.41838 -0.1384,0 -0.6634,-0.525 -1.1667,-1.16667 z m 92.8044,-42.55555 c 0.032,-0.77664 0.19,-0.9346 0.4028,-0.40278 0.1926,0.48124 0.1689,1.05625 -0.053,1.27778 -0.2215,0.22152 -0.3791,-0.17223 -0.3502,-0.875 z M 869.87499,199.5446 c 0.48126,-0.19258 1.05626,-0.1689 1.2778,0.0526 0.22153,0.22152 -0.17227,0.37909 -0.875,0.35014 -0.77667,-0.032 -0.9346,-0.18996 -0.4028,-0.40277 z m 10.66666,0 c 0.48127,-0.19258 1.05627,-0.1689 1.2778,0.0526 0.22154,0.22152 -0.17226,0.37909 -0.875,0.35014 -0.77666,-0.032 -0.9346,-0.18996 -0.4028,-0.40277 z m 307.33335,0 c 0.4812,-0.19258 1.0562,-0.1689 1.2778,0.0526 0.2215,0.22152 -0.1723,0.37909 -0.875,0.35014 -0.7767,-0.032 -0.9346,-0.18996 -0.4028,-0.40277 z m 10.6666,0 c 0.4813,-0.19258 1.0563,-0.1689 1.2778,0.0526 0.2216,0.22152 -0.1722,0.37909 -0.875,0.35014 -0.7766,-0.032 -0.9346,-0.18996 -0.4028,-0.40277 z M 1801.5,198.87378 c 0.6416,-0.16768 1.6916,-0.16768 2.3333,0 0.6417,0.16769 0.1167,0.30489 -1.1667,0.30489 -1.2833,0 -1.8083,-0.1372 -1.1666,-0.30489 z m 7.0416,0.004 c 0.4813,-0.19258 1.0563,-0.1689 1.2778,0.0526 0.2216,0.22153 -0.1722,0.3791 -0.875,0.35015 -0.7766,-0.032 -0.9346,-0.18996 -0.4028,-0.40277 z m -73.2083,-15.12948 c 0,-0.13844 0.525,-0.66344 1.1667,-1.16667 1.0574,-0.82925 1.0809,-0.80567 0.2517,0.25171 -0.8709,1.1105 -1.4184,1.46365 -1.4184,0.91496 z m -320.125,-26.2037 c 0.4813,-0.19258 1.0563,-0.1689 1.2778,0.0526 0.2215,0.22152 -0.1723,0.37909 -0.875,0.35014 -0.7767,-0.032 -0.9346,-0.18996 -0.4028,-0.40277 z",
																			),
																		]),
																	]),
																]),
															]),
															Type.list([]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n    "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("path"),
															Type.list([
																Type.tuple([
																	Type.bitstring("fill"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("#a88bfa"),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.bitstring("stroke-width"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("0.666667"),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.bitstring("d"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring(
																				"M 73.999999,390.00001 V 353.33334 H 204 334 v 36.66667 36.66666 H 204 73.999999 Z m 1253.248201,13.5 c -0.8292,-1.05738 -0.8056,-1.08096 0.2518,-0.25171 0.6416,0.50323 1.1666,1.02823 1.1666,1.16667 0,0.54869 -0.5474,0.19554 -1.4184,-0.91496 z M 868.50779,356.86183 c 0.82926,-0.15946 2.02926,-0.1534 2.66666,0.0135 0.63734,0.16686 -0.0413,0.29733 -1.5078,0.28993 -1.46666,-0.007 -1.9882,-0.14392 -1.15886,-0.30338 z m 12,0 c 0.82926,-0.15946 2.02926,-0.1534 2.66666,0.0135 0.63734,0.16686 -0.0413,0.29733 -1.5078,0.28993 -1.46666,-0.007 -1.9882,-0.14392 -1.15886,-0.30338 z m 306.00001,0 c 0.8292,-0.15946 2.0292,-0.1534 2.6666,0.0135 0.6374,0.16686 -0.041,0.29733 -1.5078,0.28993 -1.4666,-0.007 -1.9882,-0.14392 -1.1588,-0.30338 z m 12,0 c 0.8292,-0.15946 2.0292,-0.1534 2.6666,0.0135 0.6374,0.16686 -0.041,0.29733 -1.5078,0.28993 -1.4666,-0.007 -1.9882,-0.14392 -1.1588,-0.30338 z m 595.0048,0.01 c 0.6487,-0.16903 1.5487,-0.15792 2,0.0247 0.4514,0.18262 -0.079,0.32091 -1.1793,0.30733 -1.1,-0.0136 -1.4693,-0.163 -0.8207,-0.33203 z m 8.6667,0 c 0.6487,-0.16903 1.5487,-0.15792 2,0.0247 0.4514,0.18262 -0.079,0.32091 -1.1793,0.30733 -1.1,-0.0136 -1.4693,-0.163 -0.8207,-0.33203 z M 102.33333,176.63579 C 46.599999,80.187008 0.89999999,0.98763928 0.77777779,0.63718663 0.63679999,0.23295544 74.934846,0 204,0 334.70268,0 407.36498,0.23048938 407.22221,0.64463362 406.7545,2.0013994 204.31634,351.99993 204.00007,351.99861 203.8167,351.99783 158.06666,273.08457 102.33333,176.63579 Z M 242.7665,139.96788 281.19966,73.333334 h -77.19932 -77.19932 l 38.43282,66.638126 c 21.13805,36.65098 38.58282,66.63652 38.76616,66.63454 0.18333,-0.002 17.62826,-29.98913 38.7665,-66.63812 z M 775.46326,257 c 0.0133,-1.1 0.163,-1.46929 0.33206,-0.82064 0.169,0.64864 0.15794,1.54864 -0.0247,2 -0.1826,0.45135 -0.32087,-0.0794 -0.30734,-1.17936 z m 318.00004,0 c 0.013,-1.1 0.163,-1.46929 0.332,-0.82064 0.169,0.64864 0.158,1.54864 -0.025,2 -0.1826,0.45135 -0.3209,-0.0794 -0.3074,-1.17936 z M 1810.5,198.89182 c 0.4583,-0.18494 1.2083,-0.18494 1.6666,0 0.4584,0.18494 0.083,0.33626 -0.8333,0.33626 -0.9167,0 -1.2917,-0.15132 -0.8333,-0.33626 z M 885.87499,158.21126 c 0.48126,-0.19258 1.05626,-0.1689 1.2778,0.0526 0.22153,0.22153 -0.17227,0.3791 -0.875,0.35015 -0.77667,-0.032 -0.9346,-0.18996 -0.4028,-0.40277 z m 318.00001,0 c 0.4812,-0.19258 1.0562,-0.1689 1.2778,0.0526 0.2215,0.22153 -0.1723,0.3791 -0.875,0.35015 -0.7767,-0.032 -0.9346,-0.18996 -0.4028,-0.40277 z",
																			),
																		]),
																	]),
																]),
															]),
															Type.list([]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n    "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("path"),
															Type.list([
																Type.tuple([
																	Type.bitstring("fill"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("#a88bfa"),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.bitstring("stroke-width"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("0.666667"),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.bitstring("d"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring(
																				"m 873.84525,356.85019 c 1.19827,-0.14838 2.99827,-0.14532 4,0.007 1.0018,0.15212 0.0213,0.27351 -2.1786,0.26977 -2.2,-0.004 -3.0196,-0.1282 -1.8214,-0.27657 z m 317.99995,0 c 1.1983,-0.14838 2.9983,-0.14532 4,0.007 1.0018,0.15212 0.021,0.27351 -2.1786,0.26977 -2.2,-0.004 -3.0196,-0.1282 -1.8214,-0.27657 z m 605.3214,0.0127 c 0.825,-0.1589 2.175,-0.1589 3,0 0.825,0.1589 0.15,0.28892 -1.5,0.28892 -1.65,0 -2.325,-0.13002 -1.5,-0.28892 z m 153.1578,-99.52951 c 0,-52.98334 0.079,-74.65834 0.1755,-48.16667 0.096,26.49167 0.096,69.84167 0,96.33333 -0.097,26.49167 -0.1755,4.81667 -0.1755,-48.16666 z m 171.3278,38.33333 c -1e-4,-31.9 0.081,-45.04755 0.1809,-29.21677 0.1,15.83077 0.1,41.93077 1e-4,58 -0.1,16.06923 -0.181,3.11677 -0.181,-28.78323 z m -264.054,47 c 0,-5.31666 0.1036,-7.49166 0.2301,-4.83333 0.1265,2.65833 0.1265,7.00833 0,9.66667 -0.1265,2.65833 -0.2301,0.48333 -0.2301,-4.83334 z m -389.3254,-7.66666 c 0,-6.23334 0.099,-8.87307 0.2226,-5.86607 0.1233,3.00699 0.1239,8.10699 0,11.33333 -0.1224,3.22634 -0.2233,0.76607 -0.224,-5.46726 z m -492.88688,-68.0556 c 0.032,-0.77663 0.19,-0.9346 0.4028,-0.40278 0.1926,0.48125 0.16893,1.05625 -0.0527,1.27778 -0.22153,0.22153 -0.37913,-0.17223 -0.3502,-0.875 z m 317.99998,0 c 0.032,-0.77663 0.19,-0.9346 0.4028,-0.40278 0.1926,0.48125 0.1689,1.05625 -0.053,1.27778 -0.2215,0.22153 -0.3791,-0.17223 -0.3502,-0.875 z m 566.7193,-5.61111 c 0,-0.91667 0.1514,-1.29167 0.3363,-0.83334 0.1849,0.45834 0.1849,1.20834 0,1.66667 -0.1849,0.45833 -0.3363,0.0833 -0.3363,-0.83333 z m -154.0526,-3.72222 c 0.032,-0.77664 0.19,-0.9346 0.4028,-0.40278 0.1926,0.48124 0.1689,1.05625 -0.053,1.27778 -0.2215,0.22152 -0.3791,-0.17223 -0.3502,-0.875 z m -885.94735,-0.94445 c 0,-0.91667 0.15134,-1.29167 0.33627,-0.83333 0.18493,0.45833 0.18493,1.20833 0,1.66666 -0.18493,0.45834 -0.33627,0.0833 -0.33627,-0.83333 z m 155.94734,0.27778 c 0.032,-0.77663 0.19,-0.9346 0.4028,-0.40278 0.1926,0.48125 0.16893,1.05625 -0.0527,1.27778 -0.22153,0.22153 -0.37913,-0.17223 -0.3502,-0.875 z m 162.05261,-0.27778 c 0,-0.91667 0.1514,-1.29167 0.3363,-0.83333 0.1849,0.45833 0.1849,1.20833 0,1.66666 -0.1849,0.45834 -0.3363,0.0833 -0.3363,-0.83333 z m 155.9474,0.27778 c 0.032,-0.77663 0.19,-0.9346 0.4028,-0.40278 0.1926,0.48125 0.1689,1.05625 -0.053,1.27778 -0.2215,0.22153 -0.3791,-0.17223 -0.3502,-0.875 z m 69.386,-3.61111 c 0,-0.91667 0.1513,-1.29167 0.3362,-0.83334 0.185,0.45834 0.185,1.20834 0,1.66667 -0.1849,0.45833 -0.3362,0.0833 -0.3362,-0.83333 z m -388.05268,-5.72222 c 0.032,-0.77664 0.19,-0.9346 0.4028,-0.40278 0.1926,0.48124 0.16893,1.05625 -0.0527,1.27778 -0.22153,0.22152 -0.37913,-0.17223 -0.3502,-0.875 z m 317.99998,0 c 0.032,-0.77664 0.19,-0.9346 0.4028,-0.40278 0.1926,0.48124 0.1689,1.05625 -0.053,1.27778 -0.2215,0.22152 -0.3791,-0.17223 -0.3502,-0.875 z M 1604.7966,241 c 0.013,-1.1 0.163,-1.46929 0.332,-0.82064 0.169,0.64864 0.158,1.54864 -0.025,2 -0.1826,0.45135 -0.3209,-0.0794 -0.3074,-1.17936 z M 1646.5,198.22515 c 0.4583,-0.18494 1.2083,-0.18494 1.6666,0 0.4584,0.18494 0.083,0.33626 -0.8333,0.33626 -0.9167,0 -1.2917,-0.15132 -0.8333,-0.33626 z m 42.5,-5.55848 c 1.8057,-1.83333 3.4332,-3.33333 3.6165,-3.33333 0.1833,0 -1.1441,1.5 -2.9499,3.33333 -1.8057,1.83333 -3.4332,3.33333 -3.6165,3.33333 -0.1833,0 1.1441,-1.5 2.9499,-3.33333 z m -220.7302,-21 c 0,-5.86667 0.1028,-8.17742 0.2267,-5.13501 0.1238,3.04241 0.1231,7.84241 0,10.66666 -0.1247,2.82426 -0.226,0.33502 -0.2251,-5.53165 z m 389.061,0.80217 0.3308,-9.46884 0.1893,8.94653 c 0.1041,4.92059 -0.045,9.18157 -0.3308,9.46883 -0.2861,0.28728 -0.3713,-3.73866 -0.1893,-8.94652 z m -243.6642,-1.1355 c 0.6637,-0.73334 1.3567,-1.33334 1.54,-1.33334 0.1834,0 -0.2096,0.6 -0.8733,1.33334 -0.6637,0.73333 -1.3567,1.33333 -1.54,1.33333 -0.1833,0 0.2097,-0.6 0.8733,-1.33333 z m 36.5,-13.79289 c 0.6417,-0.16768 1.6917,-0.16768 2.3334,0 0.6416,0.16769 0.1166,0.30489 -1.1667,0.30489 -1.2833,0 -1.8083,-0.1372 -1.1667,-0.30489 z m 7.3334,0 c 0.6416,-0.16768 1.6916,-0.16768 2.3333,0 0.6417,0.16769 0.1167,0.30489 -1.1667,0.30489 -1.2833,0 -1.8083,-0.1372 -1.1666,-0.30489 z",
																			),
																		]),
																	]),
																]),
															]),
															Type.list([]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n    "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("path"),
															Type.list([
																Type.tuple([
																	Type.bitstring("fill"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("currentColor"),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.bitstring("stroke-width"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("0.666667"),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.bitstring("d"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring(
																				"m 1404,436.88977 c -22.2484,-1.12674 -41.1478,-6.83471 -57.1424,-17.25802 -10.2486,-6.6788 -16.3781,-12.30241 -23.4446,-21.50984 l -2.2537,-2.93642 14.2403,-14.2518 14.2402,-14.25179 5.0134,5.45206 c 15.2903,16.62808 34.6407,23.98841 60.4892,23.00835 12.002,-0.45506 18.6888,-1.97412 27.4918,-6.24537 5.2978,-2.57057 7.21,-3.97307 12.012,-8.81042 11.04,-11.12145 14.065,-21.22959 13.9914,-46.75318 l -0.028,-9.66667 -2.4715,2.71271 c -11.3332,12.43891 -29.8179,20.75421 -49.4767,22.25699 -7.1266,0.54479 -18.2426,0.0884 -24.4206,-1.00272 -13.9722,-2.46759 -29.106,-9.70369 -40.47,-19.35034 -12.3886,-10.51654 -22.0808,-25.06657 -27.4328,-41.18243 -12.0546,-36.29866 -3.9328,-76.74273 20.5288,-102.22826 18.9166,-19.7084 44.1708,-29.12398 72.026,-26.85362 19.4097,1.58202 34.5938,7.93587 47.0536,19.6898 l 4.7201,4.45271 v -10.41409 -10.41408 h 21.6915 21.6916 l -0.2385,98.5 c -0.263,108.62298 0,101.78985 -4.4863,115.52571 -9.5225,29.13994 -34.8143,51.05369 -67.6583,58.62165 -9.3823,2.1619 -25.1025,3.44407 -35.6667,2.90907 z m 29.0441,-130.90097 c 9.4384,-2.41377 15.8709,-5.98081 22.5353,-12.49662 10.5548,-10.31957 15.2508,-22.68494 15.2508,-40.15884 0,-17.4739 -4.696,-29.83928 -15.2508,-40.15885 -6.616,-6.46841 -12.9112,-9.97602 -22.5794,-12.58091 -7.6466,-2.06017 -23.004,-2.0625 -30.6667,-0.005 -18.1861,4.88392 -31.5185,17.70397 -36.2983,34.9032 -2.7768,9.99208 -2.9261,23.9342 -0.3652,34.10688 5.1136,20.313 21.5384,34.70942 43.0372,37.72247 6.3206,0.88583 18.2075,0.23491 24.3371,-1.33267 z m -577.04411,49.32639 c -25.8522,-4.97934 -49.1264,-20.7156 -63.9,-43.20441 -7.73873,-11.78008 -11.7556,-21.5268 -14.47013,-35.11078 -2.15287,-10.7731 -2.27467,-27.11191 -0.2862,-38.3834 5.33033,-30.21406 24.85833,-56.0464 53.02333,-70.14099 12.5386,-6.27469 20.991,-8.61586 36.29966,-10.05439 14.52854,-1.36522 30.36067,0.50836 43.66667,5.16753 14.8878,5.21305 26.3608,12.36535 36.96873,23.04645 14.01974,14.11636 23.19647,31.3837 27.12087,51.03147 1.7052,8.53737 1.69933,30.84651 -0.01,39.33333 -2.5442,12.62962 -8.08947,25.58837 -15.9754,37.33286 -7.9622,11.85813 -23.7724,25.64607 -37.10387,32.35807 -6.89386,3.47086 -18.38313,7.2494 -26.33333,8.66041 -9.9324,1.76282 -29.75533,1.74444 -39,-0.0361 z m 30.56866,-41.39573 c 17.32354,-2.49212 31.86834,-13.64437 39.45574,-30.25279 1.94453,-4.25653 3.30633,-8.78543 4.6392,-15.42876 1.12573,-5.61085 0.5392,-21.85344 -0.9956,-27.57124 -4.2994,-16.01675 -15.46587,-29.45725 -30.36034,-36.54302 -5.54106,-2.63607 -13.208,-4.26754 -21.641,-4.60508 -7.1106,-0.28461 -8.81526,-0.1191 -15.33333,1.48873 -4.03333,0.9949 -9.13333,2.71634 -11.33333,3.82539 -17.7522,8.94917 -28.41654,24.92603 -30.2328,45.29349 -3.10707,34.84302 17.45206,61.64713 49.43053,64.4454 6.00933,0.52584 9.01473,0.40613 16.37093,-0.65212 z M 1174,355.31519 c -25.8522,-4.97934 -49.1264,-20.7156 -63.9,-43.20441 -7.7387,-11.78008 -11.7556,-21.5268 -14.4701,-35.11078 -2.1529,-10.7731 -2.2747,-27.11191 -0.2862,-38.3834 5.3303,-30.21406 24.8583,-56.0464 53.0233,-70.14099 12.5386,-6.27469 20.991,-8.61586 36.2996,-10.05439 14.5286,-1.36522 30.3607,0.50836 43.6667,5.16753 14.8878,5.21305 26.3608,12.36535 36.9687,23.04645 14.0198,14.11636 23.1965,31.3837 27.1209,51.03147 1.7052,8.53737 1.6993,30.84651 -0.01,39.33333 -2.5442,12.62962 -8.0895,25.58837 -15.9754,37.33286 -7.9622,11.85813 -23.7724,25.64607 -37.1039,32.35807 -6.8938,3.47086 -18.3831,7.2494 -26.3333,8.66041 -9.9324,1.76282 -29.7553,1.74444 -39,-0.0361 z m 30.5686,-41.39573 c 17.3236,-2.49212 31.8684,-13.64437 39.4558,-30.25279 1.9445,-4.25653 3.3063,-8.78543 4.6392,-15.42876 1.1257,-5.61085 0.5392,-21.85344 -0.9956,-27.57124 -4.2994,-16.01675 -15.4659,-29.45725 -30.3604,-36.54302 -5.541,-2.63607 -13.208,-4.26754 -21.641,-4.60508 -7.1106,-0.28461 -8.8152,-0.1191 -15.3333,1.48873 -4.0333,0.9949 -9.1333,2.71634 -11.3333,3.82539 -17.7522,8.94917 -28.4166,24.92603 -30.2328,45.29349 -3.1071,34.84302 17.452,61.64713 49.4305,64.4454 6.0093,0.52584 9.0147,0.40613 16.3709,-0.65212 z M 1781,355.35595 c -32.389,-6.3495 -59.3656,-31.60378 -69.7484,-65.29517 -3.5918,-11.65522 -4.8672,-22.5852 -4.3244,-37.06078 0.6149,-16.40274 3.2332,-28.06354 9.1503,-40.75228 9.1212,-19.55962 22.6771,-34.24072 40.5891,-43.95834 10.9482,-5.93958 19.5269,-8.52489 32.9956,-9.94368 13.9591,-1.47046 24.7479,-0.1847 39.5375,4.71191 7.4423,2.46405 18.9121,10.08613 25.2743,16.79566 1.1774,1.24165 2.4662,2.05638 2.864,1.81049 0.4724,-0.29192 0.6888,-3.68829 0.6238,-9.78658 -0.055,-5.13672 0.1758,-9.61484 0.5124,-9.95134 0.353,-0.35303 9.4768,-0.53725 21.5688,-0.43551 l 20.957,0.17634 v 95.66667 95.66667 h -21.5682 -21.5681 l 0.098,-9.77542 c 0.054,-5.37648 -0.1579,-9.93364 -0.4707,-10.12702 -0.313,-0.19338 -2.3998,1.37976 -4.6374,3.49587 -10.1664,9.61417 -22.2762,15.80328 -36.7606,18.78756 -8.3146,1.71311 -26.2923,1.70027 -35.0932,-0.0251 z m 38.3333,-40.82107 c 4.9762,-0.9812 14.7783,-5.65908 19.7419,-9.42146 11.1727,-8.46878 18.1751,-21.51582 20.656,-38.4867 0.945,-6.46366 0.9876,-8.65766 0.3016,-15.50846 -2.2508,-22.47497 -11.0792,-36.52501 -29.5214,-46.98208 -5.4124,-3.0689 -16.4812,-5.47048 -25.1781,-5.46288 -6.2927,0.005 -16.0478,1.93602 -21.6851,4.29143 -4.5611,1.90577 -12.0644,7.23593 -16.1467,11.47036 -10.6693,11.06674 -15.3443,22.7096 -15.9939,39.83276 -0.459,12.09797 0.9472,20.52375 4.9459,29.63557 8.0397,18.3197 24.5347,30.14076 44.2131,31.68497 4.3992,0.34521 14.4498,-0.22203 18.6667,-1.05351 z M 509.33333,213.33334 V 73.333334 h 22.66666 22.66667 v 57.000006 57 h 66.33333 66.33333 v -57 -57.000006 h 22.66667 22.66667 v 140.000006 140 h -22.66667 -22.66667 v -62 -62 h -66.33333 -66.33333 v 62 62 h -22.66667 -22.66666 z m 503.99997,-4 V 65.333334 H 1035 h 21.6667 v 144.000006 144 H 1035 1013.3333 Z m 548,48 v -96 h 21.6493 21.6493 l 0.1841,10.13989 0.184,10.13989 2.8718,-3.63989 c 6.5988,-8.36375 16.8484,-15.05794 27.4701,-17.94115 14.9055,-4.04603 35.3902,-2.41311 47.6476,3.7982 4.4535,2.25679 11.9221,7.9011 15.9447,12.05014 l 3.2676,3.37028 -14.1879,14.68809 -14.1879,14.68809 -2.997,-2.6381 c -3.4507,-3.03742 -8.554,-5.61565 -13.2392,-6.68867 -4.7521,-1.0883 -17.1765,-0.89339 -21.9232,0.34393 -13.046,3.4007 -23.1508,12.30245 -27.4688,24.19844 -3.3539,9.23973 -3.523,12.75512 -3.5272,73.32419 v 56.16667 H 1583 1561.3333 Z m 389.3333,0 v -96 H 1972.3333 1994 v 10.11926 10.11927 l 2.8369,-2.9526 c 13.9498,-14.51845 37.2173,-22.60547 59.3297,-20.62103 10.8084,0.96998 17.0156,2.5793 26.6024,6.89718 9.5295,4.29206 20.3123,13.13442 25.5763,20.97369 l 2.8219,4.20243 2.4432,-3.3283 c 3.5142,-4.78726 11.6634,-12.18086 18.092,-16.41444 14.3769,-9.46786 32.1435,-13.81661 50.2976,-12.31132 8.513,0.70587 10.2227,1.01582 16.897,3.06325 22.5958,6.93145 39.179,22.41851 46.3192,43.25749 1.1298,3.29731 2.4096,7.79512 2.844,9.99512 0.5652,2.86183 0.8694,23.20659 1.0691,71.5 l 0.2791,67.5 h -22.0376 -22.0375 l -0.023,-60.5 c -0.026,-67.02155 0.08,-65.22766 -4.3678,-73.99027 -2.9213,-5.75545 -9.3682,-12.1297 -15.6591,-15.48274 -10.9113,-5.81567 -27.352,-6.42714 -39.7097,-1.47691 -11.0764,4.43695 -19.6206,14.04817 -22.6798,25.51196 -1.0266,3.84676 -1.1643,10.31769 -1.3854,65.10462 l -0.2456,60.83334 H 2099.6313 2078 v -59.27469 c 0,-62.44291 -0.088,-64.51342 -3.0538,-72.05865 -4.2242,-10.74518 -15.4984,-19.84762 -27.7587,-22.41147 -7.0085,-1.46561 -17.6979,-1.28064 -23.7399,0.41079 -12.0932,3.38543 -21.1736,10.74982 -25.8503,20.96491 -3.5675,7.79243 -3.5732,7.90808 -3.5857,72.53577 L 1994,353.33334 h -21.6667 -21.6667 z",
																			),
																		]),
																	]),
																]),
															]),
															Type.list([]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n  "),
														]),
													]),
												]),
												Type.tuple([Type.atom("text"), Type.bitstring("\n")]),
											]),
										]),
									]);
								},
							},
						],
						context,
					);
					Interpreter.updateVarsToMatchedValues(context);
					return globalThis.hologram.return;
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"HologramWebsite.Components.Nav",
		"__props__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Elixir_Enum["reverse/1"](
						Type.list([
							Type.tuple([
								Type.atom("class"),
								Type.atom("string"),
								Type.list([]),
							]),
						]),
					);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"HologramWebsite.Components.Nav",
		"template",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					globalThis.hologram.return = Type.anonymousFunction(
						1,
						[
							{
								params: (context) => [Type.variablePattern("vars_0")],
								guards: [],
								body: (context) => {
									Interpreter.matchOperator(
										context.vars.vars_0,
										Type.matchPlaceholder(),
										context,
									);
									Interpreter.updateVarsToMatchedValues(context);
									return Type.list([
										Type.tuple([
											Type.atom("element"),
											Type.bitstring("nav"),
											Type.list([
												Type.tuple([
													Type.bitstring("class"),
													Type.list([
														Type.tuple([
															Type.atom("expression"),
															Type.tuple([
																Interpreter.dotOperator(
																	context.vars.vars_0,
																	Type.atom("class"),
																),
															]),
														]),
													]),
												]),
											]),
											Type.list([
												Type.tuple([Type.atom("text"), Type.bitstring("\n  ")]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("div"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("px-4 sm:px-6 pt-14 lg:pt-16"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n    "),
														]),
														Type.tuple([
															Type.atom("component"),
															Type.atom(
																"Elixir.HologramWebsite.Components.Nav.Group",
															),
															Type.list([
																Type.tuple([
																	Type.bitstring("heading"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("Guides"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("\n      "),
																]),
																Type.tuple([
																	Type.atom("component"),
																	Type.atom(
																		"Elixir.HologramWebsite.Components.Nav.Item",
																	),
																	Type.list([
																		Type.tuple([
																			Type.bitstring("page"),
																			Type.list([
																				Type.tuple([
																					Type.atom("expression"),
																					Type.tuple([
																						Type.atom(
																							"Elixir.HologramWebsite.IntroductionPage",
																						),
																					]),
																				]),
																			]),
																		]),
																	]),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("Introduction"),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("\n      "),
																]),
																Type.tuple([
																	Type.atom("component"),
																	Type.atom(
																		"Elixir.HologramWebsite.Components.Nav.Item",
																	),
																	Type.list([
																		Type.tuple([
																			Type.bitstring("page"),
																			Type.list([
																				Type.tuple([
																					Type.atom("expression"),
																					Type.tuple([
																						Type.atom(
																							"Elixir.HologramWebsite.InstallationPage",
																						),
																					]),
																				]),
																			]),
																		]),
																	]),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("Installation"),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("\n      "),
																]),
																Type.tuple([
																	Type.atom("component"),
																	Type.atom(
																		"Elixir.HologramWebsite.Components.Nav.Item",
																	),
																	Type.list([
																		Type.tuple([
																			Type.bitstring("page"),
																			Type.list([
																				Type.tuple([
																					Type.atom("expression"),
																					Type.tuple([
																						Type.atom(
																							"Elixir.HologramWebsite.QuickStartPage",
																						),
																					]),
																				]),
																			]),
																		]),
																	]),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("Quick Start"),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("\n    "),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n\n    "),
														]),
														Type.tuple([
															Type.atom("component"),
															Type.atom(
																"Elixir.HologramWebsite.Components.Nav.Group",
															),
															Type.list([
																Type.tuple([
																	Type.bitstring("heading"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("Documentation"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("\n      "),
																]),
																Type.tuple([
																	Type.atom("component"),
																	Type.atom(
																		"Elixir.HologramWebsite.Components.Nav.Item",
																	),
																	Type.list([
																		Type.tuple([
																			Type.bitstring("page"),
																			Type.list([
																				Type.tuple([
																					Type.atom("expression"),
																					Type.tuple([
																						Type.atom(
																							"Elixir.HologramWebsite.ArchitecturePage",
																						),
																					]),
																				]),
																			]),
																		]),
																	]),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("Architecture"),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("\n      "),
																]),
																Type.tuple([
																	Type.atom("component"),
																	Type.atom(
																		"Elixir.HologramWebsite.Components.Nav.Item",
																	),
																	Type.list([
																		Type.tuple([
																			Type.bitstring("page"),
																			Type.list([
																				Type.tuple([
																					Type.atom("expression"),
																					Type.tuple([
																						Type.atom(
																							"Elixir.HologramWebsite.PagesPage",
																						),
																					]),
																				]),
																			]),
																		]),
																	]),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("Pages"),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("\n      "),
																]),
																Type.tuple([
																	Type.atom("component"),
																	Type.atom(
																		"Elixir.HologramWebsite.Components.Nav.Item",
																	),
																	Type.list([
																		Type.tuple([
																			Type.bitstring("page"),
																			Type.list([
																				Type.tuple([
																					Type.atom("expression"),
																					Type.tuple([
																						Type.atom(
																							"Elixir.HologramWebsite.LayoutsPage",
																						),
																					]),
																				]),
																			]),
																		]),
																	]),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("Layouts"),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("\n      "),
																]),
																Type.tuple([
																	Type.atom("component"),
																	Type.atom(
																		"Elixir.HologramWebsite.Components.Nav.Item",
																	),
																	Type.list([
																		Type.tuple([
																			Type.bitstring("page"),
																			Type.list([
																				Type.tuple([
																					Type.atom("expression"),
																					Type.tuple([
																						Type.atom(
																							"Elixir.HologramWebsite.ComponentsPage",
																						),
																					]),
																				]),
																			]),
																		]),
																	]),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("Components"),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("\n      "),
																]),
																Type.tuple([
																	Type.atom("component"),
																	Type.atom(
																		"Elixir.HologramWebsite.Components.Nav.Item",
																	),
																	Type.list([
																		Type.tuple([
																			Type.bitstring("page"),
																			Type.list([
																				Type.tuple([
																					Type.atom("expression"),
																					Type.tuple([
																						Type.atom(
																							"Elixir.HologramWebsite.ContextPage",
																						),
																					]),
																				]),
																			]),
																		]),
																	]),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("Context"),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("\n      "),
																]),
																Type.tuple([
																	Type.atom("component"),
																	Type.atom(
																		"Elixir.HologramWebsite.Components.Nav.Item",
																	),
																	Type.list([
																		Type.tuple([
																			Type.bitstring("page"),
																			Type.list([
																				Type.tuple([
																					Type.atom("expression"),
																					Type.tuple([
																						Type.atom(
																							"Elixir.HologramWebsite.NavigationPage",
																						),
																					]),
																				]),
																			]),
																		]),
																	]),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("Navigation"),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("\n      "),
																]),
																Type.tuple([
																	Type.atom("component"),
																	Type.atom(
																		"Elixir.HologramWebsite.Components.Nav.Item",
																	),
																	Type.list([
																		Type.tuple([
																			Type.bitstring("page"),
																			Type.list([
																				Type.tuple([
																					Type.atom("expression"),
																					Type.tuple([
																						Type.atom(
																							"Elixir.HologramWebsite.TemplateSyntaxPage",
																						),
																					]),
																				]),
																			]),
																		]),
																	]),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("Template Syntax"),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("\n      "),
																]),
																Type.tuple([
																	Type.atom("component"),
																	Type.atom(
																		"Elixir.HologramWebsite.Components.Nav.Item",
																	),
																	Type.list([
																		Type.tuple([
																			Type.bitstring("page"),
																			Type.list([
																				Type.tuple([
																					Type.atom("expression"),
																					Type.tuple([
																						Type.atom(
																							"Elixir.HologramWebsite.ActionsPage",
																						),
																					]),
																				]),
																			]),
																		]),
																	]),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("Actions"),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("\n      "),
																]),
																Type.tuple([
																	Type.atom("component"),
																	Type.atom(
																		"Elixir.HologramWebsite.Components.Nav.Item",
																	),
																	Type.list([
																		Type.tuple([
																			Type.bitstring("page"),
																			Type.list([
																				Type.tuple([
																					Type.atom("expression"),
																					Type.tuple([
																						Type.atom(
																							"Elixir.HologramWebsite.CommandsPage",
																						),
																					]),
																				]),
																			]),
																		]),
																	]),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("Commands"),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("\n    "),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n    \n    "),
														]),
														Type.tuple([
															Type.atom("component"),
															Type.atom(
																"Elixir.HologramWebsite.Components.Nav.Group",
															),
															Type.list([
																Type.tuple([
																	Type.bitstring("heading"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("Resources"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("\n      "),
																]),
																Type.tuple([
																	Type.atom("component"),
																	Type.atom(
																		"Elixir.HologramWebsite.Components.Nav.Item",
																	),
																	Type.list([
																		Type.tuple([
																			Type.bitstring("page"),
																			Type.list([
																				Type.tuple([
																					Type.atom("expression"),
																					Type.tuple([
																						Type.atom(
																							"Elixir.HologramWebsite.RoadmapPage",
																						),
																					]),
																				]),
																			]),
																		]),
																	]),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("Roadmap"),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("\n    "),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n\n    "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("div"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("my-9"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("\n      "),
																]),
																Type.tuple([
																	Type.atom("component"),
																	Type.atom(
																		"Elixir.HologramWebsite.Components.GitHubStarButton",
																	),
																	Type.list([
																		Type.tuple([
																			Type.bitstring("size"),
																			Type.list([
																				Type.tuple([
																					Type.atom("expression"),
																					Type.tuple([Type.atom("small")]),
																				]),
																			]),
																		]),
																		Type.tuple([
																			Type.bitstring("class"),
																			Type.list([
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring("mr-2"),
																				]),
																			]),
																		]),
																	]),
																	Type.list([]),
																]),
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("\n      "),
																]),
																Type.tuple([
																	Type.atom("component"),
																	Type.atom(
																		"Elixir.HologramWebsite.Components.GitHubSponsorsButton",
																	),
																	Type.list([
																		Type.tuple([
																			Type.bitstring("size"),
																			Type.list([
																				Type.tuple([
																					Type.atom("expression"),
																					Type.tuple([Type.atom("small")]),
																				]),
																			]),
																		]),
																	]),
																	Type.list([]),
																]),
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("\n    "),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n  "),
														]),
													]),
												]),
												Type.tuple([Type.atom("text"), Type.bitstring("\n")]),
											]),
										]),
									]);
								},
							},
						],
						context,
					);
					Interpreter.updateVarsToMatchedValues(context);
					return globalThis.hologram.return;
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"HologramWebsite.Components.Nav.Group",
		"__props__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Elixir_Enum["reverse/1"](
						Type.list([
							Type.tuple([
								Type.atom("heading"),
								Type.atom("string"),
								Type.list([]),
							]),
						]),
					);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"HologramWebsite.Components.Nav.Group",
		"template",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					globalThis.hologram.return = Type.anonymousFunction(
						1,
						[
							{
								params: (context) => [Type.variablePattern("vars_0")],
								guards: [],
								body: (context) => {
									Interpreter.matchOperator(
										context.vars.vars_0,
										Type.matchPlaceholder(),
										context,
									);
									Interpreter.updateVarsToMatchedValues(context);
									return Type.list([
										Type.tuple([
											Type.atom("element"),
											Type.bitstring("div"),
											Type.list([
												Type.tuple([
													Type.bitstring("class"),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("mt-9"),
														]),
													]),
												]),
											]),
											Type.list([
												Type.tuple([Type.atom("text"), Type.bitstring("\n  ")]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("h2"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring(
																		"text-sm font-semibold text-[#737373]",
																	),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("expression"),
															Type.tuple([
																Interpreter.dotOperator(
																	context.vars.vars_0,
																	Type.atom("heading"),
																),
															]),
														]),
													]),
												]),
												Type.tuple([Type.atom("text"), Type.bitstring("\n  ")]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("ul"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring(
																		"ml-3 border-l border-[#262626]",
																	),
																]),
															]),
														]),
														Type.tuple([
															Type.bitstring("role"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("list"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n    "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("slot"),
															Type.list([]),
															Type.list([]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n  "),
														]),
													]),
												]),
												Type.tuple([Type.atom("text"), Type.bitstring("\n")]),
											]),
										]),
									]);
								},
							},
						],
						context,
					);
					Interpreter.updateVarsToMatchedValues(context);
					return globalThis.hologram.return;
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"HologramWebsite.Components.Nav.Item",
		"__props__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Elixir_Enum["reverse/1"](
						Type.list([
							Type.tuple([
								Type.atom("page"),
								Type.atom("module"),
								Type.list([]),
							]),
							Type.tuple([
								Type.atom("current_page"),
								Type.atom("module"),
								Type.list([
									Type.tuple([
										Type.atom("from_context"),
										Type.atom("current_page"),
									]),
								]),
							]),
						]),
					);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"HologramWebsite.Components.Nav.Item",
		"border_color",
		1,
		"public",
		[
			{
				params: (context) => [Type.atom("true")],
				guards: [],
				body: (context) => {
					return Type.bitstring("border-[#a78bfa]");
				},
			},
			{
				params: (context) => [Type.atom("false")],
				guards: [],
				body: (context) => {
					return Type.bitstring("border-transparent");
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"HologramWebsite.Components.Nav.Item",
		"template",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					globalThis.hologram.return = Type.anonymousFunction(
						1,
						[
							{
								params: (context) => [Type.variablePattern("vars_0")],
								guards: [],
								body: (context) => {
									Interpreter.matchOperator(
										context.vars.vars_0,
										Type.matchPlaceholder(),
										context,
									);
									Interpreter.updateVarsToMatchedValues(context);
									return Type.list([
										Type.tuple([
											Type.atom("element"),
											Type.bitstring("li"),
											Type.list([
												Type.tuple([
													Type.bitstring("class"),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("border-l "),
														]),
														Type.tuple([
															Type.atom("expression"),
															Type.tuple([
																Elixir_HologramWebsite_Components_Nav_Item[
																	"border_color/1"
																](
																	Erlang["==/2"](
																		Interpreter.dotOperator(
																			context.vars.vars_0,
																			Type.atom("page"),
																		),
																		Interpreter.dotOperator(
																			context.vars.vars_0,
																			Type.atom("current_page"),
																		),
																	),
																),
															]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring(" mt-3 -ml-px pl-5"),
														]),
													]),
												]),
											]),
											Type.list([
												Type.tuple([Type.atom("text"), Type.bitstring("\n  ")]),
												Type.tuple([
													Type.atom("component"),
													Type.atom("Elixir.Hologram.UI.Link"),
													Type.list([
														Type.tuple([
															Type.bitstring("to"),
															Type.list([
																Type.tuple([
																	Type.atom("expression"),
																	Type.tuple([
																		Interpreter.dotOperator(
																			context.vars.vars_0,
																			Type.atom("page"),
																		),
																	]),
																]),
															]),
														]),
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("text-md "),
																]),
																Type.tuple([
																	Type.atom("expression"),
																	Type.tuple([
																		Elixir_HologramWebsite_Components_Nav_Item[
																			"text_color/1"
																		](
																			Erlang["==/2"](
																				Interpreter.dotOperator(
																					context.vars.vars_0,
																					Type.atom("page"),
																				),
																				Interpreter.dotOperator(
																					context.vars.vars_0,
																					Type.atom("current_page"),
																				),
																			),
																		),
																	]),
																]),
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring(" hover:text-[#a78bfa]"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("slot"),
															Type.list([]),
															Type.list([]),
														]),
													]),
												]),
												Type.tuple([Type.atom("text"), Type.bitstring("\n")]),
											]),
										]),
									]);
								},
							},
						],
						context,
					);
					Interpreter.updateVarsToMatchedValues(context);
					return globalThis.hologram.return;
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"HologramWebsite.Components.Nav.Item",
		"text_color",
		1,
		"public",
		[
			{
				params: (context) => [Type.atom("true")],
				guards: [],
				body: (context) => {
					return Type.bitstring("text-[#a78bfa]");
				},
			},
			{
				params: (context) => [Type.atom("false")],
				guards: [],
				body: (context) => {
					return Type.bitstring("text-[#eeeeee]");
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"HologramWebsite.Components.Paragraph",
		"__props__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Elixir_Enum["reverse/1"](Type.list([]));
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"HologramWebsite.Components.Paragraph",
		"template",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					globalThis.hologram.return = Type.anonymousFunction(
						1,
						[
							{
								params: (context) => [Type.variablePattern("vars_0")],
								guards: [],
								body: (context) => {
									Interpreter.matchOperator(
										context.vars.vars_0,
										Type.matchPlaceholder(),
										context,
									);
									Interpreter.updateVarsToMatchedValues(context);
									return Type.list([
										Type.tuple([
											Type.atom("element"),
											Type.bitstring("p"),
											Type.list([
												Type.tuple([
													Type.bitstring("class"),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("text-base mt-5 text-neutral-300"),
														]),
													]),
												]),
											]),
											Type.list([
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("slot"),
													Type.list([]),
													Type.list([]),
												]),
											]),
										]),
									]);
								},
							},
						],
						context,
					);
					Interpreter.updateVarsToMatchedValues(context);
					return globalThis.hologram.return;
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"HologramWebsite.ComponentsPage",
		"__params__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Elixir_Enum["reverse/1"](Type.list([]));
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"HologramWebsite.ComponentsPage",
		"__route__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Type.bitstring("/docs/components");
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"HologramWebsite.ContextPage",
		"__params__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Elixir_Enum["reverse/1"](Type.list([]));
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"HologramWebsite.ContextPage",
		"__route__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Type.bitstring("/docs/context");
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"HologramWebsite.HomePage",
		"__params__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Elixir_Enum["reverse/1"](Type.list([]));
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"HologramWebsite.HomePage",
		"__route__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Type.bitstring("/");
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"HologramWebsite.InstallationPage",
		"__params__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Elixir_Enum["reverse/1"](Type.list([]));
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"HologramWebsite.InstallationPage",
		"__route__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Type.bitstring("/docs/installation");
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"HologramWebsite.IntroductionPage",
		"__params__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Elixir_Enum["reverse/1"](Type.list([]));
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"HologramWebsite.IntroductionPage",
		"__route__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Type.bitstring("/docs/introduction");
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"HologramWebsite.LayoutsPage",
		"__params__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Elixir_Enum["reverse/1"](Type.list([]));
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"HologramWebsite.LayoutsPage",
		"__route__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Type.bitstring("/docs/layouts");
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"HologramWebsite.NavigationPage",
		"__params__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Elixir_Enum["reverse/1"](Type.list([]));
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"HologramWebsite.NavigationPage",
		"__route__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Type.bitstring("/docs/navigation");
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"HologramWebsite.PagesPage",
		"__params__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Elixir_Enum["reverse/1"](Type.list([]));
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"HologramWebsite.PagesPage",
		"__route__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Type.bitstring("/docs/pages");
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"HologramWebsite.QuickStartPage",
		"__layout_module__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Type.atom("Elixir.HologramWebsite.Components.DocsLayout");
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"HologramWebsite.QuickStartPage",
		"__layout_props__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Type.list([
						Type.tuple([
							Type.atom("page_title"),
							Type.bitstring("Quick Start"),
						]),
					]);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"HologramWebsite.QuickStartPage",
		"__params__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Elixir_Enum["reverse/1"](Type.list([]));
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"HologramWebsite.QuickStartPage",
		"__route__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Type.bitstring("/docs/quick-start");
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"HologramWebsite.QuickStartPage",
		"template",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					globalThis.hologram.return = Type.anonymousFunction(
						1,
						[
							{
								params: (context) => [Type.variablePattern("vars_0")],
								guards: [],
								body: (context) => {
									Interpreter.matchOperator(
										context.vars.vars_0,
										Type.matchPlaceholder(),
										context,
									);
									Interpreter.updateVarsToMatchedValues(context);
									return Type.list([
										Type.tuple([
											Type.atom("component"),
											Type.atom("Elixir.HologramWebsite.Components.Heading1"),
											Type.list([]),
											Type.list([
												Type.tuple([
													Type.atom("text"),
													Type.bitstring("Quick Start Guide"),
												]),
											]),
										]),
										Type.tuple([Type.atom("text"), Type.bitstring("\n")]),
										Type.tuple([
											Type.atom("component"),
											Type.atom("Elixir.HologramWebsite.Components.Paragraph"),
											Type.list([]),
											Type.list([
												Type.tuple([
													Type.atom("text"),
													Type.bitstring(
														"Before starting, make sure you have installed Hologram correctly by following the ",
													),
												]),
												Type.tuple([
													Type.atom("component"),
													Type.atom("Elixir.Hologram.UI.Link"),
													Type.list([
														Type.tuple([
															Type.bitstring("to"),
															Type.list([
																Type.tuple([
																	Type.atom("expression"),
																	Type.tuple([
																		Type.atom(
																			"Elixir.HologramWebsite.InstallationPage",
																		),
																	]),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("Installation Guide"),
														]),
													]),
												]),
												Type.tuple([Type.atom("text"), Type.bitstring(".")]),
											]),
										]),
										Type.tuple([Type.atom("text"), Type.bitstring("\n")]),
										Type.tuple([
											Type.atom("component"),
											Type.atom("Elixir.HologramWebsite.Components.Paragraph"),
											Type.list([]),
											Type.list([
												Type.tuple([
													Type.atom("text"),
													Type.bitstring(
														"\n  Let's build a simple blog application to demonstrate Hologram's key features. Our blog will have:\n  ",
													),
												]),
												Type.tuple([
													Type.atom("component"),
													Type.atom("Elixir.HologramWebsite.Components.List"),
													Type.list([]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n    "),
														]),
														Type.tuple([
															Type.atom("component"),
															Type.atom(
																"Elixir.HologramWebsite.Components.List.Item",
															),
															Type.list([]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring(
																		"A home page listing blog posts",
																	),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n    "),
														]),
														Type.tuple([
															Type.atom("component"),
															Type.atom(
																"Elixir.HologramWebsite.Components.List.Item",
															),
															Type.list([]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("Individual post pages"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n    "),
														]),
														Type.tuple([
															Type.atom("component"),
															Type.atom(
																"Elixir.HologramWebsite.Components.List.Item",
															),
															Type.list([]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("A layout with navigation"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n    "),
														]),
														Type.tuple([
															Type.atom("component"),
															Type.atom(
																"Elixir.HologramWebsite.Components.List.Item",
															),
															Type.list([]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("The ability to like posts"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n  "),
														]),
													]),
												]),
												Type.tuple([Type.atom("text"), Type.bitstring("\n")]),
											]),
										]),
										Type.tuple([Type.atom("text"), Type.bitstring("\n\n")]),
										Type.tuple([
											Type.atom("component"),
											Type.atom("Elixir.HologramWebsite.Components.Heading2"),
											Type.list([]),
											Type.list([
												Type.tuple([
													Type.atom("text"),
													Type.bitstring("Creating the Layout"),
												]),
											]),
										]),
										Type.tuple([Type.atom("text"), Type.bitstring("\n")]),
										Type.tuple([
											Type.atom("component"),
											Type.atom("Elixir.HologramWebsite.Components.Paragraph"),
											Type.list([]),
											Type.list([
												Type.tuple([
													Type.atom("text"),
													Type.bitstring(
														"First, let's create a layout that will be shared across all pages:",
													),
												]),
											]),
										]),
										Type.tuple([Type.atom("text"), Type.bitstring("\n")]),
										Type.tuple([
											Type.atom("component"),
											Type.atom("Elixir.HologramWebsite.Components.CodeBlock"),
											Type.list([]),
											Type.list([
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("kd"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("defmodule"),
														]),
													]),
												]),
												Type.tuple([Type.atom("text"), Type.bitstring(" ")]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("module-name"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("segment"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("Blog"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("dot"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("."),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("segment"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("MainLayout"),
																]),
															]),
														]),
													]),
												]),
												Type.tuple([Type.atom("text"), Type.bitstring(" ")]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("k"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("do"),
														]),
													]),
												]),
												Type.tuple([Type.atom("text"), Type.bitstring("\n  ")]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("kn"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("use"),
														]),
													]),
												]),
												Type.tuple([Type.atom("text"), Type.bitstring(" ")]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("module-name"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("segment"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("Hologram"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("dot"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("."),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("segment"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("Component"),
																]),
															]),
														]),
													]),
												]),
												Type.tuple([
													Type.atom("text"),
													Type.bitstring("\n  \n  "),
												]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("kn"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("alias"),
														]),
													]),
												]),
												Type.tuple([Type.atom("text"), Type.bitstring(" ")]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("module-name"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("segment"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("Hologram"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("dot"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("."),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("segment"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("UI"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("dot"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("."),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("segment"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("Link"),
																]),
															]),
														]),
													]),
												]),
												Type.tuple([Type.atom("text"), Type.bitstring("\n  ")]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("kn"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("alias"),
														]),
													]),
												]),
												Type.tuple([Type.atom("text"), Type.bitstring(" ")]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("module-name"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("segment"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("Hologram"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("dot"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("."),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("segment"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("UI"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("dot"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("."),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("segment"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("Runtime"),
																]),
															]),
														]),
													]),
												]),
												Type.tuple([
													Type.atom("text"),
													Type.bitstring("\n  \n  "),
												]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("kd"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("def"),
														]),
													]),
												]),
												Type.tuple([Type.atom("text"), Type.bitstring(" ")]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("nf"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("template"),
														]),
													]),
												]),
												Type.tuple([Type.atom("text"), Type.bitstring(" ")]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("k"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("do"),
														]),
													]),
												]),
												Type.tuple([
													Type.atom("text"),
													Type.bitstring("\n    "),
												]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("holo"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("H-sigil-start"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring('~HOLO"""'),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n    "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("opening-angle-bracket"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("<!"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("tag-name"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("DOCTYPE"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring(" "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("attribute-name"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("html"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("closing-angle-bracket"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring(">"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n    "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("opening-angle-bracket"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("<"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("tag-name"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("html"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring(" "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("attribute-name"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("lang"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("equals-sign"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("="),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("attribute-value"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring('"en"'),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("closing-angle-bracket"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring(">"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n      "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("opening-angle-bracket"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("<"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("tag-name"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("head"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("closing-angle-bracket"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring(">"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n        "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("opening-angle-bracket"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("<"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("tag-name"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("meta"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring(" "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("attribute-name"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("charset"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("equals-sign"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("="),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("attribute-value"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring('"utf-8"'),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring(" "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("element-tag-delimiter"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("element"),
																	Type.bitstring("span"),
																	Type.list([
																		Type.tuple([
																			Type.bitstring("class"),
																			Type.list([
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring("slash"),
																				]),
																			]),
																		]),
																	]),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("/"),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.atom("element"),
																	Type.bitstring("span"),
																	Type.list([
																		Type.tuple([
																			Type.bitstring("class"),
																			Type.list([
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring(
																						"closing-angle-bracket",
																					),
																				]),
																			]),
																		]),
																	]),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring(">"),
																		]),
																	]),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n        "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("opening-angle-bracket"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("<"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("tag-name"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("title"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("closing-angle-bracket"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring(">"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("My Blog"),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("opening-angle-bracket"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("</"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("tag-name"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("title"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("closing-angle-bracket"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring(">"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n        "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("opening-angle-bracket"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("<"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("module-name"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("element"),
																	Type.bitstring("span"),
																	Type.list([
																		Type.tuple([
																			Type.bitstring("class"),
																			Type.list([
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring("segment"),
																				]),
																			]),
																		]),
																	]),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("Runtime"),
																		]),
																	]),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring(" "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("element-tag-delimiter"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("element"),
																	Type.bitstring("span"),
																	Type.list([
																		Type.tuple([
																			Type.bitstring("class"),
																			Type.list([
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring("slash"),
																				]),
																			]),
																		]),
																	]),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("/"),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.atom("element"),
																	Type.bitstring("span"),
																	Type.list([
																		Type.tuple([
																			Type.bitstring("class"),
																			Type.list([
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring(
																						"closing-angle-bracket",
																					),
																				]),
																			]),
																		]),
																	]),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring(">"),
																		]),
																	]),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n      "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("opening-angle-bracket"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("</"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("tag-name"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("head"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("closing-angle-bracket"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring(">"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n      "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("opening-angle-bracket"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("<"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("tag-name"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("body"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("closing-angle-bracket"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring(">"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n        "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("opening-angle-bracket"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("<"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("tag-name"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("nav"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("closing-angle-bracket"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring(">"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n          "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("opening-angle-bracket"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("<"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("module-name"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("element"),
																	Type.bitstring("span"),
																	Type.list([
																		Type.tuple([
																			Type.bitstring("class"),
																			Type.list([
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring("segment"),
																				]),
																			]),
																		]),
																	]),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("Link"),
																		]),
																	]),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring(" "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("attribute-name"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("to"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("equals-sign"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("="),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("opening-curly-brace"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("{"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("elixir"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("element"),
																	Type.bitstring("span"),
																	Type.list([
																		Type.tuple([
																			Type.bitstring("class"),
																			Type.list([
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring("module-name"),
																				]),
																			]),
																		]),
																	]),
																	Type.list([
																		Type.tuple([
																			Type.atom("element"),
																			Type.bitstring("span"),
																			Type.list([
																				Type.tuple([
																					Type.bitstring("class"),
																					Type.list([
																						Type.tuple([
																							Type.atom("text"),
																							Type.bitstring("segment"),
																						]),
																					]),
																				]),
																			]),
																			Type.list([
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring("Blog"),
																				]),
																			]),
																		]),
																		Type.tuple([
																			Type.atom("element"),
																			Type.bitstring("span"),
																			Type.list([
																				Type.tuple([
																					Type.bitstring("class"),
																					Type.list([
																						Type.tuple([
																							Type.atom("text"),
																							Type.bitstring("dot"),
																						]),
																					]),
																				]),
																			]),
																			Type.list([
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring("."),
																				]),
																			]),
																		]),
																		Type.tuple([
																			Type.atom("element"),
																			Type.bitstring("span"),
																			Type.list([
																				Type.tuple([
																					Type.bitstring("class"),
																					Type.list([
																						Type.tuple([
																							Type.atom("text"),
																							Type.bitstring("segment"),
																						]),
																					]),
																				]),
																			]),
																			Type.list([
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring("HomePage"),
																				]),
																			]),
																		]),
																	]),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("closing-curly-brace"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("}"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("closing-angle-bracket"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring(">"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("Home"),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("opening-angle-bracket"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("</"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("module-name"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("element"),
																	Type.bitstring("span"),
																	Type.list([
																		Type.tuple([
																			Type.bitstring("class"),
																			Type.list([
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring("segment"),
																				]),
																			]),
																		]),
																	]),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("Link"),
																		]),
																	]),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("closing-angle-bracket"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring(">"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n        "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("opening-angle-bracket"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("</"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("tag-name"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("nav"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("closing-angle-bracket"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring(">"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n        "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("opening-angle-bracket"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("<"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("tag-name"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("main"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("closing-angle-bracket"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring(">"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n          "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("opening-angle-bracket"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("<"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("tag-name"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("slot"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring(" "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("element-tag-delimiter"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("element"),
																	Type.bitstring("span"),
																	Type.list([
																		Type.tuple([
																			Type.bitstring("class"),
																			Type.list([
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring("slash"),
																				]),
																			]),
																		]),
																	]),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("/"),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.atom("element"),
																	Type.bitstring("span"),
																	Type.list([
																		Type.tuple([
																			Type.bitstring("class"),
																			Type.list([
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring(
																						"closing-angle-bracket",
																					),
																				]),
																			]),
																		]),
																	]),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring(">"),
																		]),
																	]),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n        "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("opening-angle-bracket"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("</"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("tag-name"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("main"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("closing-angle-bracket"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring(">"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n      "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("opening-angle-bracket"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("</"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("tag-name"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("body"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("closing-angle-bracket"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring(">"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n    "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("opening-angle-bracket"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("</"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("tag-name"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("html"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("closing-angle-bracket"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring(">"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n    "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("H-sigil-end"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring('"""'),
																]),
															]),
														]),
													]),
												]),
												Type.tuple([Type.atom("text"), Type.bitstring("\n  ")]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("k"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("end"),
														]),
													]),
												]),
												Type.tuple([Type.atom("text"), Type.bitstring("\n")]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("k"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("end"),
														]),
													]),
												]),
											]),
										]),
										Type.tuple([Type.atom("text"), Type.bitstring("\n\n")]),
										Type.tuple([
											Type.atom("component"),
											Type.atom("Elixir.HologramWebsite.Components.Heading2"),
											Type.list([]),
											Type.list([
												Type.tuple([
													Type.atom("text"),
													Type.bitstring("Creating the Home Page"),
												]),
											]),
										]),
										Type.tuple([Type.atom("text"), Type.bitstring("\n")]),
										Type.tuple([
											Type.atom("component"),
											Type.atom("Elixir.HologramWebsite.Components.Paragraph"),
											Type.list([]),
											Type.list([
												Type.tuple([
													Type.atom("text"),
													Type.bitstring(
														"Now let's create the home page that lists blog posts:",
													),
												]),
											]),
										]),
										Type.tuple([Type.atom("text"), Type.bitstring("\n")]),
										Type.tuple([
											Type.atom("component"),
											Type.atom("Elixir.HologramWebsite.Components.CodeBlock"),
											Type.list([]),
											Type.list([
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("kd"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("defmodule"),
														]),
													]),
												]),
												Type.tuple([Type.atom("text"), Type.bitstring(" ")]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("module-name"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("segment"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("Blog"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("dot"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("."),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("segment"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("HomePage"),
																]),
															]),
														]),
													]),
												]),
												Type.tuple([Type.atom("text"), Type.bitstring(" ")]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("k"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("do"),
														]),
													]),
												]),
												Type.tuple([Type.atom("text"), Type.bitstring("\n  ")]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("kn"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("use"),
														]),
													]),
												]),
												Type.tuple([Type.atom("text"), Type.bitstring(" ")]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("module-name"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("segment"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("Hologram"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("dot"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("."),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("segment"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("Page"),
																]),
															]),
														]),
													]),
												]),
												Type.tuple([Type.atom("text"), Type.bitstring("\n  ")]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("kn"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("alias"),
														]),
													]),
												]),
												Type.tuple([Type.atom("text"), Type.bitstring(" ")]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("module-name"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("segment"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("Blog"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("dot"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("."),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("segment"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("Components"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("dot"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("."),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("segment"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("PostPreview"),
																]),
															]),
														]),
													]),
												]),
												Type.tuple([
													Type.atom("text"),
													Type.bitstring("\n  \n  "),
												]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("n"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("route"),
														]),
													]),
												]),
												Type.tuple([Type.atom("text"), Type.bitstring(" ")]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("string"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("double-quote"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring('"'),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("/"),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("double-quote"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring('"'),
																]),
															]),
														]),
													]),
												]),
												Type.tuple([
													Type.atom("text"),
													Type.bitstring("\n  \n  "),
												]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("n"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("layout"),
														]),
													]),
												]),
												Type.tuple([Type.atom("text"), Type.bitstring(" ")]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("module-name"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("segment"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("Blog"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("dot"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("."),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("segment"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("MainLayout"),
																]),
															]),
														]),
													]),
												]),
												Type.tuple([
													Type.atom("text"),
													Type.bitstring("\n  \n  "),
												]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("kd"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("def"),
														]),
													]),
												]),
												Type.tuple([Type.atom("text"), Type.bitstring(" ")]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("nf"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("init"),
														]),
													]),
												]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("opening-parenthesis"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("("),
														]),
													]),
												]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("c"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("_params"),
														]),
													]),
												]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("p"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring(","),
														]),
													]),
												]),
												Type.tuple([Type.atom("text"), Type.bitstring(" ")]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("n"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("component"),
														]),
													]),
												]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("p"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring(","),
														]),
													]),
												]),
												Type.tuple([Type.atom("text"), Type.bitstring(" ")]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("c"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("_server"),
														]),
													]),
												]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("closing-parenthesis"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring(")"),
														]),
													]),
												]),
												Type.tuple([Type.atom("text"), Type.bitstring(" ")]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("k"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("do"),
														]),
													]),
												]),
												Type.tuple([
													Type.atom("text"),
													Type.bitstring("\n    "),
												]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("n"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("posts"),
														]),
													]),
												]),
												Type.tuple([Type.atom("text"), Type.bitstring(" ")]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("o"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("="),
														]),
													]),
												]),
												Type.tuple([Type.atom("text"), Type.bitstring(" ")]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("opening-square-bracket"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("["),
														]),
													]),
												]),
												Type.tuple([
													Type.atom("text"),
													Type.bitstring("\n      "),
												]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("map-delimiter"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("percent-sign"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("%"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("opening-curly-brace"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("{"),
																]),
															]),
														]),
													]),
												]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("ss"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("id"),
														]),
													]),
												]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("colon"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring(":"),
														]),
													]),
												]),
												Type.tuple([Type.atom("text"), Type.bitstring(" ")]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("mi"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("1"),
														]),
													]),
												]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("p"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring(","),
														]),
													]),
												]),
												Type.tuple([Type.atom("text"), Type.bitstring(" ")]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("ss"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("title"),
														]),
													]),
												]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("colon"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring(":"),
														]),
													]),
												]),
												Type.tuple([Type.atom("text"), Type.bitstring(" ")]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("string"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("double-quote"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring('"'),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("First Post"),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("double-quote"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring('"'),
																]),
															]),
														]),
													]),
												]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("p"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring(","),
														]),
													]),
												]),
												Type.tuple([Type.atom("text"), Type.bitstring(" ")]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("ss"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("excerpt"),
														]),
													]),
												]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("colon"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring(":"),
														]),
													]),
												]),
												Type.tuple([Type.atom("text"), Type.bitstring(" ")]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("string"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("double-quote"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring('"'),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("This is my first post"),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("double-quote"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring('"'),
																]),
															]),
														]),
													]),
												]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("closing-curly-brace"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("}"),
														]),
													]),
												]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("p"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring(","),
														]),
													]),
												]),
												Type.tuple([
													Type.atom("text"),
													Type.bitstring("\n      "),
												]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("map-delimiter"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("percent-sign"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("%"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("opening-curly-brace"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("{"),
																]),
															]),
														]),
													]),
												]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("ss"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("id"),
														]),
													]),
												]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("colon"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring(":"),
														]),
													]),
												]),
												Type.tuple([Type.atom("text"), Type.bitstring(" ")]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("mi"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("2"),
														]),
													]),
												]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("p"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring(","),
														]),
													]),
												]),
												Type.tuple([Type.atom("text"), Type.bitstring(" ")]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("ss"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("title"),
														]),
													]),
												]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("colon"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring(":"),
														]),
													]),
												]),
												Type.tuple([Type.atom("text"), Type.bitstring(" ")]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("string"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("double-quote"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring('"'),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("Second Post"),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("double-quote"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring('"'),
																]),
															]),
														]),
													]),
												]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("p"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring(","),
														]),
													]),
												]),
												Type.tuple([Type.atom("text"), Type.bitstring(" ")]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("ss"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("excerpt"),
														]),
													]),
												]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("colon"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring(":"),
														]),
													]),
												]),
												Type.tuple([Type.atom("text"), Type.bitstring(" ")]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("no"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("nil"),
														]),
													]),
												]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("closing-curly-brace"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("}"),
														]),
													]),
												]),
												Type.tuple([
													Type.atom("text"),
													Type.bitstring("\n    "),
												]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("closing-square-bracket"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("]"),
														]),
													]),
												]),
												Type.tuple([
													Type.atom("text"),
													Type.bitstring("\n    \n    "),
												]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("function-name"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("put_state"),
														]),
													]),
												]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("opening-parenthesis"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("("),
														]),
													]),
												]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("n"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("component"),
														]),
													]),
												]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("p"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring(","),
														]),
													]),
												]),
												Type.tuple([Type.atom("text"), Type.bitstring(" ")]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("colon"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring(":"),
														]),
													]),
												]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("ss"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("posts"),
														]),
													]),
												]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("p"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring(","),
														]),
													]),
												]),
												Type.tuple([Type.atom("text"), Type.bitstring(" ")]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("n"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("posts"),
														]),
													]),
												]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("closing-parenthesis"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring(")"),
														]),
													]),
												]),
												Type.tuple([Type.atom("text"), Type.bitstring("\n  ")]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("k"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("end"),
														]),
													]),
												]),
												Type.tuple([
													Type.atom("text"),
													Type.bitstring("\n\n  "),
												]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("kd"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("def"),
														]),
													]),
												]),
												Type.tuple([Type.atom("text"), Type.bitstring(" ")]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("nf"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("template"),
														]),
													]),
												]),
												Type.tuple([Type.atom("text"), Type.bitstring(" ")]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("k"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("do"),
														]),
													]),
												]),
												Type.tuple([
													Type.atom("text"),
													Type.bitstring("\n    "),
												]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("holo"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("H-sigil-start"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring('~HOLO"""'),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n    "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("opening-angle-bracket"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("<"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("tag-name"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("h1"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("closing-angle-bracket"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring(">"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("Welcome to my Blog"),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("opening-angle-bracket"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("</"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("tag-name"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("h1"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("closing-angle-bracket"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring(">"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n    \n    "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("opening-angle-bracket"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("<"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("tag-name"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("div"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring(" "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("attribute-name"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("class"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("equals-sign"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("="),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("attribute-value"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring('"posts"'),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("closing-angle-bracket"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring(">"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n      "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("for-start-tag"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("element"),
																	Type.bitstring("span"),
																	Type.list([
																		Type.tuple([
																			Type.bitstring("class"),
																			Type.list([
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring("delimiter"),
																				]),
																			]),
																		]),
																	]),
																	Type.list([
																		Type.tuple([
																			Type.atom("element"),
																			Type.bitstring("span"),
																			Type.list([
																				Type.tuple([
																					Type.bitstring("class"),
																					Type.list([
																						Type.tuple([
																							Type.atom("text"),
																							Type.bitstring(
																								"opening-curly-brace",
																							),
																						]),
																					]),
																				]),
																			]),
																			Type.list([
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring("{"),
																				]),
																			]),
																		]),
																		Type.tuple([
																			Type.atom("element"),
																			Type.bitstring("span"),
																			Type.list([
																				Type.tuple([
																					Type.bitstring("class"),
																					Type.list([
																						Type.tuple([
																							Type.atom("text"),
																							Type.bitstring("percent-sign"),
																						]),
																					]),
																				]),
																			]),
																			Type.list([
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring("%"),
																				]),
																			]),
																		]),
																		Type.tuple([
																			Type.atom("element"),
																			Type.bitstring("span"),
																			Type.list([
																				Type.tuple([
																					Type.bitstring("class"),
																					Type.list([
																						Type.tuple([
																							Type.atom("text"),
																							Type.bitstring("keyword"),
																						]),
																					]),
																				]),
																			]),
																			Type.list([
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring("for"),
																				]),
																			]),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.atom("element"),
																	Type.bitstring("span"),
																	Type.list([
																		Type.tuple([
																			Type.bitstring("class"),
																			Type.list([
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring("elixir"),
																				]),
																			]),
																		]),
																	]),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring(" "),
																		]),
																		Type.tuple([
																			Type.atom("element"),
																			Type.bitstring("span"),
																			Type.list([
																				Type.tuple([
																					Type.bitstring("class"),
																					Type.list([
																						Type.tuple([
																							Type.atom("text"),
																							Type.bitstring("n"),
																						]),
																					]),
																				]),
																			]),
																			Type.list([
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring("post"),
																				]),
																			]),
																		]),
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring(" "),
																		]),
																		Type.tuple([
																			Type.atom("element"),
																			Type.bitstring("span"),
																			Type.list([
																				Type.tuple([
																					Type.bitstring("class"),
																					Type.list([
																						Type.tuple([
																							Type.atom("text"),
																							Type.bitstring("o"),
																						]),
																					]),
																				]),
																			]),
																			Type.list([
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring("<-"),
																				]),
																			]),
																		]),
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring(" "),
																		]),
																		Type.tuple([
																			Type.atom("element"),
																			Type.bitstring("span"),
																			Type.list([
																				Type.tuple([
																					Type.bitstring("class"),
																					Type.list([
																						Type.tuple([
																							Type.atom("text"),
																							Type.bitstring("na"),
																						]),
																					]),
																				]),
																			]),
																			Type.list([
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring("@posts"),
																				]),
																			]),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.atom("element"),
																	Type.bitstring("span"),
																	Type.list([
																		Type.tuple([
																			Type.bitstring("class"),
																			Type.list([
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring("delimiter"),
																				]),
																			]),
																		]),
																	]),
																	Type.list([
																		Type.tuple([
																			Type.atom("element"),
																			Type.bitstring("span"),
																			Type.list([
																				Type.tuple([
																					Type.bitstring("class"),
																					Type.list([
																						Type.tuple([
																							Type.atom("text"),
																							Type.bitstring(
																								"closing-curly-brace",
																							),
																						]),
																					]),
																				]),
																			]),
																			Type.list([
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring("}"),
																				]),
																			]),
																		]),
																	]),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n        "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("opening-angle-bracket"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("<"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("module-name"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("element"),
																	Type.bitstring("span"),
																	Type.list([
																		Type.tuple([
																			Type.bitstring("class"),
																			Type.list([
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring("segment"),
																				]),
																			]),
																		]),
																	]),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("PostPreview"),
																		]),
																	]),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring(" "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("attribute-name"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("post"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("equals-sign"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("="),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("opening-curly-brace"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("{"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("elixir"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("element"),
																	Type.bitstring("span"),
																	Type.list([
																		Type.tuple([
																			Type.bitstring("class"),
																			Type.list([
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring("n"),
																				]),
																			]),
																		]),
																	]),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("post"),
																		]),
																	]),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("closing-curly-brace"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("}"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring(" "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("element-tag-delimiter"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("element"),
																	Type.bitstring("span"),
																	Type.list([
																		Type.tuple([
																			Type.bitstring("class"),
																			Type.list([
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring("slash"),
																				]),
																			]),
																		]),
																	]),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("/"),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.atom("element"),
																	Type.bitstring("span"),
																	Type.list([
																		Type.tuple([
																			Type.bitstring("class"),
																			Type.list([
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring(
																						"closing-angle-bracket",
																					),
																				]),
																			]),
																		]),
																	]),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring(">"),
																		]),
																	]),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n      "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("for-end-tag"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("element"),
																	Type.bitstring("span"),
																	Type.list([
																		Type.tuple([
																			Type.bitstring("class"),
																			Type.list([
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring("opening-curly-brace"),
																				]),
																			]),
																		]),
																	]),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("{"),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.atom("element"),
																	Type.bitstring("span"),
																	Type.list([
																		Type.tuple([
																			Type.bitstring("class"),
																			Type.list([
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring("slash"),
																				]),
																			]),
																		]),
																	]),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("/"),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.atom("element"),
																	Type.bitstring("span"),
																	Type.list([
																		Type.tuple([
																			Type.bitstring("class"),
																			Type.list([
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring("keyword"),
																				]),
																			]),
																		]),
																	]),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("for"),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.atom("element"),
																	Type.bitstring("span"),
																	Type.list([
																		Type.tuple([
																			Type.bitstring("class"),
																			Type.list([
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring("closing-curly-brace"),
																				]),
																			]),
																		]),
																	]),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("}"),
																		]),
																	]),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n    "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("opening-angle-bracket"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("</"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("tag-name"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("div"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("closing-angle-bracket"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring(">"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n    "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("H-sigil-end"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring('"""'),
																]),
															]),
														]),
													]),
												]),
												Type.tuple([Type.atom("text"), Type.bitstring("\n  ")]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("k"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("end"),
														]),
													]),
												]),
												Type.tuple([Type.atom("text"), Type.bitstring("\n")]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("k"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("end"),
														]),
													]),
												]),
											]),
										]),
										Type.tuple([Type.atom("text"), Type.bitstring("\n\n")]),
										Type.tuple([
											Type.atom("component"),
											Type.atom("Elixir.HologramWebsite.Components.Heading2"),
											Type.list([]),
											Type.list([
												Type.tuple([
													Type.atom("text"),
													Type.bitstring("Creating a Post Preview Component"),
												]),
											]),
										]),
										Type.tuple([Type.atom("text"), Type.bitstring("\n")]),
										Type.tuple([
											Type.atom("component"),
											Type.atom("Elixir.HologramWebsite.Components.Paragraph"),
											Type.list([]),
											Type.list([
												Type.tuple([
													Type.atom("text"),
													Type.bitstring(
														"Let's create a reusable component for displaying post previews:",
													),
												]),
											]),
										]),
										Type.tuple([Type.atom("text"), Type.bitstring("\n")]),
										Type.tuple([
											Type.atom("component"),
											Type.atom("Elixir.HologramWebsite.Components.CodeBlock"),
											Type.list([]),
											Type.list([
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("kd"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("defmodule"),
														]),
													]),
												]),
												Type.tuple([Type.atom("text"), Type.bitstring(" ")]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("module-name"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("segment"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("Blog"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("dot"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("."),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("segment"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("Components"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("dot"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("."),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("segment"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("PostPreview"),
																]),
															]),
														]),
													]),
												]),
												Type.tuple([Type.atom("text"), Type.bitstring(" ")]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("k"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("do"),
														]),
													]),
												]),
												Type.tuple([Type.atom("text"), Type.bitstring("\n  ")]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("kn"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("use"),
														]),
													]),
												]),
												Type.tuple([Type.atom("text"), Type.bitstring(" ")]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("module-name"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("segment"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("Hologram"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("dot"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("."),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("segment"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("Component"),
																]),
															]),
														]),
													]),
												]),
												Type.tuple([Type.atom("text"), Type.bitstring("\n  ")]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("kn"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("alias"),
														]),
													]),
												]),
												Type.tuple([Type.atom("text"), Type.bitstring(" ")]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("module-name"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("segment"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("Hologram"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("dot"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("."),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("segment"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("UI"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("dot"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("."),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("segment"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("Link"),
																]),
															]),
														]),
													]),
												]),
												Type.tuple([
													Type.atom("text"),
													Type.bitstring("\n  \n  "),
												]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("n"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("prop"),
														]),
													]),
												]),
												Type.tuple([Type.atom("text"), Type.bitstring(" ")]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("colon"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring(":"),
														]),
													]),
												]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("ss"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("post"),
														]),
													]),
												]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("p"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring(","),
														]),
													]),
												]),
												Type.tuple([Type.atom("text"), Type.bitstring(" ")]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("colon"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring(":"),
														]),
													]),
												]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("ss"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("map"),
														]),
													]),
												]),
												Type.tuple([
													Type.atom("text"),
													Type.bitstring("\n  \n  "),
												]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("kd"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("def"),
														]),
													]),
												]),
												Type.tuple([Type.atom("text"), Type.bitstring(" ")]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("nf"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("template"),
														]),
													]),
												]),
												Type.tuple([Type.atom("text"), Type.bitstring(" ")]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("k"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("do"),
														]),
													]),
												]),
												Type.tuple([
													Type.atom("text"),
													Type.bitstring("\n    "),
												]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("holo"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("H-sigil-start"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring('~HOLO"""'),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n    "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("opening-angle-bracket"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("<"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("tag-name"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("article"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring(" "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("attribute-name"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("class"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("equals-sign"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("="),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("attribute-value"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring('"post-preview"'),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("closing-angle-bracket"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring(">"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n      "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("opening-angle-bracket"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("<"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("tag-name"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("h2"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("closing-angle-bracket"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring(">"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("opening-curly-brace"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("{"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("elixir"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("element"),
																	Type.bitstring("span"),
																	Type.list([
																		Type.tuple([
																			Type.bitstring("class"),
																			Type.list([
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring("na"),
																				]),
																			]),
																		]),
																	]),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("@post"),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.atom("element"),
																	Type.bitstring("span"),
																	Type.list([
																		Type.tuple([
																			Type.bitstring("class"),
																			Type.list([
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring("dot"),
																				]),
																			]),
																		]),
																	]),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("."),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.atom("element"),
																	Type.bitstring("span"),
																	Type.list([
																		Type.tuple([
																			Type.bitstring("class"),
																			Type.list([
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring("n"),
																				]),
																			]),
																		]),
																	]),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("title"),
																		]),
																	]),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("closing-curly-brace"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("}"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("opening-angle-bracket"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("</"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("tag-name"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("h2"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("closing-angle-bracket"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring(">"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n      "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("opening-angle-bracket"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("<"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("tag-name"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("p"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("closing-angle-bracket"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring(">"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("opening-curly-brace"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("{"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("elixir"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("element"),
																	Type.bitstring("span"),
																	Type.list([
																		Type.tuple([
																			Type.bitstring("class"),
																			Type.list([
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring("na"),
																				]),
																			]),
																		]),
																	]),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("@post"),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.atom("element"),
																	Type.bitstring("span"),
																	Type.list([
																		Type.tuple([
																			Type.bitstring("class"),
																			Type.list([
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring("dot"),
																				]),
																			]),
																		]),
																	]),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("."),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.atom("element"),
																	Type.bitstring("span"),
																	Type.list([
																		Type.tuple([
																			Type.bitstring("class"),
																			Type.list([
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring("n"),
																				]),
																			]),
																		]),
																	]),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("excerpt"),
																		]),
																	]),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("closing-curly-brace"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("}"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("opening-angle-bracket"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("</"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("tag-name"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("p"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("closing-angle-bracket"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring(">"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n      "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("opening-angle-bracket"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("<"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("module-name"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("element"),
																	Type.bitstring("span"),
																	Type.list([
																		Type.tuple([
																			Type.bitstring("class"),
																			Type.list([
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring("segment"),
																				]),
																			]),
																		]),
																	]),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("Link"),
																		]),
																	]),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring(" "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("attribute-name"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("to"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("equals-sign"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("="),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("opening-curly-brace"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("{"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("elixir"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("element"),
																	Type.bitstring("span"),
																	Type.list([
																		Type.tuple([
																			Type.bitstring("class"),
																			Type.list([
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring("module-name"),
																				]),
																			]),
																		]),
																	]),
																	Type.list([
																		Type.tuple([
																			Type.atom("element"),
																			Type.bitstring("span"),
																			Type.list([
																				Type.tuple([
																					Type.bitstring("class"),
																					Type.list([
																						Type.tuple([
																							Type.atom("text"),
																							Type.bitstring("segment"),
																						]),
																					]),
																				]),
																			]),
																			Type.list([
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring("Blog"),
																				]),
																			]),
																		]),
																		Type.tuple([
																			Type.atom("element"),
																			Type.bitstring("span"),
																			Type.list([
																				Type.tuple([
																					Type.bitstring("class"),
																					Type.list([
																						Type.tuple([
																							Type.atom("text"),
																							Type.bitstring("dot"),
																						]),
																					]),
																				]),
																			]),
																			Type.list([
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring("."),
																				]),
																			]),
																		]),
																		Type.tuple([
																			Type.atom("element"),
																			Type.bitstring("span"),
																			Type.list([
																				Type.tuple([
																					Type.bitstring("class"),
																					Type.list([
																						Type.tuple([
																							Type.atom("text"),
																							Type.bitstring("segment"),
																						]),
																					]),
																				]),
																			]),
																			Type.list([
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring("PostPage"),
																				]),
																			]),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.atom("element"),
																	Type.bitstring("span"),
																	Type.list([
																		Type.tuple([
																			Type.bitstring("class"),
																			Type.list([
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring("p"),
																				]),
																			]),
																		]),
																	]),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring(","),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring(" "),
																]),
																Type.tuple([
																	Type.atom("element"),
																	Type.bitstring("span"),
																	Type.list([
																		Type.tuple([
																			Type.bitstring("class"),
																			Type.list([
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring("ss"),
																				]),
																			]),
																		]),
																	]),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("id"),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.atom("element"),
																	Type.bitstring("span"),
																	Type.list([
																		Type.tuple([
																			Type.bitstring("class"),
																			Type.list([
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring("colon"),
																				]),
																			]),
																		]),
																	]),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring(":"),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring(" "),
																]),
																Type.tuple([
																	Type.atom("element"),
																	Type.bitstring("span"),
																	Type.list([
																		Type.tuple([
																			Type.bitstring("class"),
																			Type.list([
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring("na"),
																				]),
																			]),
																		]),
																	]),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("@post"),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.atom("element"),
																	Type.bitstring("span"),
																	Type.list([
																		Type.tuple([
																			Type.bitstring("class"),
																			Type.list([
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring("dot"),
																				]),
																			]),
																		]),
																	]),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("."),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.atom("element"),
																	Type.bitstring("span"),
																	Type.list([
																		Type.tuple([
																			Type.bitstring("class"),
																			Type.list([
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring("n"),
																				]),
																			]),
																		]),
																	]),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("id"),
																		]),
																	]),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("closing-curly-brace"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("}"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("closing-angle-bracket"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring(">"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("Read more"),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("opening-angle-bracket"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("</"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("module-name"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("element"),
																	Type.bitstring("span"),
																	Type.list([
																		Type.tuple([
																			Type.bitstring("class"),
																			Type.list([
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring("segment"),
																				]),
																			]),
																		]),
																	]),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("Link"),
																		]),
																	]),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("closing-angle-bracket"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring(">"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n    "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("opening-angle-bracket"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("</"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("tag-name"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("article"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("closing-angle-bracket"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring(">"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n    "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("H-sigil-end"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring('"""'),
																]),
															]),
														]),
													]),
												]),
												Type.tuple([Type.atom("text"), Type.bitstring("\n  ")]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("k"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("end"),
														]),
													]),
												]),
												Type.tuple([Type.atom("text"), Type.bitstring("\n")]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("k"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("end"),
														]),
													]),
												]),
											]),
										]),
										Type.tuple([Type.atom("text"), Type.bitstring("\n\n")]),
										Type.tuple([
											Type.atom("component"),
											Type.atom("Elixir.HologramWebsite.Components.Heading2"),
											Type.list([]),
											Type.list([
												Type.tuple([
													Type.atom("text"),
													Type.bitstring("Creating the Post Page"),
												]),
											]),
										]),
										Type.tuple([Type.atom("text"), Type.bitstring("\n")]),
										Type.tuple([
											Type.atom("component"),
											Type.atom("Elixir.HologramWebsite.Components.Paragraph"),
											Type.list([]),
											Type.list([
												Type.tuple([
													Type.atom("text"),
													Type.bitstring(
														"Now let's create a page for individual posts with a like button:",
													),
												]),
											]),
										]),
										Type.tuple([Type.atom("text"), Type.bitstring("\n")]),
										Type.tuple([
											Type.atom("component"),
											Type.atom("Elixir.HologramWebsite.Components.CodeBlock"),
											Type.list([]),
											Type.list([
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("kd"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("defmodule"),
														]),
													]),
												]),
												Type.tuple([Type.atom("text"), Type.bitstring(" ")]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("module-name"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("segment"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("Blog"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("dot"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("."),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("segment"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("PostPage"),
																]),
															]),
														]),
													]),
												]),
												Type.tuple([Type.atom("text"), Type.bitstring(" ")]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("k"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("do"),
														]),
													]),
												]),
												Type.tuple([Type.atom("text"), Type.bitstring("\n  ")]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("kn"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("use"),
														]),
													]),
												]),
												Type.tuple([Type.atom("text"), Type.bitstring(" ")]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("module-name"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("segment"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("Hologram"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("dot"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("."),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("segment"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("Page"),
																]),
															]),
														]),
													]),
												]),
												Type.tuple([
													Type.atom("text"),
													Type.bitstring("\n  \n  "),
												]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("n"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("route"),
														]),
													]),
												]),
												Type.tuple([Type.atom("text"), Type.bitstring(" ")]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("string"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("double-quote"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring('"'),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("/posts/:id"),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("double-quote"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring('"'),
																]),
															]),
														]),
													]),
												]),
												Type.tuple([
													Type.atom("text"),
													Type.bitstring("\n\n  "),
												]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("n"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("param"),
														]),
													]),
												]),
												Type.tuple([Type.atom("text"), Type.bitstring(" ")]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("colon"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring(":"),
														]),
													]),
												]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("ss"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("id"),
														]),
													]),
												]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("p"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring(","),
														]),
													]),
												]),
												Type.tuple([Type.atom("text"), Type.bitstring(" ")]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("colon"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring(":"),
														]),
													]),
												]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("ss"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("integer"),
														]),
													]),
												]),
												Type.tuple([
													Type.atom("text"),
													Type.bitstring("\n\n  "),
												]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("n"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("layout"),
														]),
													]),
												]),
												Type.tuple([Type.atom("text"), Type.bitstring(" ")]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("module-name"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("segment"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("Blog"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("dot"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("."),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("segment"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("MainLayout"),
																]),
															]),
														]),
													]),
												]),
												Type.tuple([
													Type.atom("text"),
													Type.bitstring("\n\n  "),
												]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("kd"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("def"),
														]),
													]),
												]),
												Type.tuple([Type.atom("text"), Type.bitstring(" ")]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("nf"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("init"),
														]),
													]),
												]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("opening-parenthesis"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("("),
														]),
													]),
												]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("n"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("params"),
														]),
													]),
												]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("p"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring(","),
														]),
													]),
												]),
												Type.tuple([Type.atom("text"), Type.bitstring(" ")]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("n"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("component"),
														]),
													]),
												]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("p"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring(","),
														]),
													]),
												]),
												Type.tuple([Type.atom("text"), Type.bitstring(" ")]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("c"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("_server"),
														]),
													]),
												]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("closing-parenthesis"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring(")"),
														]),
													]),
												]),
												Type.tuple([Type.atom("text"), Type.bitstring(" ")]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("k"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("do"),
														]),
													]),
												]),
												Type.tuple([
													Type.atom("text"),
													Type.bitstring("\n    "),
												]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("c1"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring(
																"# In real app, fetch from database",
															),
														]),
													]),
												]),
												Type.tuple([
													Type.atom("text"),
													Type.bitstring("\n    "),
												]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("n"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("post"),
														]),
													]),
												]),
												Type.tuple([Type.atom("text"), Type.bitstring(" ")]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("o"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("="),
														]),
													]),
												]),
												Type.tuple([Type.atom("text"), Type.bitstring(" ")]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("map-delimiter"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("percent-sign"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("%"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("opening-curly-brace"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("{"),
																]),
															]),
														]),
													]),
												]),
												Type.tuple([
													Type.atom("text"),
													Type.bitstring("\n      "),
												]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("ss"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("id"),
														]),
													]),
												]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("colon"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring(":"),
														]),
													]),
												]),
												Type.tuple([Type.atom("text"), Type.bitstring(" ")]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("n"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("params"),
														]),
													]),
												]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("dot"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("."),
														]),
													]),
												]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("n"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("id"),
														]),
													]),
												]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("p"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring(","),
														]),
													]),
												]),
												Type.tuple([
													Type.atom("text"),
													Type.bitstring("\n      "),
												]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("ss"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("title"),
														]),
													]),
												]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("colon"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring(":"),
														]),
													]),
												]),
												Type.tuple([Type.atom("text"), Type.bitstring(" ")]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("string"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("double-quote"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring('"'),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("Example Post"),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("double-quote"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring('"'),
																]),
															]),
														]),
													]),
												]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("p"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring(","),
														]),
													]),
												]),
												Type.tuple([
													Type.atom("text"),
													Type.bitstring("\n      "),
												]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("ss"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("content"),
														]),
													]),
												]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("colon"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring(":"),
														]),
													]),
												]),
												Type.tuple([Type.atom("text"), Type.bitstring(" ")]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("string"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("double-quote"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring('"'),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("This is the full content..."),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("double-quote"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring('"'),
																]),
															]),
														]),
													]),
												]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("p"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring(","),
														]),
													]),
												]),
												Type.tuple([
													Type.atom("text"),
													Type.bitstring("\n      "),
												]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("ss"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("likes"),
														]),
													]),
												]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("colon"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring(":"),
														]),
													]),
												]),
												Type.tuple([Type.atom("text"), Type.bitstring(" ")]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("mi"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("0"),
														]),
													]),
												]),
												Type.tuple([
													Type.atom("text"),
													Type.bitstring("\n    "),
												]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("closing-curly-brace"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("}"),
														]),
													]),
												]),
												Type.tuple([
													Type.atom("text"),
													Type.bitstring("\n    \n    "),
												]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("function-name"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("put_state"),
														]),
													]),
												]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("opening-parenthesis"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("("),
														]),
													]),
												]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("n"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("component"),
														]),
													]),
												]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("p"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring(","),
														]),
													]),
												]),
												Type.tuple([Type.atom("text"), Type.bitstring(" ")]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("colon"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring(":"),
														]),
													]),
												]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("ss"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("post"),
														]),
													]),
												]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("p"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring(","),
														]),
													]),
												]),
												Type.tuple([Type.atom("text"), Type.bitstring(" ")]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("n"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("post"),
														]),
													]),
												]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("closing-parenthesis"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring(")"),
														]),
													]),
												]),
												Type.tuple([Type.atom("text"), Type.bitstring("\n  ")]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("k"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("end"),
														]),
													]),
												]),
												Type.tuple([
													Type.atom("text"),
													Type.bitstring("\n\n  "),
												]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("kd"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("def"),
														]),
													]),
												]),
												Type.tuple([Type.atom("text"), Type.bitstring(" ")]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("nf"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("template"),
														]),
													]),
												]),
												Type.tuple([Type.atom("text"), Type.bitstring(" ")]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("k"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("do"),
														]),
													]),
												]),
												Type.tuple([
													Type.atom("text"),
													Type.bitstring("\n    "),
												]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("holo"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("H-sigil-start"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring('~HOLO"""'),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n    "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("opening-angle-bracket"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("<"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("tag-name"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("article"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("closing-angle-bracket"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring(">"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n      "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("opening-angle-bracket"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("<"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("tag-name"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("h1"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("closing-angle-bracket"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring(">"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("opening-curly-brace"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("{"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("elixir"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("element"),
																	Type.bitstring("span"),
																	Type.list([
																		Type.tuple([
																			Type.bitstring("class"),
																			Type.list([
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring("na"),
																				]),
																			]),
																		]),
																	]),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("@post"),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.atom("element"),
																	Type.bitstring("span"),
																	Type.list([
																		Type.tuple([
																			Type.bitstring("class"),
																			Type.list([
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring("dot"),
																				]),
																			]),
																		]),
																	]),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("."),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.atom("element"),
																	Type.bitstring("span"),
																	Type.list([
																		Type.tuple([
																			Type.bitstring("class"),
																			Type.list([
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring("n"),
																				]),
																			]),
																		]),
																	]),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("title"),
																		]),
																	]),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("closing-curly-brace"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("}"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("opening-angle-bracket"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("</"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("tag-name"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("h1"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("closing-angle-bracket"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring(">"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n      "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("opening-angle-bracket"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("<"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("tag-name"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("p"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("closing-angle-bracket"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring(">"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("opening-curly-brace"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("{"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("elixir"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("element"),
																	Type.bitstring("span"),
																	Type.list([
																		Type.tuple([
																			Type.bitstring("class"),
																			Type.list([
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring("na"),
																				]),
																			]),
																		]),
																	]),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("@post"),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.atom("element"),
																	Type.bitstring("span"),
																	Type.list([
																		Type.tuple([
																			Type.bitstring("class"),
																			Type.list([
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring("dot"),
																				]),
																			]),
																		]),
																	]),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("."),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.atom("element"),
																	Type.bitstring("span"),
																	Type.list([
																		Type.tuple([
																			Type.bitstring("class"),
																			Type.list([
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring("n"),
																				]),
																			]),
																		]),
																	]),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("content"),
																		]),
																	]),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("closing-curly-brace"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("}"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("opening-angle-bracket"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("</"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("tag-name"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("p"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("closing-angle-bracket"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring(">"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n      \n      "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("opening-angle-bracket"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("<"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("tag-name"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("div"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring(" "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("attribute-name"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("class"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("equals-sign"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("="),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("attribute-value"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring('"likes"'),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("closing-angle-bracket"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring(">"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n        Likes: "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("opening-curly-brace"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("{"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("elixir"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("element"),
																	Type.bitstring("span"),
																	Type.list([
																		Type.tuple([
																			Type.bitstring("class"),
																			Type.list([
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring("na"),
																				]),
																			]),
																		]),
																	]),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("@post"),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.atom("element"),
																	Type.bitstring("span"),
																	Type.list([
																		Type.tuple([
																			Type.bitstring("class"),
																			Type.list([
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring("dot"),
																				]),
																			]),
																		]),
																	]),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("."),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.atom("element"),
																	Type.bitstring("span"),
																	Type.list([
																		Type.tuple([
																			Type.bitstring("class"),
																			Type.list([
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring("n"),
																				]),
																			]),
																		]),
																	]),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("likes"),
																		]),
																	]),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("closing-curly-brace"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("}"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n        "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("opening-angle-bracket"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("<"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("tag-name"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("button"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring(" "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("attribute-name"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("$click"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("equals-sign"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("="),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("attribute-value"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring('"like_post"'),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("closing-angle-bracket"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring(">"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("Like"),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("opening-angle-bracket"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("</"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("tag-name"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("button"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("closing-angle-bracket"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring(">"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n      "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("opening-angle-bracket"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("</"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("tag-name"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("div"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("closing-angle-bracket"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring(">"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n    "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("opening-angle-bracket"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("</"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("tag-name"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("article"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("closing-angle-bracket"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring(">"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n    "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("H-sigil-end"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring('"""'),
																]),
															]),
														]),
													]),
												]),
												Type.tuple([Type.atom("text"), Type.bitstring("\n  ")]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("k"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("end"),
														]),
													]),
												]),
												Type.tuple([
													Type.atom("text"),
													Type.bitstring("\n\n  "),
												]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("kd"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("def"),
														]),
													]),
												]),
												Type.tuple([Type.atom("text"), Type.bitstring(" ")]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("nf"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("action"),
														]),
													]),
												]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("opening-parenthesis"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("("),
														]),
													]),
												]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("colon"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring(":"),
														]),
													]),
												]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("ss"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("like_post"),
														]),
													]),
												]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("p"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring(","),
														]),
													]),
												]),
												Type.tuple([Type.atom("text"), Type.bitstring(" ")]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("c"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("_params"),
														]),
													]),
												]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("p"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring(","),
														]),
													]),
												]),
												Type.tuple([Type.atom("text"), Type.bitstring(" ")]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("n"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("component"),
														]),
													]),
												]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("closing-parenthesis"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring(")"),
														]),
													]),
												]),
												Type.tuple([Type.atom("text"), Type.bitstring(" ")]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("k"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("do"),
														]),
													]),
												]),
												Type.tuple([
													Type.atom("text"),
													Type.bitstring("\n    "),
												]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("c1"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring(
																"# Update likes locally first for instant feedback",
															),
														]),
													]),
												]),
												Type.tuple([
													Type.atom("text"),
													Type.bitstring("\n    "),
												]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("n"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("component"),
														]),
													]),
												]),
												Type.tuple([
													Type.atom("text"),
													Type.bitstring("\n    "),
												]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("o"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("|>"),
														]),
													]),
												]),
												Type.tuple([Type.atom("text"), Type.bitstring(" ")]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("function-name"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("put_state"),
														]),
													]),
												]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("opening-parenthesis"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("("),
														]),
													]),
												]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("opening-square-bracket"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("["),
														]),
													]),
												]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("colon"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring(":"),
														]),
													]),
												]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("ss"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("post"),
														]),
													]),
												]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("p"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring(","),
														]),
													]),
												]),
												Type.tuple([Type.atom("text"), Type.bitstring(" ")]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("colon"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring(":"),
														]),
													]),
												]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("ss"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("likes"),
														]),
													]),
												]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("closing-square-bracket"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("]"),
														]),
													]),
												]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("p"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring(","),
														]),
													]),
												]),
												Type.tuple([Type.atom("text"), Type.bitstring(" ")]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("n"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("component"),
														]),
													]),
												]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("dot"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("."),
														]),
													]),
												]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("n"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("state"),
														]),
													]),
												]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("dot"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("."),
														]),
													]),
												]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("n"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("post"),
														]),
													]),
												]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("dot"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("."),
														]),
													]),
												]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("n"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("likes"),
														]),
													]),
												]),
												Type.tuple([Type.atom("text"), Type.bitstring(" ")]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("o"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("+"),
														]),
													]),
												]),
												Type.tuple([Type.atom("text"), Type.bitstring(" ")]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("mi"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("1"),
														]),
													]),
												]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("closing-parenthesis"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring(")"),
														]),
													]),
												]),
												Type.tuple([
													Type.atom("text"),
													Type.bitstring("\n    "),
												]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("o"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("|>"),
														]),
													]),
												]),
												Type.tuple([Type.atom("text"), Type.bitstring(" ")]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("function-name"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("put_command"),
														]),
													]),
												]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("opening-parenthesis"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("("),
														]),
													]),
												]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("colon"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring(":"),
														]),
													]),
												]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("ss"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("save_like"),
														]),
													]),
												]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("p"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring(","),
														]),
													]),
												]),
												Type.tuple([Type.atom("text"), Type.bitstring(" ")]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("ss"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("post_id"),
														]),
													]),
												]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("colon"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring(":"),
														]),
													]),
												]),
												Type.tuple([Type.atom("text"), Type.bitstring(" ")]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("n"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("component"),
														]),
													]),
												]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("dot"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("."),
														]),
													]),
												]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("n"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("state"),
														]),
													]),
												]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("dot"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("."),
														]),
													]),
												]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("n"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("post"),
														]),
													]),
												]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("dot"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("."),
														]),
													]),
												]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("n"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("id"),
														]),
													]),
												]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("closing-parenthesis"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring(")"),
														]),
													]),
												]),
												Type.tuple([Type.atom("text"), Type.bitstring("\n  ")]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("k"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("end"),
														]),
													]),
												]),
												Type.tuple([
													Type.atom("text"),
													Type.bitstring("\n\n  "),
												]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("kd"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("def"),
														]),
													]),
												]),
												Type.tuple([Type.atom("text"), Type.bitstring(" ")]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("nf"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("command"),
														]),
													]),
												]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("opening-parenthesis"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("("),
														]),
													]),
												]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("colon"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring(":"),
														]),
													]),
												]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("ss"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("save_like"),
														]),
													]),
												]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("p"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring(","),
														]),
													]),
												]),
												Type.tuple([Type.atom("text"), Type.bitstring(" ")]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("n"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("params"),
														]),
													]),
												]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("p"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring(","),
														]),
													]),
												]),
												Type.tuple([Type.atom("text"), Type.bitstring(" ")]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("n"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("server"),
														]),
													]),
												]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("closing-parenthesis"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring(")"),
														]),
													]),
												]),
												Type.tuple([Type.atom("text"), Type.bitstring(" ")]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("k"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("do"),
														]),
													]),
												]),
												Type.tuple([
													Type.atom("text"),
													Type.bitstring("\n    "),
												]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("c1"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("# In real app, save to database"),
														]),
													]),
												]),
												Type.tuple([
													Type.atom("text"),
													Type.bitstring("\n    "),
												]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("module-name"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("segment"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("IO"),
																]),
															]),
														]),
													]),
												]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("dot"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("."),
														]),
													]),
												]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("function-name"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("puts"),
														]),
													]),
												]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("opening-parenthesis"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("("),
														]),
													]),
												]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("string"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("double-quote"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring('"'),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("Liked post "),
														]),
													]),
												]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("string-interpolation-start"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("#{"),
														]),
													]),
												]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("n"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("params"),
														]),
													]),
												]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("dot"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("."),
														]),
													]),
												]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("n"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("post_id"),
														]),
													]),
												]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("string-interpolation-end"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("}"),
														]),
													]),
												]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("string"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("span"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("double-quote"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring('"'),
																]),
															]),
														]),
													]),
												]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("closing-parenthesis"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring(")"),
														]),
													]),
												]),
												Type.tuple([
													Type.atom("text"),
													Type.bitstring("\n    "),
												]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("n"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("server"),
														]),
													]),
												]),
												Type.tuple([Type.atom("text"), Type.bitstring("\n  ")]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("k"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("end"),
														]),
													]),
												]),
												Type.tuple([Type.atom("text"), Type.bitstring("\n")]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("k"),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("end"),
														]),
													]),
												]),
											]),
										]),
										Type.tuple([Type.atom("text"), Type.bitstring("\n\n")]),
										Type.tuple([
											Type.atom("component"),
											Type.atom("Elixir.HologramWebsite.Components.Heading2"),
											Type.list([]),
											Type.list([
												Type.tuple([
													Type.atom("text"),
													Type.bitstring("Key Concepts Demonstrated"),
												]),
											]),
										]),
										Type.tuple([Type.atom("text"), Type.bitstring("\n")]),
										Type.tuple([
											Type.atom("component"),
											Type.atom("Elixir.HologramWebsite.Components.Paragraph"),
											Type.list([]),
											Type.list([
												Type.tuple([Type.atom("text"), Type.bitstring("\n  ")]),
												Type.tuple([
													Type.atom("component"),
													Type.atom("Elixir.HologramWebsite.Components.List"),
													Type.list([
														Type.tuple([
															Type.bitstring("type"),
															Type.list([
																Type.tuple([
																	Type.atom("expression"),
																	Type.tuple([Type.atom("ordered")]),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n    "),
														]),
														Type.tuple([
															Type.atom("component"),
															Type.atom(
																"Elixir.HologramWebsite.Components.List.Item",
															),
															Type.list([]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("Pages: both "),
																]),
																Type.tuple([
																	Type.atom("component"),
																	Type.atom(
																		"Elixir.HologramWebsite.Components.Code",
																	),
																	Type.list([]),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("HomePage"),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring(" and "),
																]),
																Type.tuple([
																	Type.atom("component"),
																	Type.atom(
																		"Elixir.HologramWebsite.Components.Code",
																	),
																	Type.list([]),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("PostPage"),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring(
																		" are Hologram pages with their own routes",
																	),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n    "),
														]),
														Type.tuple([
															Type.atom("component"),
															Type.atom(
																"Elixir.HologramWebsite.Components.List.Item",
															),
															Type.list([]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("Components: the "),
																]),
																Type.tuple([
																	Type.atom("component"),
																	Type.atom(
																		"Elixir.HologramWebsite.Components.Code",
																	),
																	Type.list([]),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("PostPreview"),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring(
																		" component shows how to create reusable UI elements",
																	),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n    "),
														]),
														Type.tuple([
															Type.atom("component"),
															Type.atom(
																"Elixir.HologramWebsite.Components.List.Item",
															),
															Type.list([]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("Layout: the "),
																]),
																Type.tuple([
																	Type.atom("component"),
																	Type.atom(
																		"Elixir.HologramWebsite.Components.Code",
																	),
																	Type.list([]),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("MainLayout"),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring(
																		" provides a consistent structure across pages",
																	),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n    "),
														]),
														Type.tuple([
															Type.atom("component"),
															Type.atom(
																"Elixir.HologramWebsite.Components.List.Item",
															),
															Type.list([]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("Template Syntax:\n      "),
																]),
																Type.tuple([
																	Type.atom("component"),
																	Type.atom(
																		"Elixir.HologramWebsite.Components.List",
																	),
																	Type.list([]),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("\n        "),
																		]),
																		Type.tuple([
																			Type.atom("component"),
																			Type.atom(
																				"Elixir.HologramWebsite.Components.List.Item",
																			),
																			Type.list([]),
																			Type.list([
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring("Using "),
																				]),
																				Type.tuple([
																					Type.atom("component"),
																					Type.atom(
																						"Elixir.HologramWebsite.Components.Code",
																					),
																					Type.list([]),
																					Type.list([
																						Type.tuple([
																							Type.atom("text"),
																							Type.bitstring("{%for}"),
																						]),
																					]),
																				]),
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring(" loops"),
																				]),
																			]),
																		]),
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("\n        "),
																		]),
																		Type.tuple([
																			Type.atom("component"),
																			Type.atom(
																				"Elixir.HologramWebsite.Components.List.Item",
																			),
																			Type.list([]),
																			Type.list([
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring(
																						"Interpolating values with ",
																					),
																				]),
																				Type.tuple([
																					Type.atom("component"),
																					Type.atom(
																						"Elixir.HologramWebsite.Components.Code",
																					),
																					Type.list([]),
																					Type.list([
																						Type.tuple([
																							Type.atom("text"),
																							Type.bitstring("{@var}"),
																						]),
																					]),
																				]),
																			]),
																		]),
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("\n        "),
																		]),
																		Type.tuple([
																			Type.atom("component"),
																			Type.atom(
																				"Elixir.HologramWebsite.Components.List.Item",
																			),
																			Type.list([]),
																			Type.list([
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring("Event binding with "),
																				]),
																				Type.tuple([
																					Type.atom("component"),
																					Type.atom(
																						"Elixir.HologramWebsite.Components.Code",
																					),
																					Type.list([]),
																					Type.list([
																						Type.tuple([
																							Type.atom("text"),
																							Type.bitstring("$click"),
																						]),
																					]),
																				]),
																			]),
																		]),
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("\n      "),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("\n    "),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n    "),
														]),
														Type.tuple([
															Type.atom("component"),
															Type.atom(
																"Elixir.HologramWebsite.Components.List.Item",
															),
															Type.list([]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("Navigation: using "),
																]),
																Type.tuple([
																	Type.atom("component"),
																	Type.atom(
																		"Elixir.HologramWebsite.Components.Code",
																	),
																	Type.list([]),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("Link"),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring(
																		" component to navigate between pages",
																	),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n    "),
														]),
														Type.tuple([
															Type.atom("component"),
															Type.atom(
																"Elixir.HologramWebsite.Components.List.Item",
															),
															Type.list([]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("State Management: using "),
																]),
																Type.tuple([
																	Type.atom("component"),
																	Type.atom(
																		"Elixir.HologramWebsite.Components.Code",
																	),
																	Type.list([]),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("put_state/3"),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring(" to manage component state"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n    "),
														]),
														Type.tuple([
															Type.atom("component"),
															Type.atom(
																"Elixir.HologramWebsite.Components.List.Item",
															),
															Type.list([]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring(
																		"Actions & Commands: the like button demonstrates:\n      ",
																	),
																]),
																Type.tuple([
																	Type.atom("component"),
																	Type.atom(
																		"Elixir.HologramWebsite.Components.List",
																	),
																	Type.list([]),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("\n        "),
																		]),
																		Type.tuple([
																			Type.atom("component"),
																			Type.atom(
																				"Elixir.HologramWebsite.Components.List.Item",
																			),
																			Type.list([]),
																			Type.list([
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring(
																						"Client-side action for immediate UI update",
																					),
																				]),
																			]),
																		]),
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("\n        "),
																		]),
																		Type.tuple([
																			Type.atom("component"),
																			Type.atom(
																				"Elixir.HologramWebsite.Components.List.Item",
																			),
																			Type.list([]),
																			Type.list([
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring(
																						"Server-side command for persistence",
																					),
																				]),
																			]),
																		]),
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("\n      "),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("\n    "),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n    "),
														]),
														Type.tuple([
															Type.atom("component"),
															Type.atom(
																"Elixir.HologramWebsite.Components.List.Item",
															),
															Type.list([]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring(
																		"Props: component properties with the ",
																	),
																]),
																Type.tuple([
																	Type.atom("component"),
																	Type.atom(
																		"Elixir.HologramWebsite.Components.Code",
																	),
																	Type.list([]),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("prop/2"),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring(" macro"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n    "),
														]),
														Type.tuple([
															Type.atom("component"),
															Type.atom(
																"Elixir.HologramWebsite.Components.List.Item",
															),
															Type.list([]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring(
																		"Parameters: route parameters with the ",
																	),
																]),
																Type.tuple([
																	Type.atom("component"),
																	Type.atom(
																		"Elixir.HologramWebsite.Components.Code",
																	),
																	Type.list([]),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("param/2"),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring(" macro"),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n  "),
														]),
													]),
												]),
												Type.tuple([Type.atom("text"), Type.bitstring("\n")]),
											]),
										]),
										Type.tuple([Type.atom("text"), Type.bitstring("\n")]),
										Type.tuple([
											Type.atom("component"),
											Type.atom("Elixir.HologramWebsite.Components.Paragraph"),
											Type.list([]),
											Type.list([
												Type.tuple([
													Type.atom("text"),
													Type.bitstring(
														"This example demonstrates the basic building blocks of a Hologram application. The framework handles the client-server communication and state management automatically, letting you focus on building features.",
													),
												]),
											]),
										]),
										Type.tuple([Type.atom("text"), Type.bitstring("\n")]),
										Type.tuple([
											Type.atom("component"),
											Type.atom("Elixir.HologramWebsite.Components.Paragraph"),
											Type.list([]),
											Type.list([
												Type.tuple([
													Type.atom("text"),
													Type.bitstring(
														"Remember that Hologram keeps state on the client side for better performance while using commands for server-side operations when needed.",
													),
												]),
											]),
										]),
									]);
								},
							},
						],
						context,
					);
					Interpreter.updateVarsToMatchedValues(context);
					return globalThis.hologram.return;
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"HologramWebsite.RoadmapPage",
		"__params__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Elixir_Enum["reverse/1"](Type.list([]));
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"HologramWebsite.RoadmapPage",
		"__route__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Type.bitstring("/docs/roadmap");
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"HologramWebsite.TemplateSyntaxPage",
		"__params__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Elixir_Enum["reverse/1"](Type.list([]));
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"HologramWebsite.TemplateSyntaxPage",
		"__route__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Type.bitstring("/docs/template-syntax");
				},
			},
		],
	);

	Interpreter.defineElixirFunction("IO", "warn_once", 3, "public", [
		{
			params: (context) => [
				Type.variablePattern("key_0"),
				Type.variablePattern("message_1"),
				Type.variablePattern("stacktrace_drop_levels_2"),
			],
			guards: [],
			body: (context) => {
				Interpreter.matchOperator(
					Elixir_Process["info/2"](
						Erlang["self/0"](),
						Type.atom("current_stacktrace"),
					),
					Type.tuple([
						Type.atom("current_stacktrace"),
						Type.variablePattern("stacktrace_3"),
					]),
					context,
				);
				Interpreter.updateVarsToMatchedValues(context);
				Interpreter.matchOperator(
					Elixir_Enum["drop/2"](
						context.vars.stacktrace_3,
						context.vars.stacktrace_drop_levels_2,
					),
					Type.variablePattern("stacktrace_4"),
					context,
				);
				Interpreter.updateVarsToMatchedValues(context);
				return Interpreter.case(
					Erlang_Elixir_Config["warn/2"](
						context.vars.key_0,
						context.vars.stacktrace_4,
					),
					[
						{
							match: Type.variablePattern("x_5"),
							guards: [
								(context) =>
									Erlang["orelse/2"](
										(context) =>
											Erlang["=:=/2"](context.vars.x_5, Type.atom("false")),
										(context) =>
											Erlang["=:=/2"](context.vars.x_5, Type.atom("nil")),
										context,
									),
							],
							body: (context) => {
								return Type.atom("ok");
							},
						},
						{
							match: Type.matchPlaceholder(),
							guards: [],
							body: (context) => {
								return Elixir_IO["warn/2"](
									Interpreter.callAnonymousFunction(context.vars.message_1, []),
									context.vars.stacktrace_4,
								);
							},
						},
					],
					context,
				);
			},
		},
	]);

	Interpreter.defineElixirFunction("Kernel", "get_and_update_in", 3, "public", [
		{
			params: (context) => [
				Type.variablePattern("data_0"),
				Type.list([Type.variablePattern("head_1")]),
				Type.variablePattern("fun_2"),
			],
			guards: [
				(context) =>
					Erlang["is_function/2"](context.vars.head_1, Type.integer(3n)),
			],
			body: (context) => {
				return Interpreter.callAnonymousFunction(context.vars.head_1, [
					Type.atom("get_and_update"),
					context.vars.data_0,
					context.vars.fun_2,
				]);
			},
		},
		{
			params: (context) => [
				Type.variablePattern("data_0"),
				Type.consPattern(
					Type.variablePattern("head_1"),
					Type.variablePattern("tail_2"),
				),
				Type.variablePattern("fun_3"),
			],
			guards: [
				(context) =>
					Erlang["is_function/2"](context.vars.head_1, Type.integer(3n)),
			],
			body: (context) => {
				return Interpreter.callAnonymousFunction(context.vars.head_1, [
					Type.atom("get_and_update"),
					context.vars.data_0,
					Type.anonymousFunction(
						1,
						[
							{
								params: (context) => [Type.variablePattern("$689")],
								guards: [],
								body: (context) => {
									return Elixir_Kernel["get_and_update_in/3"](
										context.vars["$689"],
										context.vars.tail_2,
										context.vars.fun_3,
									);
								},
							},
						],
						context,
					),
				]);
			},
		},
		{
			params: (context) => [
				Type.variablePattern("data_0"),
				Type.list([Type.variablePattern("head_1")]),
				Type.variablePattern("fun_2"),
			],
			guards: [
				(context) =>
					Erlang["is_function/2"](context.vars.fun_2, Type.integer(1n)),
			],
			body: (context) => {
				return Elixir_Access["get_and_update/3"](
					context.vars.data_0,
					context.vars.head_1,
					context.vars.fun_2,
				);
			},
		},
		{
			params: (context) => [
				Type.variablePattern("data_0"),
				Type.consPattern(
					Type.variablePattern("head_1"),
					Type.variablePattern("tail_2"),
				),
				Type.variablePattern("fun_3"),
			],
			guards: [
				(context) =>
					Erlang["is_function/2"](context.vars.fun_3, Type.integer(1n)),
			],
			body: (context) => {
				return Elixir_Access["get_and_update/3"](
					context.vars.data_0,
					context.vars.head_1,
					Type.anonymousFunction(
						1,
						[
							{
								params: (context) => [Type.variablePattern("$690")],
								guards: [],
								body: (context) => {
									return Elixir_Kernel["get_and_update_in/3"](
										context.vars["$690"],
										context.vars.tail_2,
										context.vars.fun_3,
									);
								},
							},
						],
						context,
					),
				);
			},
		},
	]);

	Interpreter.defineElixirFunction("Kernel", "put_in", 3, "public", [
		{
			params: (context) => [
				Type.variablePattern("data_0"),
				Interpreter.matchOperator(
					Type.variablePattern("keys_1"),
					Type.consPattern(Type.matchPlaceholder(), Type.matchPlaceholder()),
					context,
				),
				Type.variablePattern("value_2"),
			],
			guards: [],
			body: (context) => {
				return Erlang["element/2"](
					Type.integer(2n),
					Elixir_Kernel["get_and_update_in/3"](
						context.vars.data_0,
						context.vars.keys_1,
						Type.anonymousFunction(
							1,
							[
								{
									params: (context) => [Type.matchPlaceholder()],
									guards: [],
									body: (context) => {
										return Type.tuple([Type.atom("nil"), context.vars.value_2]);
									},
								},
							],
							context,
						),
					),
				);
			},
		},
	]);

	Interpreter.defineElixirFunction("Keyword", "get_and_update", 3, "public", [
		{
			params: (context) => [
				Type.variablePattern("keywords_0"),
				Type.variablePattern("key_1"),
				Type.variablePattern("fun_2"),
			],
			guards: [
				(context) =>
					Erlang["andalso/2"](
						(context) => Erlang["is_list/1"](context.vars.keywords_0),
						(context) => Erlang["is_atom/1"](context.vars.key_1),
						context,
					),
			],
			body: (context) => {
				return Elixir_Keyword["get_and_update/4"](
					context.vars.keywords_0,
					Type.list([]),
					context.vars.key_1,
					context.vars.fun_2,
				);
			},
		},
	]);

	Interpreter.defineElixirFunction("Keyword", "get_and_update", 4, "private", [
		{
			params: (context) => [
				Type.consPattern(
					Type.tuple([
						Type.variablePattern("key_0"),
						Type.variablePattern("current_1"),
					]),
					Type.variablePattern("t_2"),
				),
				Type.variablePattern("acc_3"),
				Type.variablePattern("key_0"),
				Type.variablePattern("fun_4"),
			],
			guards: [],
			body: (context) => {
				return Interpreter.case(
					Interpreter.callAnonymousFunction(context.vars.fun_4, [
						context.vars.current_1,
					]),
					[
						{
							match: Type.tuple([
								Type.variablePattern("get_5"),
								Type.variablePattern("value_6"),
							]),
							guards: [],
							body: (context) => {
								return Type.tuple([
									context.vars.get_5,
									Erlang_Lists["reverse/2"](
										context.vars.acc_3,
										Interpreter.consOperator(
											Type.tuple([context.vars.key_0, context.vars.value_6]),
											context.vars.t_2,
										),
									),
								]);
							},
						},
						{
							match: Type.atom("pop"),
							guards: [],
							body: (context) => {
								return Type.tuple([
									context.vars.current_1,
									Erlang_Lists["reverse/2"](
										context.vars.acc_3,
										context.vars.t_2,
									),
								]);
							},
						},
						{
							match: Type.variablePattern("other_7"),
							guards: [],
							body: (context) => {
								return Erlang["error/3"](
									Elixir_RuntimeError["exception/1"](
										Type.bitstring([
											Type.bitstringSegment(
												Type.string(
													"the given function must return a two-element tuple or :pop, got: ",
												),
												{ type: "binary" },
											),
											Type.bitstringSegment(
												Elixir_Kernel["inspect/1"](context.vars.other_7),
												{ type: "binary" },
											),
										]),
									),
									Type.atom("none"),
									Type.list([
										Type.tuple([
											Type.atom("error_info"),
											Type.map([
												[Type.atom("module"), Type.atom("Elixir.Exception")],
											]),
										]),
									]),
								);
							},
						},
					],
					context,
				);
			},
		},
		{
			params: (context) => [
				Type.consPattern(
					Interpreter.matchOperator(
						Type.variablePattern("h_0"),
						Type.tuple([Type.matchPlaceholder(), Type.matchPlaceholder()]),
						context,
					),
					Type.variablePattern("t_1"),
				),
				Type.variablePattern("acc_2"),
				Type.variablePattern("key_3"),
				Type.variablePattern("fun_4"),
			],
			guards: [],
			body: (context) => {
				return Elixir_Keyword["get_and_update/4"](
					context.vars.t_1,
					Interpreter.consOperator(context.vars.h_0, context.vars.acc_2),
					context.vars.key_3,
					context.vars.fun_4,
				);
			},
		},
		{
			params: (context) => [
				Type.list([]),
				Type.variablePattern("acc_0"),
				Type.variablePattern("key_1"),
				Type.variablePattern("fun_2"),
			],
			guards: [],
			body: (context) => {
				return Interpreter.case(
					Interpreter.callAnonymousFunction(context.vars.fun_2, [
						Type.atom("nil"),
					]),
					[
						{
							match: Type.tuple([
								Type.variablePattern("get_3"),
								Type.variablePattern("update_4"),
							]),
							guards: [],
							body: (context) => {
								return Type.tuple([
									context.vars.get_3,
									Interpreter.consOperator(
										Type.tuple([context.vars.key_1, context.vars.update_4]),
										Erlang_Lists["reverse/1"](context.vars.acc_0),
									),
								]);
							},
						},
						{
							match: Type.atom("pop"),
							guards: [],
							body: (context) => {
								return Type.tuple([
									Type.atom("nil"),
									Erlang_Lists["reverse/1"](context.vars.acc_0),
								]);
							},
						},
						{
							match: Type.variablePattern("other_5"),
							guards: [],
							body: (context) => {
								return Erlang["error/3"](
									Elixir_RuntimeError["exception/1"](
										Type.bitstring([
											Type.bitstringSegment(
												Type.string(
													"the given function must return a two-element tuple or :pop, got: ",
												),
												{ type: "binary" },
											),
											Type.bitstringSegment(
												Elixir_Kernel["inspect/1"](context.vars.other_5),
												{ type: "binary" },
											),
										]),
									),
									Type.atom("none"),
									Type.list([
										Type.tuple([
											Type.atom("error_info"),
											Type.map([
												[Type.atom("module"), Type.atom("Elixir.Exception")],
											]),
										]),
									]),
								);
							},
						},
					],
					context,
				);
			},
		},
	]);

	Interpreter.defineElixirFunction("Map", "delete", 2, "public", [
		{
			params: (context) => [
				Type.variablePattern("map_0"),
				Type.variablePattern("key_1"),
			],
			guards: [],
			body: (context) => {
				return Erlang_Maps["remove/2"](context.vars.key_1, context.vars.map_0);
			},
		},
	]);

	Interpreter.defineElixirFunction("Map", "get", 2, "public", [
		{
			params: (context) => [
				Type.variablePattern("x0_0"),
				Type.variablePattern("x1_1"),
			],
			guards: [],
			body: (context) => {
				return Elixir_Map["get/3"](
					context.vars.x0_0,
					context.vars.x1_1,
					Type.atom("nil"),
				);
			},
		},
	]);

	Interpreter.defineElixirFunction("Map", "get", 3, "public", [
		{
			params: (context) => [
				Type.variablePattern("map_0"),
				Type.variablePattern("key_1"),
				Type.variablePattern("default_2"),
			],
			guards: [],
			body: (context) => {
				return Interpreter.case(
					context.vars.map_0,
					[
						{
							match: Type.map([
								[context.vars.key_1, Type.variablePattern("value_3")],
							]),
							guards: [],
							body: (context) => {
								return context.vars.value_3;
							},
						},
						{
							match: Type.map([]),
							guards: [],
							body: (context) => {
								return context.vars.default_2;
							},
						},
						{
							match: Type.variablePattern("other_4"),
							guards: [],
							body: (context) => {
								return Erlang["error/2"](
									Type.tuple([Type.atom("badmap"), context.vars.other_4]),
									Type.list([
										context.vars.map_0,
										context.vars.key_1,
										context.vars.default_2,
									]),
								);
							},
						},
					],
					context,
				);
			},
		},
	]);

	Interpreter.defineElixirFunction("Map", "get_and_update", 3, "public", [
		{
			params: (context) => [
				Type.variablePattern("map_0"),
				Type.variablePattern("key_1"),
				Type.variablePattern("fun_2"),
			],
			guards: [
				(context) =>
					Erlang["is_function/2"](context.vars.fun_2, Type.integer(1n)),
			],
			body: (context) => {
				Interpreter.matchOperator(
					Elixir_Map["get/2"](context.vars.map_0, context.vars.key_1),
					Type.variablePattern("current_3"),
					context,
				);
				Interpreter.updateVarsToMatchedValues(context);
				return Interpreter.case(
					Interpreter.callAnonymousFunction(context.vars.fun_2, [
						context.vars.current_3,
					]),
					[
						{
							match: Type.tuple([
								Type.variablePattern("get_4"),
								Type.variablePattern("update_5"),
							]),
							guards: [],
							body: (context) => {
								return Type.tuple([
									context.vars.get_4,
									Elixir_Map["put/3"](
										context.vars.map_0,
										context.vars.key_1,
										context.vars.update_5,
									),
								]);
							},
						},
						{
							match: Type.atom("pop"),
							guards: [],
							body: (context) => {
								return Type.tuple([
									context.vars.current_3,
									Elixir_Map["delete/2"](
										context.vars.map_0,
										context.vars.key_1,
									),
								]);
							},
						},
						{
							match: Type.variablePattern("other_6"),
							guards: [],
							body: (context) => {
								return Erlang["error/3"](
									Elixir_RuntimeError["exception/1"](
										Type.bitstring([
											Type.bitstringSegment(
												Type.string(
													"the given function must return a two-element tuple or :pop, got: ",
												),
												{ type: "binary" },
											),
											Type.bitstringSegment(
												Elixir_Kernel["inspect/1"](context.vars.other_6),
												{ type: "binary" },
											),
										]),
									),
									Type.atom("none"),
									Type.list([
										Type.tuple([
											Type.atom("error_info"),
											Type.map([
												[Type.atom("module"), Type.atom("Elixir.Exception")],
											]),
										]),
									]),
								);
							},
						},
					],
					context,
				);
			},
		},
	]);

	Interpreter.defineElixirFunction("Map", "put", 3, "public", [
		{
			params: (context) => [
				Type.variablePattern("map_0"),
				Type.variablePattern("key_1"),
				Type.variablePattern("value_2"),
			],
			guards: [],
			body: (context) => {
				return Erlang_Maps["put/3"](
					context.vars.key_1,
					context.vars.value_2,
					context.vars.map_0,
				);
			},
		},
	]);
};

globalThis.hologram.pageScriptLoaded = true;
document.dispatchEvent(new CustomEvent("hologram:pageScriptLoaded"));

console.debug("Hologram: page script executed");
